export const organizationsHeaderMock = {
  "lastUpdate": "2025-11-24T02:49:00.054Z",
  "organizationsCount": 50845,
  "enrichedOrganizationsCount": 2461
};

export const totalTreasuryMock = {
  "graph": {
    "name": "Total treasury value",
    "data": {
      "totalAum": 13614351767.20324,
      "changeWeek": -1545418323.4166965,
      "changeMonth": -6563790399.784576
    }
  },
  "treasuryGraph": [
    {
      "aum": 16011903009.621624,
      "month": "2025-11"
    },
    {
      "aum": 20822159841.902195,
      "month": "2025-10"
    },
    {
      "aum": 21126774677.517433,
      "month": "2025-09"
    },
    {
      "aum": 21793603933.91609,
      "month": "2025-08"
    },
    {
      "aum": 18383045270.224266,
      "month": "2025-07"
    },
    {
      "aum": 16072970752.585577,
      "month": "2025-06"
    },
    {
      "aum": 17592049378.412148,
      "month": "2025-05"
    },
    {
      "aum": 15620717494.677845,
      "month": "2025-04"
    },
    {
      "aum": 19123737618.23901,
      "month": "2025-03"
    },
    {
      "aum": 23470232044.284454,
      "month": "2025-02"
    },
    {
      "aum": 32992675528.702023,
      "month": "2025-01"
    },
    {
      "aum": 37623555934.47963,
      "month": "2024-12"
    },
    {
      "aum": 26031460472.83535,
      "month": "2024-11"
    },
    {
      "aum": 23662991692.771282,
      "month": "2024-10"
    },
    {
      "aum": 21156773086.553104,
      "month": "2024-09"
    },
    {
      "aum": 20432805272.552135,
      "month": "2024-08"
    },
    {
      "aum": 24961204572.52353,
      "month": "2024-07"
    },
    {
      "aum": 29566640050.91545,
      "month": "2024-06"
    },
    {
      "aum": 31815188928.236668,
      "month": "2024-05"
    },
    {
      "aum": 35012930709.48169,
      "month": "2024-04"
    },
    {
      "aum": 42507443673.52114,
      "month": "2024-03"
    },
    {
      "aum": 34857344348.14796,
      "month": "2024-02"
    },
    {
      "aum": 31429294263.08397,
      "month": "2024-01"
    },
    {
      "aum": 26050917746.462402,
      "month": "2023-12"
    },
    {
      "aum": 20973070833.73421,
      "month": "2023-11"
    },
    {
      "aum": 17201260843.713825,
      "month": "2023-10"
    },
    {
      "aum": 17989057272.50071,
      "month": "2023-09"
    },
    {
      "aum": 21282562532.75954,
      "month": "2023-08"
    },
    {
      "aum": 21839699707.167263,
      "month": "2023-07"
    },
    {
      "aum": 20110611000.255627,
      "month": "2023-06"
    },
    {
      "aum": 22270292011.650238,
      "month": "2023-05"
    },
    {
      "aum": 25509334921.02745,
      "month": "2023-04"
    },
    {
      "aum": 14529810604.503351,
      "month": "2023-03"
    },
    {
      "aum": 12975564571.228119,
      "month": "2023-02"
    },
    {
      "aum": 10669656138.799847,
      "month": "2023-01"
    },
    {
      "aum": 9158756020.023508,
      "month": "2022-12"
    },
    {
      "aum": 9448028711.08946,
      "month": "2022-11"
    },
    {
      "aum": 10374636418.137226,
      "month": "2022-10"
    },
    {
      "aum": 9853728126.823471,
      "month": "2022-09"
    },
    {
      "aum": 10893175457.570967,
      "month": "2022-08"
    },
    {
      "aum": 9137082615.454124,
      "month": "2022-07"
    },
    {
      "aum": 8490385146.501428,
      "month": "2022-06"
    },
    {
      "aum": 10318112198.97574,
      "month": "2022-05"
    },
    {
      "aum": 11298495317.011671,
      "month": "2022-04"
    },
    {
      "aum": 9761084651.788399,
      "month": "2022-03"
    },
    {
      "aum": 9154461506.900148,
      "month": "2022-02"
    },
    {
      "aum": 11486109684.895596,
      "month": "2022-01"
    },
    {
      "aum": 12429817037.896982,
      "month": "2021-12"
    },
    {
      "aum": 13242551280.441986,
      "month": "2021-11"
    },
    {
      "aum": 11556635444.34117,
      "month": "2021-10"
    },
    {
      "aum": 7937690609.901417,
      "month": "2021-09"
    },
    {
      "aum": 8543585611.931345,
      "month": "2021-08"
    },
    {
      "aum": 1499486940.5775757,
      "month": "2021-07"
    },
    {
      "aum": 607297951.0478216,
      "month": "2021-06"
    },
    {
      "aum": 926116122.1214279,
      "month": "2021-05"
    },
    {
      "aum": 952323544.7884331,
      "month": "2021-04"
    },
    {
      "aum": 835560231.2364606,
      "month": "2021-03"
    },
    {
      "aum": 924426517.8709579,
      "month": "2021-02"
    },
    {
      "aum": 520696181.9126001,
      "month": "2021-01"
    },
    {
      "aum": 363730157.33640754,
      "month": "2020-12"
    }
  ],
  "aum": [
    {
      "name": "Liquid",
      "value": 12250391827.69
    },
    {
      "name": "Vesting",
      "value": 1363959939.51
    },
    {
      "name": "Protocol Funds",
      "value": 2638063539.25
    },
    {
      "name": "Private Funds",
      "value": 1276916114.29
    },
    {
      "name": "Project Funds",
      "value": 377182054.98
    }
  ]
};

export const orgsOverThresholdMock = {
  "graph": {
    "name": "Orgs over threshold - active members",
    "data": {
      "totalOrganizations": 52289,
      "tokenHolders": 11819317,
      "over100": 451,
      "over1k": 337,
      "over10k": 153
    }
  }
}

export const orgsOverThresholdAumMock = {
  "graph": {
    "name": "Orgs. over threshold AUM",
    "data": {
      "totalOrganizations": 2461,
      "totalAum": 13614378943.888885,
      "over1m": 183,
      "over10m": 73,
      "over100m": 19
    }
  }
};

export const potentialVotersMock = {
  "graph": {
    "name": "Potential voters",
    "data": {
      "totalTokenHolders": 11819317,
      "changeWeek": 0,
      "changeMonth": 0
    }
  }
};

export const activeMembersMock = {
  "graph": {
    "name": "Active members",
    "data": {
      "activeTokenHolders": 3318740,
      "changeWeek": 360,
      "changeMonth": 1509
    }
  }
};

export const orgCategoriesMock = {
  "data": [
    {
      "id": "9137eb61-ce09-4391-aa22-f23fce0cc662",
      "name": "Art & Culture",
      "description": "Promote Web3 creators, their creations, communities & markets; lead ecosystem ideation, discourse and framing",
      "createdAt": "2021-12-07T12:50:14.312Z"
    },
    {
      "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
      "name": "DAO Tool",
      "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting",
      "createdAt": "2021-12-07T12:50:14.312Z"
    },
    {
      "id": "779d69c2-f9da-4b88-992b-3bceba47a1a4",
      "name": "Data & Analysis",
      "description": "Supply data and analysis of web3 ecosystems & projects",
      "createdAt": "2023-03-01T07:32:30.521Z"
    },
    {
      "id": "e5ce3a6b-5db5-4c6d-bb08-37827620328b",
      "name": "Decentralized Science",
      "description": "Conduct cooperative scientific research utilizing blockchain tools and development",
      "createdAt": "2023-04-18T11:54:26.664Z"
    },
    {
      "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
      "name": "DeFi",
      "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading",
      "createdAt": "2021-12-07T12:50:14.312Z"
    },
    {
      "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
      "name": "Gaming",
      "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets",
      "createdAt": "2021-12-07T12:50:14.312Z"
    },
    {
      "id": "df5e8880-9d6f-412c-adab-d61fc242e0d3",
      "name": "Greater Good / Political",
      "description": "Work to achieve public goods and other goals beyond membership boundaries and immediate interests",
      "createdAt": "2022-04-18T14:03:52.096Z"
    },
    {
      "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
      "name": "Infrastructure",
      "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives",
      "createdAt": "2022-04-18T14:03:52.096Z"
    },
    {
      "id": "b0ec5a90-63b7-4e1f-8a87-5e48cedfd105",
      "name": "Investments",
      "description": "Invest in crypto assets and projects via Web3, from incubation and VC to full acquisitions",
      "createdAt": "2022-04-18T14:03:52.096Z"
    },
    {
      "id": "1c53c9d8-5a64-4e4d-9845-cf3a03976a47",
      "name": "Media & Communications",
      "description": "Build and run platforms and channels for exchange of information & ideas, PR and marketing on Web3",
      "createdAt": "2022-04-18T14:03:52.096Z"
    },
    {
      "id": "1011857f-9223-480d-a67b-5b74890f1111",
      "name": "NFTs",
      "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument",
      "createdAt": "2021-12-07T12:50:14.312Z"
    },
    {
      "id": "84f710d8-5ad0-4996-9f8a-a345d58b1b15",
      "name": "Physical Assets",
      "description": "Create, produce, manage or trade assets and any other things that are not online",
      "createdAt": "2022-04-18T14:03:52.096Z"
    },
    {
      "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
      "name": "Work & Funding",
      "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues",
      "createdAt": "2022-04-18T14:03:52.096Z"
    }
  ]
};

export const dashboardOrgsMock = {
  "currentOrganizationsListPage": 0,
  "isEndOfOrganizationsList": false,
  "daosSummary": [
    {
      "organizationId": "30d12da9-5fd5-411a-8ca8-1422a4ce1373",
      "uniqueKey": "efa63477-4fbc-4122-8591-8d2bd4739ac6",
      "daoName": "Mantle (formerly: BitDAO)",
      "title": "Mantle (formerly: BitDAO)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/30d12da9-5fd5-411a-8ca8-1422a4ce1373.webp",
      "totalNumMembers": 23678,
      "totalNumProposals": 79,
      "totalNumVotes": 100032,
      "activeMembers": 23280,
      "totalValueUSD": 3232302600,
      "change24hPercentage": 0,
      "change1WeekPercentage": -13.232089,
      "mainTreasuryAddress": "0x78605df79524164911c144801f41e9811b7db73d",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 3118256600,
      "tokens": [
        {
          "organization_id": "30d12da9-5fd5-411a-8ca8-1422a4ce1373",
          "token_address": "0x3c3a81e81dc49a522a592e7622a7e711c06bf354",
          "token_symbol": "MNT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BIT.webp",
          "token_value": 3.3090112273232615e+27,
          "token_price": 1.032688888888889,
          "created_at": "2025-11-24T02:18:32.035555",
          "usd_value": 3417214414.3943276
        },
        {
          "organization_id": "30d12da9-5fd5-411a-8ca8-1422a4ce1373",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 8.789071821680831e+22,
          "token_price": 2862.023125,
          "created_at": "2025-11-24T02:18:32.035555",
          "usd_value": 251562087.98771125
        },
        {
          "organization_id": "30d12da9-5fd5-411a-8ca8-1422a4ce1373",
          "token_address": "0x1a4b46696b2bb4794eb3d4c26f1c55f9170fa4c5",
          "token_symbol": "BIT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BIT.webp",
          "token_value": 1.0546982561957048e+26,
          "token_price": 1.0231837043655128,
          "created_at": "2025-11-24T02:18:32.035555",
          "usd_value": 107915006.87621678
        },
        {
          "organization_id": "30d12da9-5fd5-411a-8ca8-1422a4ce1373",
          "token_address": "0xda5e1988097297dcdc1f90d4dfe7909e847cbef6",
          "token_symbol": "WLFI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WLFI.webp",
          "token_value": 2e+26,
          "token_price": 0.16631455492609343,
          "created_at": "2025-11-24T02:18:32.035555",
          "usd_value": 33262910.985218685
        },
        {
          "organization_id": "30d12da9-5fd5-411a-8ca8-1422a4ce1373",
          "token_address": "mnt",
          "token_symbol": "MNT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MNT.webp",
          "token_value": 2.234327349818764e+25,
          "token_price": 1.0319788181818181,
          "created_at": "2025-11-24T02:18:32.035555",
          "usd_value": 23063567.71091395
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "b0ec5a90-63b7-4e1f-8a87-5e48cedfd105",
          "title": "Investments",
          "description": "Invest in crypto assets and projects via Web3, from incubation and VC to full acquisitions"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 3232302550.49
        },
        "private": {
          "name": "private",
          "value": 87663242.02
        },
        "project": {
          "name": "project",
          "value": 33564797.54
        },
        "protocol": {
          "name": "protocol",
          "value": 1302166430.82
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
      "uniqueKey": "06afd916-20f7-47b3-9cd7-ccf3ba67e778",
      "daoName": "Uniswap",
      "title": "Uniswap",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28.webp",
      "totalNumMembers": 365025,
      "totalNumProposals": 281,
      "totalNumVotes": 367466,
      "activeMembers": 37930,
      "totalValueUSD": 2357706000,
      "change24hPercentage": 0,
      "change1WeekPercentage": -12.714028,
      "mainTreasuryAddress": "0x1a9c8182c09f50c8318d769245bea52c32be35bc",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 2354547000,
      "tokens": [
        {
          "organization_id": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
          "token_address": "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
          "token_symbol": "UNI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI.webp",
          "token_value": 3.825429487935134e+26,
          "token_price": 6.317549421804709,
          "created_at": "2025-11-24T02:19:51.879464",
          "usd_value": 2416733984.965928
        },
        {
          "organization_id": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 7.5147894925075e+23,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:19:51.879464",
          "usd_value": 751403.8013558249
        },
        {
          "organization_id": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 229734004306686200000,
          "token_price": 2862.73,
          "created_at": "2025-11-24T02:19:51.879464",
          "usd_value": 657668.8235570979
        },
        {
          "organization_id": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 208459647882,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:19:51.879464",
          "usd_value": 208501.3481516303
        },
        {
          "organization_id": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
          "token_address": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "token_symbol": "SYND",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "token_value": 2e+23,
          "token_price": 0.108765,
          "created_at": "2025-11-24T02:19:51.879464",
          "usd_value": 21752.999999999996
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 2357705853.32
        },
        "protocol": {
          "name": "protocol",
          "value": 79809620.93
        },
        "vesting": {
          "name": "vesting",
          "value": 2.81
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
      "uniqueKey": "80cee7e3-df25-4c6f-9971-fa0adc44a34e",
      "daoName": "ENS DAO",
      "title": "ENS DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/228c8be1-9d1e-440c-8afb-a40d6ee480f2.webp",
      "totalNumMembers": 65305,
      "totalNumProposals": 149,
      "totalNumVotes": 133393,
      "activeMembers": 89442,
      "totalValueUSD": 819205950,
      "change24hPercentage": 0,
      "change1WeekPercentage": -11.087044,
      "mainTreasuryAddress": "0xd7a029db2585553978190db5e85ec724aa4df23f",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 522637500,
      "tokens": [
        {
          "organization_id": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
          "token_address": "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
          "token_symbol": "ENS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ENS.webp",
          "token_value": 6.217771001821514e+25,
          "token_price": 11.09,
          "created_at": "2025-11-24T02:05:14.759397",
          "usd_value": 689550804.1020058
        },
        {
          "organization_id": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 4.444803957349639e+21,
          "token_price": 2836.06,
          "created_at": "2025-11-24T02:05:14.759397",
          "usd_value": 12595121.641822338
        },
        {
          "organization_id": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 3301837704778,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:05:14.759397",
          "usd_value": 3302828.553344003
        },
        {
          "organization_id": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 29586004587566027000,
          "token_price": 2835.436,
          "created_at": "2025-11-24T02:05:14.759397",
          "usd_value": 83929.18447535325
        },
        {
          "organization_id": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
          "token_address": "0x514910771af9ca656af840dff83e8264ecf986ca",
          "token_symbol": "LINK",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LINK.webp",
          "token_value": 4.16323001e+21,
          "token_price": 12.664983449544572,
          "created_at": "2025-11-24T02:05:14.759397",
          "usd_value": 52727.23917329728
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 296568439.79
        },
        "vesting": {
          "name": "vesting",
          "value": 522637489.32
        }
      },
      "isPremium": true,
      "isDefaultPremium": true
    },
    {
      "organizationId": "529571a8-5816-47ff-a50e-1e6372e2324b",
      "uniqueKey": "b3a15e32-5088-4c40-a6f1-af7d660b76d5",
      "daoName": "GnosisDAO",
      "title": "GnosisDAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/529571a8-5816-47ff-a50e-1e6372e2324b.webp",
      "totalNumMembers": 20202,
      "totalNumProposals": 270,
      "totalNumVotes": 47122,
      "activeMembers": 6076,
      "totalValueUSD": 714234700,
      "change24hPercentage": 0,
      "change1WeekPercentage": 2.7378275,
      "mainTreasuryAddress": "0x849d52316331967b6ff1198e5e32a0eb168d039d",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 83424360,
      "tokens": [
        {
          "organization_id": "529571a8-5816-47ff-a50e-1e6372e2324b",
          "token_address": "0x6810e776880c02933d47db1b9fc05908e5386b96",
          "token_symbol": "GNO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GNO.webp",
          "token_value": 4.249339802017194e+24,
          "token_price": 130.92,
          "created_at": "2025-11-24T02:29:35.055568",
          "usd_value": 556323566.880091
        },
        {
          "organization_id": "529571a8-5816-47ff-a50e-1e6372e2324b",
          "token_address": "0x9c58bacc331c9aa871afd802db6379a98e80cedb",
          "token_symbol": "GNO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GNO.webp",
          "token_value": 1.0659889397529268e+24,
          "token_price": 131.43418186021395,
          "created_at": "2025-11-24T02:29:35.055568",
          "usd_value": 140107384.16846284
        },
        {
          "organization_id": "529571a8-5816-47ff-a50e-1e6372e2324b",
          "token_address": "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
          "token_symbol": "COW",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/COW.webp",
          "token_value": 4.72024511181988e+25,
          "token_price": 0.1672,
          "created_at": "2025-11-24T02:29:35.055568",
          "usd_value": 7892249.826962839
        },
        {
          "organization_id": "529571a8-5816-47ff-a50e-1e6372e2324b",
          "token_address": "0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 1.4558217546548817e+21,
          "token_price": 2855.24,
          "created_at": "2025-11-24T02:29:35.055568",
          "usd_value": 4156720.506760804
        },
        {
          "organization_id": "529571a8-5816-47ff-a50e-1e6372e2324b",
          "token_address": "0x6c76971f98945ae98dd7d4dfca8711ebea946ea6",
          "token_symbol": "wstETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WSTETH.webp",
          "token_value": 637835428144090800000,
          "token_price": 3488.949281024168,
          "created_at": "2025-11-24T02:29:35.055568",
          "usd_value": 2225375.4584350684
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 209896948.1
        },
        "private": {
          "name": "private",
          "value": 44308439.87
        },
        "protocol": {
          "name": "protocol",
          "value": 29676.65
        },
        "vesting": {
          "name": "vesting",
          "value": 504337736.31
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "c0dd1775-1e51-41a0-ae93-bfefb4835358",
      "uniqueKey": "63d9f549-3418-4846-b7bd-b27bfa81da75",
      "daoName": "Ethereum Foundation",
      "title": "Ethereum Foundation",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/c0dd1775-1e51-41a0-ae93-bfefb4835358.webp",
      "totalNumMembers": null,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 683228740,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x9ee457023bb3de16d51a003a247baead7fce313d",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 541121.44,
      "tokens": [
        {
          "organization_id": "c0dd1775-1e51-41a0-ae93-bfefb4835358",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1.7285797288307066e+23,
          "token_price": 3945.62,
          "created_at": "2025-10-20T02:24:46.579461",
          "usd_value": 682042236.4188019
        },
        {
          "organization_id": "c0dd1775-1e51-41a0-ae93-bfefb4835358",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 214140968221600000000,
          "token_price": 3945.62,
          "created_at": "2025-10-20T02:24:46.579461",
          "usd_value": 844931.7354925906
        },
        {
          "organization_id": "c0dd1775-1e51-41a0-ae93-bfefb4835358",
          "token_address": "op",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 33091010167760945000,
          "token_price": 3945.68,
          "created_at": "2025-10-20T02:24:46.579461",
          "usd_value": 130566.536998731
        },
        {
          "organization_id": "c0dd1775-1e51-41a0-ae93-bfefb4835358",
          "token_address": "0xb8c77482e45f1f44de1745f52c74426c631bdd52",
          "token_symbol": "BNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNB.webp",
          "token_value": 42100000000000000000,
          "token_price": 1588.0667328343372,
          "created_at": "2025-10-20T02:24:46.579461",
          "usd_value": 66857.6094523256
        },
        {
          "organization_id": "c0dd1775-1e51-41a0-ae93-bfefb4835358",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 30579196487,
          "token_price": 0.9997000899730081,
          "created_at": "2025-10-20T02:24:46.579461",
          "usd_value": 30570.02547935619
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "df5e8880-9d6f-412c-adab-d61fc242e0d3",
          "title": "Greater Good / Political",
          "description": "Work to achieve public goods and other goals beyond membership boundaries and immediate interests"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 683228744.19
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b29f3be3-d4c7-4401-92cd-73390f09816b",
      "uniqueKey": "e5c81e41-fac6-4ebc-8031-e3c6096d812f",
      "daoName": "Arbitrum",
      "title": "Arbitrum",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b29f3be3-d4c7-4401-92cd-73390f09816b.webp",
      "totalNumMembers": 1166779,
      "totalNumProposals": 499,
      "totalNumVotes": 6140083,
      "activeMembers": 330455,
      "totalValueUSD": 622736200,
      "change24hPercentage": 0,
      "change1WeekPercentage": -13.279307,
      "mainTreasuryAddress": "0x34d45e99f7d8c45ed05b5ca72d54bbd1fb3f98f0",
      "mainTreasuryTitle": "Arbitrum",
      "mainTreasuryAum": 19.697546,
      "tokens": [
        {
          "organization_id": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "token_address": "0x912ce59144191c1204e64559fe8253a0e49e6548",
          "token_symbol": "ARB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ARB.webp",
          "token_value": 2.961934884701388e+27,
          "token_price": 0.20614,
          "created_at": "2025-11-24T02:12:48.070947",
          "usd_value": 610454779.7369561
        },
        {
          "organization_id": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "token_address": "arb",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 2.4975183057256616e+21,
          "token_price": 2855.053,
          "created_at": "2025-11-24T02:12:48.070947",
          "usd_value": 7129840.050787973
        },
        {
          "organization_id": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "token_address": "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 1.6945329752140934e+21,
          "token_price": 2852.5,
          "created_at": "2025-11-24T02:12:48.070947",
          "usd_value": 4833655.311798201
        },
        {
          "organization_id": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 211611456283895800000,
          "token_price": 2854.4216666666666,
          "created_at": "2025-11-24T02:12:48.070947",
          "usd_value": 603994.4153361191
        },
        {
          "organization_id": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "token_address": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 123193010000,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:12:48.070947",
          "usd_value": 123229.97899369811
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/arbitrum.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 570122975.96
        },
        "project": {
          "name": "project",
          "value": 72699.26
        },
        "protocol": {
          "name": "protocol",
          "value": 379486.09
        },
        "vesting": {
          "name": "vesting",
          "value": 52613211.69
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
      "uniqueKey": "fbf3e4b5-48a3-4008-9e3e-d7d0e60f4805",
      "daoName": "Optimism",
      "title": "Optimism",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/10edb97a-9dba-448a-88b1-ca263a7c75ad.webp",
      "totalNumMembers": null,
      "totalNumProposals": 223,
      "totalNumVotes": 2209506,
      "activeMembers": 188921,
      "totalValueUSD": 574293500,
      "change24hPercentage": 0,
      "change1WeekPercentage": -20.173409,
      "mainTreasuryAddress": "0x2501c477d0a35545a387aa4a3eee4292a9a8b3f0",
      "mainTreasuryTitle": "Optimism",
      "mainTreasuryAum": 175598180,
      "tokens": [
        {
          "organization_id": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
          "token_address": "0x4200000000000000000000000000000000000042",
          "token_symbol": "OP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/optimism-token.png",
          "token_value": 1.8858097204137382e+27,
          "token_price": 0.30815,
          "created_at": "2025-11-24T02:42:58.594985",
          "usd_value": 581074949.9775311
        },
        {
          "organization_id": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
          "token_address": "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 14284833598,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:42:58.594985",
          "usd_value": 14289.120334100227
        },
        {
          "organization_id": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
          "token_address": "op",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 744381446227336600,
          "token_price": 2843.73,
          "created_at": "2025-11-24T02:42:58.594985",
          "usd_value": 2116.819850080064
        },
        {
          "organization_id": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 143735972108306320,
          "token_price": 2843.73,
          "created_at": "2025-11-24T02:42:58.594985",
          "usd_value": 408.74629596355396
        },
        {
          "organization_id": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
          "token_address": "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 5000001,
          "token_price": 0.99981,
          "created_at": "2025-11-24T02:42:58.594985",
          "usd_value": 4.99905099981
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/optimism.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 574293500.71
        },
        "project": {
          "name": "project",
          "value": 6798269.5
        }
      },
      "isPremium": true,
      "isDefaultPremium": true
    },
    {
      "organizationId": "c41f87df-35a6-4a37-82c4-62cd5a3a8c08",
      "uniqueKey": "eff8e95b-c7a7-49fa-add4-7fa39faff198",
      "daoName": "Sky (fka: MakerDAO)",
      "title": "Sky (fka: MakerDAO)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/c41f87df-35a6-4a37-82c4-62cd5a3a8c08.webp",
      "totalNumMembers": 101107,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 375691460,
      "change24hPercentage": 0,
      "change1WeekPercentage": -12.100717,
      "mainTreasuryAddress": "0x2cccc4b4708b318a6290511aac75d6c3dbe0cf9f",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 75.119,
      "tokens": [
        {
          "organization_id": "c41f87df-35a6-4a37-82c4-62cd5a3a8c08",
          "token_address": "0xdc035d45d973e3ec169d2276ddab16f1e407384f",
          "token_symbol": "USDS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDS.webp",
          "token_value": 1.778590028082465e+26,
          "token_price": 1,
          "created_at": "2025-11-24T02:06:23.483558",
          "usd_value": 177859002.8082465
        },
        {
          "organization_id": "c41f87df-35a6-4a37-82c4-62cd5a3a8c08",
          "token_address": "0xc20059e0317de91738d13af027dfc4a50781b066",
          "token_symbol": "SPK",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SPK.webp",
          "token_value": 5.820519405490209e+27,
          "token_price": 0.02949,
          "created_at": "2025-11-24T02:06:23.483558",
          "usd_value": 171647117.26790628
        },
        {
          "organization_id": "c41f87df-35a6-4a37-82c4-62cd5a3a8c08",
          "token_address": "0x56072c95faa701256059aa122697b133aded9279",
          "token_symbol": "SKY",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SKY.webp",
          "token_value": 6.676733652482251e+26,
          "token_price": 0.043610813803052074,
          "created_at": "2025-11-24T02:06:23.483558",
          "usd_value": 29117778.813097518
        },
        {
          "organization_id": "c41f87df-35a6-4a37-82c4-62cd5a3a8c08",
          "token_address": "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
          "token_symbol": "MKR",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MKR.webp",
          "token_value": 1.2637308993800004e+22,
          "token_price": 1032,
          "created_at": "2025-11-24T02:06:23.483558",
          "usd_value": 13041702.881601604
        },
        {
          "organization_id": "c41f87df-35a6-4a37-82c4-62cd5a3a8c08",
          "token_address": "0xadf7c35560035944e805d98ff17d58cde2449389",
          "token_symbol": "SPEC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SPEC.webp",
          "token_value": 2.15451e+23,
          "token_price": 0.189755604564708,
          "created_at": "2025-11-24T02:06:23.483558",
          "usd_value": 40883.034759070906
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 375691468.7
        },
        "protocol": {
          "name": "protocol",
          "value": 180172560.81
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "d7eab985-c59e-4c44-9d87-00a2b87c900a",
      "uniqueKey": "7dc97dca-10a9-4224-9232-28c0124e00bb",
      "daoName": "DeXe Protocol DAO",
      "title": "DeXe Protocol DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d7eab985-c59e-4c44-9d87-00a2b87c900a.webp",
      "totalNumMembers": 2504,
      "totalNumProposals": 27,
      "totalNumVotes": 131,
      "activeMembers": 55,
      "totalValueUSD": 287618820,
      "change24hPercentage": 0,
      "change1WeekPercentage": -17.851095,
      "mainTreasuryAddress": "0xde4ee8057785a7e8e800db58f9784845a5c2cbd6",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 58186636,
      "tokens": [
        {
          "organization_id": "d7eab985-c59e-4c44-9d87-00a2b87c900a",
          "token_address": "0xde4ee8057785a7e8e800db58f9784845a5c2cbd6",
          "token_symbol": "DEXE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DEXE.webp",
          "token_value": 6.715759956245271e+25,
          "token_price": 4.555666666666666,
          "created_at": "2025-11-24T02:09:19.99148",
          "usd_value": 305964128.3371061
        },
        {
          "organization_id": "d7eab985-c59e-4c44-9d87-00a2b87c900a",
          "token_address": "0x6e88056e8376ae7709496ba64d37fa2f8015ce3e",
          "token_symbol": "DEXE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/dexe.png",
          "token_value": 1.8788380689970617e+25,
          "token_price": 4.5555,
          "created_at": "2025-11-24T02:09:19.99148",
          "usd_value": 85582412.70329675
        },
        {
          "organization_id": "d7eab985-c59e-4c44-9d87-00a2b87c900a",
          "token_address": "0xe9e7cea3dedca5984780bafc599bd69add087d56",
          "token_symbol": "BUSD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BUSD.webp",
          "token_value": 1.071601e+21,
          "token_price": 1.00050348822242,
          "created_at": "2025-11-24T02:09:19.99148",
          "usd_value": 1072.1405384826332
        },
        {
          "organization_id": "d7eab985-c59e-4c44-9d87-00a2b87c900a",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 605479694,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:09:19.99148",
          "usd_value": 605.37676245202
        },
        {
          "organization_id": "d7eab985-c59e-4c44-9d87-00a2b87c900a",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 230817404,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:09:19.99148",
          "usd_value": 230.88667000100028
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 229432190.12
        },
        "protocol": {
          "name": "protocol",
          "value": 104313499.41
        },
        "vesting": {
          "name": "vesting",
          "value": 58186635.06
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "996e1469-01d7-4e94-b18a-c7c970b8c1ec",
      "uniqueKey": "9d803ccb-3096-416c-8937-08d9c817411b",
      "daoName": "Tribe DAO / Fei",
      "title": "Tribe DAO / Fei",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/2e1DDx1a_400x400.jpg",
      "totalNumMembers": 13897,
      "totalNumProposals": 161,
      "totalNumVotes": 15101,
      "activeMembers": 5104,
      "totalValueUSD": 253531170,
      "change24hPercentage": 0,
      "change1WeekPercentage": -3.8744583,
      "mainTreasuryAddress": "0x639572471f2f318464dc01066a56867130e45e25",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 498.4,
      "tokens": [
        {
          "organization_id": "996e1469-01d7-4e94-b18a-c7c970b8c1ec",
          "token_address": "0xc7283b66eb1eb5fb86327f08e1b5816b0720212b",
          "token_symbol": "TRIBE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TRIBE.webp",
          "token_value": 5.304617022401424e+26,
          "token_price": 0.4771214355415148,
          "created_at": "2025-11-24T02:05:27.208132",
          "usd_value": 253520885.20710745
        },
        {
          "organization_id": "996e1469-01d7-4e94-b18a-c7c970b8c1ec",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 514002636414986940,
          "token_price": 2839.065,
          "created_at": "2025-11-24T02:05:27.208132",
          "usd_value": 1459.3194278933215
        },
        {
          "organization_id": "996e1469-01d7-4e94-b18a-c7c970b8c1ec",
          "token_address": "0x5afe3855358e112b5647b952709e6165e1c1eeee",
          "token_symbol": "SAFE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "token_value": 6.490057291151977e+21,
          "token_price": 0.1513,
          "created_at": "2025-11-24T02:05:27.208132",
          "usd_value": 981.9456681512941
        },
        {
          "organization_id": "996e1469-01d7-4e94-b18a-c7c970b8c1ec",
          "token_address": "0xa6610ed604047e7b76c1da288172d15bcda57596",
          "token_symbol": "SACKS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SACKS.webp",
          "token_value": 1447602429722649000,
          "token_price": 532.5784321368998,
          "created_at": "2025-11-24T02:05:27.208132",
          "usd_value": 770.961832379255
        },
        {
          "organization_id": "996e1469-01d7-4e94-b18a-c7c970b8c1ec",
          "token_address": "0x956f47f50a910163d8bf957cf5846d573e7f87ca",
          "token_symbol": "FEI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/FEI.webp",
          "token_value": 500000000000000000000,
          "token_price": 0.9968,
          "created_at": "2025-11-24T02:05:27.208132",
          "usd_value": 498.40000000000003
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 252804732.98
        },
        "vesting": {
          "name": "vesting",
          "value": 726429.71
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "fd991dca-141d-4e23-a23b-5d908110c337",
      "uniqueKey": "b5087ff9-736a-4dab-9093-7424578540f3",
      "daoName": "Lido",
      "title": "Lido",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/fd991dca-141d-4e23-a23b-5d908110c337.webp",
      "totalNumMembers": 53072,
      "totalNumProposals": 704,
      "totalNumVotes": 85286,
      "activeMembers": 6701,
      "totalValueUSD": 220467120,
      "change24hPercentage": 0,
      "change1WeekPercentage": -9.482538,
      "mainTreasuryAddress": "0x8c2b8595ea1b627427efe4f29a64b145df439d16",
      "mainTreasuryTitle": "Arbitrum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "fd991dca-141d-4e23-a23b-5d908110c337",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 4.752564327740996e+22,
          "token_price": 2862.46,
          "created_at": "2025-11-24T02:20:36.009598",
          "usd_value": 136021246.04413903
        },
        {
          "organization_id": "fd991dca-141d-4e23-a23b-5d908110c337",
          "token_address": "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
          "token_symbol": "LDO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LDO.webp",
          "token_value": 1.0952388709621486e+26,
          "token_price": 0.6374327862949414,
          "created_at": "2025-11-24T02:20:36.009598",
          "usd_value": 69794533.4446721
        },
        {
          "organization_id": "fd991dca-141d-4e23-a23b-5d908110c337",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 1.2413378745452434e+25,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:20:36.009598",
          "usd_value": 12412137.407577885
        },
        {
          "organization_id": "fd991dca-141d-4e23-a23b-5d908110c337",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 11911036786697,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:20:36.009598",
          "usd_value": 11909011.910443261
        },
        {
          "organization_id": "fd991dca-141d-4e23-a23b-5d908110c337",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 7581478666949,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:20:36.009598",
          "usd_value": 7582995.2660022
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/arbitrum.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 220467122.64
        },
        "private": {
          "name": "private",
          "value": 215486221.18
        },
        "protocol": {
          "name": "protocol",
          "value": 75608.88
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "7fddc664-12d8-4096-b915-936997afd592",
      "uniqueKey": "ca8c8893-d54c-4739-aa43-a616bee9be94",
      "daoName": "The Graph",
      "title": "The Graph",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1688397465044TheGraph",
      "totalNumMembers": 171237,
      "totalNumProposals": 64,
      "totalNumVotes": 1532,
      "activeMembers": 787,
      "totalValueUSD": 189836160,
      "change24hPercentage": 0,
      "change1WeekPercentage": -10.7771015,
      "mainTreasuryAddress": "0x32ec7a59549b9f114c9d7d8b21891d91ae7f2ca1",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 40041668,
      "tokens": [
        {
          "organization_id": "7fddc664-12d8-4096-b915-936997afd592",
          "token_address": "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
          "token_symbol": "GRT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GRT.webp",
          "token_value": 3.986084544005381e+27,
          "token_price": 0.05,
          "created_at": "2025-11-24T02:08:19.51214",
          "usd_value": 199304227.20026907
        },
        {
          "organization_id": "7fddc664-12d8-4096-b915-936997afd592",
          "token_address": "0x9623063377ad1b27544c965ccd7342f7ea7e88c7",
          "token_symbol": "GRT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GRT.webp",
          "token_value": 2.310223838341288e+27,
          "token_price": 0.05008,
          "created_at": "2025-11-24T02:08:19.51214",
          "usd_value": 115696009.82413171
        },
        {
          "organization_id": "7fddc664-12d8-4096-b915-936997afd592",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 2293718178152590000,
          "token_price": 2847.032,
          "created_at": "2025-11-24T02:08:19.51214",
          "usd_value": 6530.279680847958
        },
        {
          "organization_id": "7fddc664-12d8-4096-b915-936997afd592",
          "token_address": "0x5afe3855358e112b5647b952709e6165e1c1eeee",
          "token_symbol": "SAFE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "token_value": 8.775360226930051e+21,
          "token_price": 0.1513,
          "created_at": "2025-11-24T02:08:19.51214",
          "usd_value": 1327.7120023345165
        },
        {
          "organization_id": "7fddc664-12d8-4096-b915-936997afd592",
          "token_address": "0x4200000000000000000000000000000000000042",
          "token_symbol": "OP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/optimism-token.png",
          "token_value": 2.380535404285558e+21,
          "token_price": 0.307,
          "created_at": "2025-11-24T02:08:19.51214",
          "usd_value": 730.8243691156663
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "779d69c2-f9da-4b88-992b-3bceba47a1a4",
          "title": "Data & Analysis",
          "description": "Supply data and analysis of web3 ecosystems & projects"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 149189967.18
        },
        "private": {
          "name": "private",
          "value": 125169098.68
        },
        "protocol": {
          "name": "protocol",
          "value": 368.34
        },
        "vesting": {
          "name": "vesting",
          "value": 40646198.56
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "34e49a9f-34e2-477b-9c4f-914f8bc48aa7",
      "uniqueKey": "e785bbd2-b64d-4038-884b-9dfc640027f1",
      "daoName": "ResearchHub Foundation",
      "title": "ResearchHub Foundation",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/34e49a9f-34e2-477b-9c4f-914f8bc48aa7.webp",
      "totalNumMembers": 9295,
      "totalNumProposals": 25,
      "totalNumVotes": 268,
      "activeMembers": 97,
      "totalValueUSD": 177483550,
      "change24hPercentage": 0,
      "change1WeekPercentage": -8.0258255,
      "mainTreasuryAddress": "0x76835ca5ebc7935cedbb1e0aa3d322e704b1b7b1",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 85.11272,
      "tokens": [
        {
          "organization_id": "34e49a9f-34e2-477b-9c4f-914f8bc48aa7",
          "token_address": "0xd101dcc414f310268c37eeb4cd376ccfa507f571",
          "token_symbol": "RSC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RSC.webp",
          "token_value": 7.880061210848545e+26,
          "token_price": 0.22455329445811117,
          "created_at": "2025-11-24T02:06:32.38398",
          "usd_value": 176949370.54276136
        },
        {
          "organization_id": "34e49a9f-34e2-477b-9c4f-914f8bc48aa7",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 187121634194545020000,
          "token_price": 2835.79,
          "created_at": "2025-11-24T02:06:32.38398",
          "usd_value": 530637.6590325488
        },
        {
          "organization_id": "34e49a9f-34e2-477b-9c4f-914f8bc48aa7",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 2818971594,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:06:32.38398",
          "usd_value": 2819.8175392617786
        },
        {
          "organization_id": "34e49a9f-34e2-477b-9c4f-914f8bc48aa7",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 493416932,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:06:32.38398",
          "usd_value": 493.33305112155995
        },
        {
          "organization_id": "34e49a9f-34e2-477b-9c4f-914f8bc48aa7",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 100000000000000000000,
          "token_price": 1,
          "created_at": "2025-11-24T02:06:32.38398",
          "usd_value": 100
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "84f710d8-5ad0-4996-9f8a-a345d58b1b15",
          "title": "Physical Assets",
          "description": "Create, produce, manage or trade assets and any other things that are not online"
        },
        {
          "id": "e5ce3a6b-5db5-4c6d-bb08-37827620328b",
          "title": "Decentralized Science",
          "description": "Conduct cooperative scientific research utilizing blockchain tools and development"
        },
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 177483549.25
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "be5f6bd8-4c65-4e96-b0eb-7e7ce6a64bf2",
      "uniqueKey": "e1a04f10-b699-493a-8068-dfe777e3185a",
      "daoName": "Olympus DAO",
      "title": "Olympus DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/be5f6bd8-4c65-4e96-b0eb-7e7ce6a64bf2.webp",
      "totalNumMembers": 8327,
      "totalNumProposals": 318,
      "totalNumVotes": 51717,
      "activeMembers": 9537,
      "totalValueUSD": 168118850,
      "change24hPercentage": 0,
      "change1WeekPercentage": 0.6127034,
      "mainTreasuryAddress": "0x4c71db02aeeb336cbd8f3d2cc866911f6e2fbd94",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 154183.94,
      "tokens": [
        {
          "organization_id": "be5f6bd8-4c65-4e96-b0eb-7e7ce6a64bf2",
          "token_address": "0x64aa3364f17a4d01c6f1751fd97c2bd3d7e7f1d5",
          "token_symbol": "OHM",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VOTE.webp",
          "token_value": 4910667552725070,
          "token_price": 21.15126457049066,
          "created_at": "2025-11-24T02:17:44.87833",
          "usd_value": 103866828.62541184
        },
        {
          "organization_id": "be5f6bd8-4c65-4e96-b0eb-7e7ce6a64bf2",
          "token_address": "0xdc035d45d973e3ec169d2276ddab16f1e407384f",
          "token_symbol": "USDS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDS.webp",
          "token_value": 1.0962470638660089e+23,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:17:44.87833",
          "usd_value": 109613.74391596223
        },
        {
          "organization_id": "be5f6bd8-4c65-4e96-b0eb-7e7ce6a64bf2",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 12733769590472548000,
          "token_price": 2863.085,
          "created_at": "2025-11-24T02:17:44.87833",
          "usd_value": 36458.92611325131
        },
        {
          "organization_id": "be5f6bd8-4c65-4e96-b0eb-7e7ce6a64bf2",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 2.7515264009506768e+22,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:17:44.87833",
          "usd_value": 27512.51248310582
        },
        {
          "organization_id": "be5f6bd8-4c65-4e96-b0eb-7e7ce6a64bf2",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 12185848943,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:17:44.87833",
          "usd_value": 12188.286600320065
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 168118843.54
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "0d61106a-d18b-49ef-9ced-447dc4886303",
      "uniqueKey": "e7b14257-9f4a-40bd-9dd9-e90d6ed20c27",
      "daoName": "Golem Network",
      "title": "Golem Network",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/0d61106a-d18b-49ef-9ced-447dc4886303.webp",
      "totalNumMembers": 20073,
      "totalNumProposals": 14,
      "totalNumVotes": 1814,
      "activeMembers": 744,
      "totalValueUSD": 157402700,
      "change24hPercentage": 0,
      "change1WeekPercentage": -9.793528,
      "mainTreasuryAddress": "0x7da82c7ab4771ff031b66538d2fb9b0b047f6cf9",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 39128880,
      "tokens": [
        {
          "organization_id": "0d61106a-d18b-49ef-9ced-447dc4886303",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1.375673460341954e+22,
          "token_price": 2833.7066666666665,
          "created_at": "2025-11-24T02:48:11.092533",
          "usd_value": 38981638.75485064
        },
        {
          "organization_id": "0d61106a-d18b-49ef-9ced-447dc4886303",
          "token_address": "0x7dd9c5cba05e151c895fde1cf355c9a1d5da6429",
          "token_symbol": "GLM",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GLM.webp",
          "token_value": 1.34102449582179e+26,
          "token_price": 0.1997,
          "created_at": "2025-11-24T02:48:11.092533",
          "usd_value": 26780259.181561142
        },
        {
          "organization_id": "0d61106a-d18b-49ef-9ced-447dc4886303",
          "token_address": "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
          "token_symbol": "XDATA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XDATA.webp",
          "token_value": 3.980586584573843e+22,
          "token_price": 0.00716808,
          "created_at": "2025-11-24T02:48:11.092533",
          "usd_value": 285.3316308515207
        },
        {
          "organization_id": "0d61106a-d18b-49ef-9ced-447dc4886303",
          "token_address": "0x8344646dd07c325c27ff49198d1345c7d9077d89",
          "token_symbol": "MIMIC",
          "token_decimals": 18,
          "token_icon": null,
          "token_value": 3.00005e+29,
          "token_price": 7.106658824055302e-11,
          "created_at": "2025-11-24T02:48:11.092533",
          "usd_value": 21.320331805107106
        },
        {
          "organization_id": "0d61106a-d18b-49ef-9ced-447dc4886303",
          "token_address": "0xd7d919ea0c33a97ad6e7bd4f510498e2ec98cb78",
          "token_symbol": "PEN",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PEN.webp",
          "token_value": 6.942e+25,
          "token_price": 6.722647520265009e-8,
          "created_at": "2025-11-24T02:48:11.092533",
          "usd_value": 4.666861908567969
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "779d69c2-f9da-4b88-992b-3bceba47a1a4",
          "title": "Data & Analysis",
          "description": "Supply data and analysis of web3 ecosystems & projects"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 157402701.13
        },
        "project": {
          "name": "project",
          "value": 21779086.6
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "9cc495be-6062-4b31-b4f8-424438ec1ed4",
      "uniqueKey": "2b89187d-5510-46ee-8e6b-d402ef9959dd",
      "daoName": "Aave",
      "title": "Aave",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/aave-token-round.png",
      "totalNumMembers": 186091,
      "totalNumProposals": 844,
      "totalNumVotes": 1715701,
      "activeMembers": 74776,
      "totalValueUSD": 154222030,
      "change24hPercentage": 0,
      "change1WeekPercentage": -0.7808326,
      "mainTreasuryAddress": "0x053d55f9b5af8694c503eb288a1b7e552f590710",
      "mainTreasuryTitle": "Arbitrum",
      "mainTreasuryAum": 8051118.5,
      "tokens": [
        {
          "organization_id": "9cc495be-6062-4b31-b4f8-424438ec1ed4",
          "token_address": "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
          "token_symbol": "AAVE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AAVE.webp",
          "token_value": 4.256596816820287e+23,
          "token_price": 169.38929196745553,
          "created_at": "2025-11-24T02:03:17.77416",
          "usd_value": 72102192.09921135
        },
        {
          "organization_id": "9cc495be-6062-4b31-b4f8-424438ec1ed4",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1.0650680588235895e+21,
          "token_price": 2832.6133333333332,
          "created_at": "2025-11-24T02:03:17.77416",
          "usd_value": 3016986.334430647
        },
        {
          "organization_id": "9cc495be-6062-4b31-b4f8-424438ec1ed4",
          "token_address": "0x40d16fc0246ad3160ccc09b8d0d3a2cd28ae6c2f",
          "token_symbol": "GHO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GHO.webp",
          "token_value": 2.2583265838567046e+24,
          "token_price": 0.999444907505056,
          "created_at": "2025-11-24T02:03:17.77416",
          "usd_value": 2257073.003718873
        },
        {
          "organization_id": "9cc495be-6062-4b31-b4f8-424438ec1ed4",
          "token_address": "0x4200000000000000000000000000000000000006",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 195051644042483860000,
          "token_price": 2833.26,
          "created_at": "2025-11-24T02:03:17.77416",
          "usd_value": 552632.0209998079
        },
        {
          "organization_id": "9cc495be-6062-4b31-b4f8-424438ec1ed4",
          "token_address": "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
          "token_symbol": "USDT0",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT0.webp",
          "token_value": 232423778023,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:03:17.77416",
          "usd_value": 232384.2659807361
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/arbitrum.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 154222033.49
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "00cdddf8-87e0-4e3f-9b36-f627133e0b24",
      "uniqueKey": "6b4ac4d4-87ab-4e3c-ae98-2cbcce13edb6",
      "daoName": "Merit Circle",
      "title": "Merit Circle",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/00cdddf8-87e0-4e3f-9b36-f627133e0b24.webp",
      "totalNumMembers": 7181,
      "totalNumProposals": 35,
      "totalNumVotes": 3361,
      "activeMembers": 1178,
      "totalValueUSD": 150002580,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x7e9e4c0876b2102f33a1d82117cc73b7fddd0032",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 150002580,
      "tokens": [
        {
          "organization_id": "00cdddf8-87e0-4e3f-9b36-f627133e0b24",
          "token_address": "0x62d0a8458ed7719fdaf978fe5929c6d342b0bfce",
          "token_symbol": "BEAM",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BEAM.webp",
          "token_value": 6.672683908760503e+27,
          "token_price": 0.017108475379604113,
          "created_at": "2023-12-10T00:13:44.74842",
          "usd_value": 114159448.3689096
        },
        {
          "organization_id": "00cdddf8-87e0-4e3f-9b36-f627133e0b24",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 28825958398261,
          "token_price": 1,
          "created_at": "2023-12-10T00:13:44.74842",
          "usd_value": 28825958.398261
        },
        {
          "organization_id": "00cdddf8-87e0-4e3f-9b36-f627133e0b24",
          "token_address": "0x180efc1349a69390ade25667487a826164c9c6e4",
          "token_symbol": "UNI-V2",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI-V2.webp",
          "token_value": 2.8812962831366652e+23,
          "token_price": 14.364214885270648,
          "created_at": "2023-12-10T00:13:44.74842",
          "usd_value": 4138755.8959106677
        },
        {
          "organization_id": "00cdddf8-87e0-4e3f-9b36-f627133e0b24",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 2644570838500,
          "token_price": 1.000205,
          "created_at": "2023-12-10T00:13:44.74842",
          "usd_value": 2645112.975521893
        },
        {
          "organization_id": "00cdddf8-87e0-4e3f-9b36-f627133e0b24",
          "token_address": "0xeb953eda0dc65e3246f43dc8fa13f35623bdd5ed",
          "token_symbol": "RAINI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RAINI.webp",
          "token_value": 2.345294e+24,
          "token_price": 0.052388476447470037,
          "created_at": "2023-12-10T00:13:44.74842",
          "usd_value": 122866.3794813928
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
          "title": "Gaming",
          "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 150002580.95
        },
        "vesting": {
          "name": "vesting",
          "value": 0
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "9167f93a-a20d-4ad2-b173-2ff178e9e3b8",
      "uniqueKey": "58630741-d859-4963-b9ae-77d7e558d3c0",
      "daoName": "Ondo DAO",
      "title": "Ondo DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/9167f93a-a20d-4ad2-b173-2ff178e9e3b8.webp",
      "totalNumMembers": 83763,
      "totalNumProposals": 9,
      "totalNumVotes": 2167,
      "activeMembers": 1071,
      "totalValueUSD": 142251140,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0xaed4caf2e535d964165b4392342f71bac77e8367",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "9167f93a-a20d-4ad2-b173-2ff178e9e3b8",
          "token_address": "0x7712c34205737192402172409a8f7ccef8aa2aec",
          "token_symbol": "BUIDL",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BUIDL.webp",
          "token_value": 142251086470000,
          "token_price": 1,
          "created_at": "2024-11-18T02:01:12.029768",
          "usd_value": 142251086.47
        },
        {
          "organization_id": "9167f93a-a20d-4ad2-b173-2ff178e9e3b8",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1400646095169262600,
          "token_price": 2243.44,
          "created_at": "2023-09-30T01:03:53.597057",
          "usd_value": 3543.256446332539
        },
        {
          "organization_id": "9167f93a-a20d-4ad2-b173-2ff178e9e3b8",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 44114789,
          "token_price": 0.5030793148324303,
          "created_at": "2024-11-18T02:01:12.029768",
          "usd_value": 44.11016366226246
        },
        {
          "organization_id": "9167f93a-a20d-4ad2-b173-2ff178e9e3b8",
          "token_address": "0x71da932ccda723ba3ab730c976bc66daaf9c598c",
          "token_symbol": "MAG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MAG.webp",
          "token_value": 1.4086489126620936e+21,
          "token_price": 0.0014859744869145212,
          "created_at": "2024-11-18T02:01:12.029768",
          "usd_value": 2.093216345235753
        },
        {
          "organization_id": "9167f93a-a20d-4ad2-b173-2ff178e9e3b8",
          "token_address": "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
          "token_symbol": "GEL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GEL.webp",
          "token_value": 2000000000000000000,
          "token_price": 0.19319086360014273,
          "created_at": "2024-11-18T02:01:12.029768",
          "usd_value": 0.38638172720028546
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "b0ec5a90-63b7-4e1f-8a87-5e48cedfd105",
          "title": "Investments",
          "description": "Invest in crypto assets and projects via Web3, from incubation and VC to full acquisitions"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "779d69c2-f9da-4b88-992b-3bceba47a1a4",
          "title": "Data & Analysis",
          "description": "Supply data and analysis of web3 ecosystems & projects"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 142251133.06
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "5b210f8c-a584-42ab-881a-d7a15c8ab985",
      "uniqueKey": "a6517cd6-3f46-4591-90af-217bfc8d9051",
      "daoName": "Qi DAO | Mai.Finance",
      "title": "Qi DAO | Mai.Finance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/5b210f8c-a584-42ab-881a-d7a15c8ab985.webp",
      "totalNumMembers": 21860,
      "totalNumProposals": 252,
      "totalNumVotes": 74144,
      "activeMembers": 6319,
      "totalValueUSD": 121826410,
      "change24hPercentage": 0,
      "change1WeekPercentage": 0.9609151,
      "mainTreasuryAddress": "0x679016b3f8e98673f85c6f72567f22b58aa15a54",
      "mainTreasuryTitle": "Fantom",
      "mainTreasuryAum": 102174.79,
      "tokens": [
        {
          "organization_id": "5b210f8c-a584-42ab-881a-d7a15c8ab985",
          "token_address": "0xa3fa99a148fa48d14ed51d610c367c61876997f1",
          "token_symbol": "miMATIC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MIMATIC.webp",
          "token_value": 1.1836250290951142e+26,
          "token_price": 1.0069536471746379,
          "created_at": "2025-11-24T02:38:00.185149",
          "usd_value": 119185553.99345121
        },
        {
          "organization_id": "5b210f8c-a584-42ab-881a-d7a15c8ab985",
          "token_address": "0x559b7bfc48a5274754b08819f75c5f27af53d53b",
          "token_symbol": "QI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/QI.webp",
          "token_value": 6.165201133444946e+25,
          "token_price": 0.014707927034572231,
          "created_at": "2025-11-24T02:38:00.185149",
          "usd_value": 906773.2842417029
        },
        {
          "organization_id": "5b210f8c-a584-42ab-881a-d7a15c8ab985",
          "token_address": "0x3f56e0c36d275367b8c502090edf38289b3dea0d",
          "token_symbol": "MAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MAI.webp",
          "token_value": 8.759053845066641e+24,
          "token_price": 0.04939,
          "created_at": "2025-11-24T02:38:00.185149",
          "usd_value": 848377.8012280829
        },
        {
          "organization_id": "5b210f8c-a584-42ab-881a-d7a15c8ab985",
          "token_address": "0xdfa46478f9e5ea86d57387849598dbfb2e964b02",
          "token_symbol": "MAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MAI.webp",
          "token_value": 1.1318168345665516e+25,
          "token_price": 0.03727271744418077,
          "created_at": "2025-11-24T02:38:00.185149",
          "usd_value": 421858.8907336617
        },
        {
          "organization_id": "5b210f8c-a584-42ab-881a-d7a15c8ab985",
          "token_address": "0xfb98b335551a418cd0737375a2ea0ded62ea213b",
          "token_symbol": "miMATIC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MIMATIC.webp",
          "token_value": 3.4662912786364815e+24,
          "token_price": 0.02938529084258622,
          "created_at": "2025-11-24T02:38:00.185149",
          "usd_value": 101857.97736785309
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/fantom.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 121826407.17
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "140b13e1-d2f6-4ba4-87a1-11697b7c935b",
      "uniqueKey": "d6875eef-db02-4563-95af-5cfb1e74dee6",
      "daoName": "Instadapp",
      "title": "Instadapp",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/140b13e1-d2f6-4ba4-87a1-11697b7c935b.webp",
      "totalNumMembers": 5464,
      "totalNumProposals": 127,
      "totalNumVotes": 1365,
      "activeMembers": 329,
      "totalValueUSD": 92039736,
      "change24hPercentage": 0,
      "change1WeekPercentage": -10.220355,
      "mainTreasuryAddress": "0x28849d2b63fa8d361e5fc15cb8abb13019884d09",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 92039736,
      "tokens": [
        {
          "organization_id": "140b13e1-d2f6-4ba4-87a1-11697b7c935b",
          "token_address": "0x6f40d4a6237c257fff2db00fa0510deeecd303eb",
          "token_symbol": "FLUID",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/INST.webp",
          "token_value": 2.251179113274039e+25,
          "token_price": 3.223431150237879,
          "created_at": "2025-11-24T02:30:06.375182",
          "usd_value": 72565208.78492424
        },
        {
          "organization_id": "140b13e1-d2f6-4ba4-87a1-11697b7c935b",
          "token_address": "0x40d16fc0246ad3160ccc09b8d0d3a2cd28ae6c2f",
          "token_symbol": "GHO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GHO.webp",
          "token_value": 439611499990000000000,
          "token_price": 0.9994507343615642,
          "created_at": "2025-11-24T02:30:06.375182",
          "usd_value": 439.37003649879426
        },
        {
          "organization_id": "140b13e1-d2f6-4ba4-87a1-11697b7c935b",
          "token_address": "0xd533a949740bb3306d119cc777fa900ba034cd52",
          "token_symbol": "CRV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CRV.webp",
          "token_value": 1.0881693805480228e+21,
          "token_price": 0.3934,
          "created_at": "2025-11-24T02:30:06.375182",
          "usd_value": 428.08583430759217
        },
        {
          "organization_id": "140b13e1-d2f6-4ba4-87a1-11697b7c935b",
          "token_address": "0x514910771af9ca656af840dff83e8264ecf986ca",
          "token_symbol": "LINK",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LINK.webp",
          "token_value": 31975845511425320000,
          "token_price": 12.756110994288015,
          "created_at": "2025-11-24T02:30:06.375182",
          "usd_value": 407.8874344799476
        },
        {
          "organization_id": "140b13e1-d2f6-4ba4-87a1-11697b7c935b",
          "token_address": "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
          "token_symbol": "UNI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI.webp",
          "token_value": 50499063700716460000,
          "token_price": 6.319850623715475,
          "created_at": "2025-11-24T02:30:06.375182",
          "usd_value": 319.1465392260204
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 92039733.74
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "5eeda0a5-5427-494c-a859-053340783d32",
      "uniqueKey": "9e3c897e-6f5c-45e2-aeee-b463a467cc78",
      "daoName": "CoW Swap",
      "title": "CoW Swap",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/5eeda0a5-5427-494c-a859-053340783d32.webp",
      "totalNumMembers": 12121,
      "totalNumProposals": 174,
      "totalNumVotes": 62770,
      "activeMembers": 14255,
      "totalValueUSD": 90401216,
      "change24hPercentage": 0,
      "change1WeekPercentage": -14.127807,
      "mainTreasuryAddress": "0xca771eda0c70aa7d053ab1b25004559b918fe662",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 60238592,
      "tokens": [
        {
          "organization_id": "5eeda0a5-5427-494c-a859-053340783d32",
          "token_address": "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
          "token_symbol": "COW",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/COW.webp",
          "token_value": 3.8759222325747534e+26,
          "token_price": 0.1673,
          "created_at": "2025-11-24T02:23:23.018169",
          "usd_value": 64844178.95097563
        },
        {
          "organization_id": "5eeda0a5-5427-494c-a859-053340783d32",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 3985941039430,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:23:23.018169",
          "usd_value": 3986738.387107421
        },
        {
          "organization_id": "5eeda0a5-5427-494c-a859-053340783d32",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 2537190187926,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:23:23.018169",
          "usd_value": 2536758.8655940527
        },
        {
          "organization_id": "5eeda0a5-5427-494c-a859-053340783d32",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 757237216382516500000,
          "token_price": 2862.86,
          "created_at": "2025-11-24T02:23:23.018169",
          "usd_value": 2167864.137292851
        },
        {
          "organization_id": "5eeda0a5-5427-494c-a859-053340783d32",
          "token_address": "0x1abaea1f7c830bd89acc67ec4af516284b1bc33c",
          "token_symbol": "EURC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/EURC.webp",
          "token_value": 1740655633173,
          "token_price": 1.1504366423202323,
          "created_at": "2025-11-24T02:23:23.018169",
          "usd_value": 2002514.0220633443
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 90401216.92
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "c84cd1ca-1b59-4ac7-ba68-0f3763e60998",
      "uniqueKey": "37254c10-ab45-4668-a703-7839f397c92e",
      "daoName": "Polkadot",
      "title": "Polkadot",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/c84cd1ca-1b59-4ac7-ba68-0f3763e60998.webp",
      "totalNumMembers": 1316310,
      "totalNumProposals": 365,
      "totalNumVotes": 2163,
      "activeMembers": 38,
      "totalValueUSD": 88827144,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "12xtAYsRUrmbniiWQqJtECiBQrMn8AypQcXhnQAc6RB6XkLW",
      "mainTreasuryTitle": "Substrate",
      "mainTreasuryAum": 88827144,
      "tokens": [
        {
          "organization_id": "c84cd1ca-1b59-4ac7-ba68-0f3763e60998",
          "token_address": "polkadot",
          "token_symbol": "DOT",
          "token_decimals": 0,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DOT.webp",
          "token_value": 21883996.213163268,
          "token_price": 4.059,
          "created_at": "2024-08-05T02:14:02.202464",
          "usd_value": 88827140.62922971
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/substrate.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 88827140.63
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "8880b84d-f3e2-49d0-b50d-0b6d338c0ffc",
      "uniqueKey": "23c2da63-9e6f-4a71-8daf-e47bf4c25d56",
      "daoName": "SafeDAO",
      "title": "SafeDAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/8880b84d-f3e2-49d0-b50d-0b6d338c0ffc.webp",
      "totalNumMembers": 11296,
      "totalNumProposals": 57,
      "totalNumVotes": 21096,
      "activeMembers": 3239,
      "totalValueUSD": 68356490,
      "change24hPercentage": 0,
      "change1WeekPercentage": -15.423509,
      "mainTreasuryAddress": "0x8cf60b289f8d31f737049b590b5e4285ff0bd1d1",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 636.983,
      "tokens": [
        {
          "organization_id": "8880b84d-f3e2-49d0-b50d-0b6d338c0ffc",
          "token_address": "0x5afe3855358e112b5647b952709e6165e1c1eeee",
          "token_symbol": "SAFE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "token_value": 1.031420230503976e+26,
          "token_price": 0.1508,
          "created_at": "2025-11-24T02:01:06.68253",
          "usd_value": 15553817.075999958
        },
        {
          "organization_id": "8880b84d-f3e2-49d0-b50d-0b6d338c0ffc",
          "token_address": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "token_symbol": "SYND",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "token_value": 2e+23,
          "token_price": 0.107666,
          "created_at": "2025-11-24T02:01:06.68253",
          "usd_value": 21533.199999999997
        },
        {
          "organization_id": "8880b84d-f3e2-49d0-b50d-0b6d338c0ffc",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 275618536320901380,
          "token_price": 2805.56,
          "created_at": "2025-11-24T02:01:06.68253",
          "usd_value": 773.264340760468
        },
        {
          "organization_id": "8880b84d-f3e2-49d0-b50d-0b6d338c0ffc",
          "token_address": "0x06450dee7fd2fb8e39061434babcfc05599a6fb8",
          "token_symbol": "XEN",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XEN.webp",
          "token_value": 1e+24,
          "token_price": 1.201e-8,
          "created_at": "2025-11-24T02:01:06.68253",
          "usd_value": 0.01201
        },
        {
          "organization_id": "8880b84d-f3e2-49d0-b50d-0b6d338c0ffc",
          "token_address": "0x3f3701e818a560eacd6fca1477e36b9338a2cbed",
          "token_symbol": "GROW",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GROW.webp",
          "token_value": 10000000,
          "token_price": 0,
          "created_at": "2025-11-24T02:01:06.68253",
          "usd_value": 0
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 68356486.76
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "18abd2d8-ff90-40cd-a889-4cc2fed78364",
      "uniqueKey": "db3d10b8-e2e5-4510-b9dc-c407899781b3",
      "daoName": "Aragon",
      "title": "Aragon",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1688717147324Aragon",
      "totalNumMembers": 10395,
      "totalNumProposals": 714,
      "totalNumVotes": 1506,
      "activeMembers": 118,
      "totalValueUSD": 65929516,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0xcafe1a77e84698c83ca8931f54a755176ef75f2c",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 47873288,
      "tokens": [
        {
          "organization_id": "18abd2d8-ff90-40cd-a889-4cc2fed78364",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 2.9846682994644856e+22,
          "token_price": 1801.21,
          "created_at": "2023-11-03T00:01:03.74618",
          "usd_value": 53760143.876784265
        },
        {
          "organization_id": "18abd2d8-ff90-40cd-a889-4cc2fed78364",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 9126925122702,
          "token_price": 1,
          "created_at": "2023-11-03T00:01:03.74618",
          "usd_value": 9126925.122701999
        },
        {
          "organization_id": "18abd2d8-ff90-40cd-a889-4cc2fed78364",
          "token_address": "0x960b236a07cf122663c4303350609a66a7b288c0",
          "token_symbol": "ANT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ANT.webp",
          "token_value": 7.329893296934097e+23,
          "token_price": 4.050827773730506,
          "created_at": "2023-11-03T00:01:03.74618",
          "usd_value": 2969213.5345701706
        },
        {
          "organization_id": "18abd2d8-ff90-40cd-a889-4cc2fed78364",
          "token_address": "0xbbe319b73744db9d54f5d29df7d8256b7e43995c",
          "token_symbol": "ANC",
          "token_decimals": 18,
          "token_icon": null,
          "token_value": 5.3e+22,
          "token_price": 0.7577549747331536,
          "created_at": "2023-11-03T00:01:03.74618",
          "usd_value": 40161.01366085714
        },
        {
          "organization_id": "18abd2d8-ff90-40cd-a889-4cc2fed78364",
          "token_address": "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
          "token_symbol": "stETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/STETH.webp",
          "token_value": 8928242328898713000,
          "token_price": 1799.709642016632,
          "created_at": "2023-11-03T00:01:03.74618",
          "usd_value": 16068.243805580041
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 65929516.25
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b2b78ded-5082-4a1a-b95f-d41f16cb9dde",
      "uniqueKey": "02d68117-4d45-44fa-b442-7accdbe53e05",
      "daoName": "InSure DeFi",
      "title": "InSure DeFi",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b2b78ded-5082-4a1a-b95f-d41f16cb9dde.webp",
      "totalNumMembers": 2185,
      "totalNumProposals": 117,
      "totalNumVotes": 190,
      "activeMembers": 62,
      "totalValueUSD": 56296412,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x329f5910739d4e7fd55594f68bfc7053a731ce22",
      "mainTreasuryTitle": "Avalanche",
      "mainTreasuryAum": 4331.7305,
      "tokens": [
        {
          "organization_id": "b2b78ded-5082-4a1a-b95f-d41f16cb9dde",
          "token_address": "0xcb86c6a22cb56b6cf40cafedb06ba0df188a416e",
          "token_symbol": "SURE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SURE.webp",
          "token_value": 6.126143422768316e+28,
          "token_price": 0.0009187961358282211,
          "created_at": "2025-11-10T02:44:35.466237",
          "usd_value": 56286769.04369001
        },
        {
          "organization_id": "b2b78ded-5082-4a1a-b95f-d41f16cb9dde",
          "token_address": "0x9b17baadf0f21f03e35249e0e59723f34994f806",
          "token_symbol": "SURE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SURE.webp",
          "token_value": 1.0164203858294307e+25,
          "token_price": 0.00048118447728200673,
          "created_at": "2025-11-10T02:44:35.466237",
          "usd_value": 4890.857120541102
        },
        {
          "organization_id": "b2b78ded-5082-4a1a-b95f-d41f16cb9dde",
          "token_address": "0x5fc17416925789e0852fbfcd81c490ca4abc51f9",
          "token_symbol": "SURE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SURE.webp",
          "token_value": 6.60751e+23,
          "token_price": 0.006555768084787106,
          "created_at": "2025-11-10T02:44:35.466237",
          "usd_value": 4331.730317791165
        },
        {
          "organization_id": "b2b78ded-5082-4a1a-b95f-d41f16cb9dde",
          "token_address": "0xf88332547c680f755481bf489d890426248bb275",
          "token_symbol": "SURE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SURE.webp",
          "token_value": 4.4718408e+23,
          "token_price": 0.0009187961358282211,
          "created_at": "2025-11-10T02:44:35.466237",
          "usd_value": 410.8710047078981
        },
        {
          "organization_id": "b2b78ded-5082-4a1a-b95f-d41f16cb9dde",
          "token_address": "bsc",
          "token_symbol": "BNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNB.webp",
          "token_value": 8239072661845532,
          "token_price": 1008.9,
          "created_at": "2025-11-10T02:44:35.466237",
          "usd_value": 8.312400408535957
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/avalanche.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 56296410.81
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "15e28f3f-ad15-41db-a8dc-3a9a42c6476d",
      "uniqueKey": "02d455d2-cbc3-447c-aeaa-a986cba9fbdc",
      "daoName": "Decubate",
      "title": "Decubate",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/15e28f3f-ad15-41db-a8dc-3a9a42c6476d.webp",
      "totalNumMembers": 14274,
      "totalNumProposals": 9,
      "totalNumVotes": 1402,
      "activeMembers": 709,
      "totalValueUSD": 55600296,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x792805a4a1bac0ff3ae47c8273bffb8a7959cb8d",
      "mainTreasuryTitle": "Binance Smart Chain",
      "mainTreasuryAum": 11939769,
      "tokens": [
        {
          "organization_id": "15e28f3f-ad15-41db-a8dc-3a9a42c6476d",
          "token_address": "0xeac9873291ddaca754ea5642114151f3035c67a2",
          "token_symbol": "DCB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DCB.webp",
          "token_value": 6.113343799845118e+26,
          "token_price": 0.08971149095657163,
          "created_at": "2024-05-03T02:14:08.938809",
          "usd_value": 54843718.70142186
        },
        {
          "organization_id": "15e28f3f-ad15-41db-a8dc-3a9a42c6476d",
          "token_address": "0x55d398326f99059ff775485246999027b3197955",
          "token_symbol": "USDT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 4.2727532608159247e+23,
          "token_price": 1.000135,
          "created_at": "2024-05-03T02:14:08.938809",
          "usd_value": 427333.00825061346
        },
        {
          "organization_id": "15e28f3f-ad15-41db-a8dc-3a9a42c6476d",
          "token_address": "0xe356cb3efc9cb4320b945393a10fd71c77dc24a0",
          "token_symbol": "TTM",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TTM.webp",
          "token_value": 2.5555556e+25,
          "token_price": 0.009391153841608001,
          "created_at": "2024-05-03T02:14:08.938809",
          "usd_value": 239996.1579038284
        },
        {
          "organization_id": "15e28f3f-ad15-41db-a8dc-3a9a42c6476d",
          "token_address": "0x2d060ef4d6bf7f9e5edde373ab735513c0e4f944",
          "token_symbol": "AITECH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AITECH.webp",
          "token_value": 2.7728347132143495e+23,
          "token_price": 0.19858628760627067,
          "created_at": "2024-05-03T02:14:08.938809",
          "usd_value": 55064.695184303586
        },
        {
          "organization_id": "15e28f3f-ad15-41db-a8dc-3a9a42c6476d",
          "token_address": "0x83d5475bc3bfa08ac3d82ba54b4f86afc5444398",
          "token_symbol": "Cake-LP",
          "token_decimals": 18,
          "token_icon": null,
          "token_value": 5.087932655595986e+22,
          "token_price": 0.6407851113374394,
          "created_at": "2024-05-03T02:14:08.938809",
          "usd_value": 32602.714931934683
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/bsc.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "b0ec5a90-63b7-4e1f-8a87-5e48cedfd105",
          "title": "Investments",
          "description": "Invest in crypto assets and projects via Web3, from incubation and VC to full acquisitions"
        },
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 55600295.73
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "0c621a01-8b6b-496b-b7db-0615b11b6662",
      "uniqueKey": "6d9b763f-f0a0-4796-80d2-5e60ad0ff353",
      "daoName": "UMA",
      "title": "UMA",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/0c621a01-8b6b-496b-b7db-0615b11b6662.webp",
      "totalNumMembers": 21999,
      "totalNumProposals": 20,
      "totalNumVotes": 411,
      "activeMembers": 198,
      "totalValueUSD": 53427920,
      "change24hPercentage": 0,
      "change1WeekPercentage": -8.467357,
      "mainTreasuryAddress": "0x8180d59b7175d4064bdfa8138a58e9babffda44a",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 24863482,
      "tokens": [
        {
          "organization_id": "0c621a01-8b6b-496b-b7db-0615b11b6662",
          "token_address": "0x04fa0d235c4abf4bcf4787af4cf447de572ef828",
          "token_symbol": "UMA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UMA.webp",
          "token_value": 7.01723537011332e+25,
          "token_price": 0.83,
          "created_at": "2025-11-24T02:44:22.815036",
          "usd_value": 58243053.571940556
        },
        {
          "organization_id": "0c621a01-8b6b-496b-b7db-0615b11b6662",
          "token_address": "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
          "token_symbol": "ACX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ACX.webp",
          "token_value": 2.6296462296084278e+26,
          "token_price": 0.0611,
          "created_at": "2025-11-24T02:44:22.815036",
          "usd_value": 16067138.462907495
        },
        {
          "organization_id": "0c621a01-8b6b-496b-b7db-0615b11b6662",
          "token_address": "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
          "token_symbol": "UNI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI.webp",
          "token_value": 1.8102241481023785e+23,
          "token_price": 6.298574103376484,
          "created_at": "2025-11-24T02:44:22.815036",
          "usd_value": 1140183.0940544398
        },
        {
          "organization_id": "0c621a01-8b6b-496b-b7db-0615b11b6662",
          "token_address": "0x14d60e7fdc0d71d8611742720e4c50e7a974020c",
          "token_symbol": "USCC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USCC.webp",
          "token_value": 99199740011,
          "token_price": 11.35033,
          "created_at": "2025-11-24T02:44:22.815036",
          "usd_value": 1125949.7850390535
        },
        {
          "organization_id": "0c621a01-8b6b-496b-b7db-0615b11b6662",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 949142295,
          "token_price": 87376.22,
          "created_at": "2025-11-24T02:44:22.815036",
          "usd_value": 829324.6597922491
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 53427920.9
        },
        "private": {
          "name": "private",
          "value": 26627411.94
        },
        "project": {
          "name": "project",
          "value": 2818.17
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "60c9b31c-4495-4028-aeac-eb7bb117fece",
      "uniqueKey": "c0a6cd72-cfb0-42e8-8b2a-727c90547150",
      "daoName": "Decentraland",
      "title": "Decentraland",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/60c9b31c-4495-4028-aeac-eb7bb117fece.webp",
      "totalNumMembers": 293304,
      "totalNumProposals": 3123,
      "totalNumVotes": 181463,
      "activeMembers": 8672,
      "totalValueUSD": 53204888,
      "change24hPercentage": 0,
      "change1WeekPercentage": -16.35244,
      "mainTreasuryAddress": "0xb08e3e7cc815213304d884c88ca476ebc50eaab2",
      "mainTreasuryTitle": "Polygon",
      "mainTreasuryAum": 293742,
      "tokens": [
        {
          "organization_id": "60c9b31c-4495-4028-aeac-eb7bb117fece",
          "token_address": "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
          "token_symbol": "MANA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VP.webp",
          "token_value": 2.9459670851806736e+26,
          "token_price": 0.16686,
          "created_at": "2025-11-24T02:21:13.847348",
          "usd_value": 49164095.88634305
        },
        {
          "organization_id": "60c9b31c-4495-4028-aeac-eb7bb117fece",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1.1573328535061463e+21,
          "token_price": 2862.633333333333,
          "created_at": "2025-11-24T02:21:13.847348",
          "usd_value": 3312754.4363279277
        },
        {
          "organization_id": "60c9b31c-4495-4028-aeac-eb7bb117fece",
          "token_address": "0xa1c57f48f0deb89f569dfbe6e2b7f46d33606fd4",
          "token_symbol": "MANA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MANA.webp",
          "token_value": 1.6329667297433202e+24,
          "token_price": 0.1667,
          "created_at": "2025-11-24T02:21:13.847348",
          "usd_value": 272215.5538482115
        },
        {
          "organization_id": "60c9b31c-4495-4028-aeac-eb7bb117fece",
          "token_address": "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
          "token_symbol": "ENS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ENS.webp",
          "token_value": 2.3304931336860245e+22,
          "token_price": 11.35,
          "created_at": "2025-11-24T02:21:13.847348",
          "usd_value": 264510.9706733638
        },
        {
          "organization_id": "60c9b31c-4495-4028-aeac-eb7bb117fece",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 8.752155654145698e+22,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:21:13.847348",
          "usd_value": 87512.80438580282
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/polygon.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
          "title": "Gaming",
          "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 15911027.93
        },
        "vesting": {
          "name": "vesting",
          "value": 37293859.12
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "28f296a9-14d1-49cd-9984-bdc4dc45ebb1",
      "uniqueKey": "63ed0857-87c9-4fbf-9942-135620dec63a",
      "daoName": "Tornado Cash",
      "title": "Tornado Cash",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/28f296a9-14d1-49cd-9984-bdc4dc45ebb1.webp",
      "totalNumMembers": 10889,
      "totalNumProposals": 31,
      "totalNumVotes": 491,
      "activeMembers": 179,
      "totalValueUSD": 51979312,
      "change24hPercentage": 0,
      "change1WeekPercentage": -8.924287,
      "mainTreasuryAddress": "0xb04e030140b30c27bcdfaafffa98c57d80eda7b4",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 491285.03,
      "tokens": [
        {
          "organization_id": "28f296a9-14d1-49cd-9984-bdc4dc45ebb1",
          "token_address": "0x77777feddddffc19ff86db637967013e6c6a116c",
          "token_symbol": "TORN",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TORN.webp",
          "token_value": 4.2289834617411223e+24,
          "token_price": 12.28555253188066,
          "created_at": "2025-11-24T02:36:30.5382",
          "usd_value": 51955398.475675076
        },
        {
          "organization_id": "28f296a9-14d1-49cd-9984-bdc4dc45ebb1",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 8414159000000000000,
          "token_price": 2842.17,
          "created_at": "2025-11-24T02:36:30.5382",
          "usd_value": 23914.47028503
        },
        {
          "organization_id": "28f296a9-14d1-49cd-9984-bdc4dc45ebb1",
          "token_address": "0x6021d2c27b6fbd6e7608d1f39b41398caee2f824",
          "token_symbol": "CP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CP.webp",
          "token_value": 1000000000000000000,
          "token_price": 0.01462880772875894,
          "created_at": "2025-11-24T02:36:30.5382",
          "usd_value": 0.01462880772875894
        },
        {
          "organization_id": "28f296a9-14d1-49cd-9984-bdc4dc45ebb1",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 100000000000,
          "token_price": 2842.17,
          "created_at": "2025-11-24T02:36:30.5382",
          "usd_value": 0.000284217
        },
        {
          "organization_id": "28f296a9-14d1-49cd-9984-bdc4dc45ebb1",
          "token_address": "0x7e1ae068ac4e0ffd7a84750c2fb093a0eae9aea2",
          "token_symbol": "TBA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TBA.webp",
          "token_value": 1000100000000000000,
          "token_price": 4.952251101337342e-10,
          "created_at": "2025-11-24T02:36:30.5382",
          "usd_value": 4.952746326447476e-10
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 51979312.96
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "d13f96a0-da32-47ce-841a-96134e8459eb",
      "uniqueKey": "e913918e-e85a-45f4-9b7e-d7494595bfdb",
      "daoName": "Stargate Finance",
      "title": "Stargate Finance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d13f96a0-da32-47ce-841a-96134e8459eb.webp",
      "totalNumMembers": 38276,
      "totalNumProposals": 165,
      "totalNumVotes": 16810415,
      "activeMembers": 1191135,
      "totalValueUSD": 48524560,
      "change24hPercentage": 0,
      "change1WeekPercentage": -9.382952,
      "mainTreasuryAddress": "0x65bb797c2b9830d891d87288f029ed8dacc19705",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 36844012,
      "tokens": [
        {
          "organization_id": "d13f96a0-da32-47ce-841a-96134e8459eb",
          "token_address": "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
          "token_symbol": "STG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VESTG.webp",
          "token_value": 2.4779624528721423e+26,
          "token_price": 0.1128,
          "created_at": "2025-11-24T02:09:01.389452",
          "usd_value": 27951416.468397763
        },
        {
          "organization_id": "d13f96a0-da32-47ce-841a-96134e8459eb",
          "token_address": "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
          "token_symbol": "STG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/STG.webp",
          "token_value": 3.967912022390879e+25,
          "token_price": 0.11442,
          "created_at": "2025-11-24T02:09:01.389452",
          "usd_value": 4538296.38063233
        },
        {
          "organization_id": "d13f96a0-da32-47ce-841a-96134e8459eb",
          "token_address": "0x296f55f8fb28e498b858d0bcda06d955b2cb3f97",
          "token_symbol": "STG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/STG.webp",
          "token_value": 1.0062252692778358e+25,
          "token_price": 0.11342720995158223,
          "created_at": "2025-11-24T02:09:01.389452",
          "usd_value": 1141333.2487696444
        },
        {
          "organization_id": "d13f96a0-da32-47ce-841a-96134e8459eb",
          "token_address": "0xb0d502e938ed5f4df2e681fe6e419ff29631d62b",
          "token_symbol": "STG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/STG.webp",
          "token_value": 7.216808899362623e+24,
          "token_price": 0.1145,
          "created_at": "2025-11-24T02:09:01.389452",
          "usd_value": 826324.6189770203
        },
        {
          "organization_id": "d13f96a0-da32-47ce-841a-96134e8459eb",
          "token_address": "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
          "token_symbol": "USDt",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 737527024382,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:09:01.389452",
          "usd_value": 737401.644787855
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 48524559.22
        },
        "protocol": {
          "name": "protocol",
          "value": 240158.52
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "1cc3c757-99f8-4373-908f-6e97931b6737",
      "uniqueKey": "8beaaaba-2bb8-4198-ba0f-d765969b7eee",
      "daoName": "Phala",
      "title": "Phala",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/1cc3c757-99f8-4373-908f-6e97931b6737.webp",
      "totalNumMembers": 3143,
      "totalNumProposals": 24,
      "totalNumVotes": 72,
      "activeMembers": 6,
      "totalValueUSD": 46988420,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "436H4jat7TobTbNX4RCH5p7qgErHbGTo1MyZhLVaSX4FkKyz",
      "mainTreasuryTitle": "Substrate",
      "mainTreasuryAum": 46988420,
      "tokens": [
        {
          "organization_id": "1cc3c757-99f8-4373-908f-6e97931b6737",
          "token_address": "phala",
          "token_symbol": "PHA",
          "token_decimals": 0,
          "token_icon": null,
          "token_value": 436289881.6804393,
          "token_price": 0.1077,
          "created_at": "2023-12-14T00:17:17.447271",
          "usd_value": 46988420.25698331
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/substrate.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 46988420.26
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "1323d31d-bd0c-4605-ba55-573dd7129324",
      "uniqueKey": "f2aaf713-e35f-4d89-a65a-08c595665f6a",
      "daoName": "Mango DAO",
      "title": "Mango DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/1323d31d-bd0c-4605-ba55-573dd7129324.webp",
      "totalNumMembers": 42913,
      "totalNumProposals": 984,
      "totalNumVotes": 6147,
      "activeMembers": 613,
      "totalValueUSD": 46724824,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "9RGoboEjmaAjSCXsKi6p6zJucnwF3Eg5NUN9jPS6ziL3",
      "mainTreasuryTitle": "Solana",
      "mainTreasuryAum": 46724584,
      "tokens": [
        {
          "organization_id": "1323d31d-bd0c-4605-ba55-573dd7129324",
          "token_address": "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
          "token_symbol": "MNGO",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MNGO.webp",
          "token_value": 2699852737143412,
          "token_price": 0.017306346,
          "created_at": "2024-08-05T02:06:08.088982",
          "usd_value": 46724585.61805094
        },
        {
          "organization_id": "1323d31d-bd0c-4605-ba55-573dd7129324",
          "token_address": "11111111111111111111111111111111",
          "token_symbol": "SOL",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SOL.webp",
          "token_value": 1824979440,
          "token_price": 130.58029,
          "created_at": "2024-08-05T02:06:08.088982",
          "usd_value": 238.30634451923757
        },
        {
          "organization_id": "1323d31d-bd0c-4605-ba55-573dd7129324",
          "token_address": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 0,
          "token_price": 0.9993098,
          "created_at": "2024-08-05T02:06:08.088982",
          "usd_value": 0
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/solana.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 46724823.92
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "7ce906c9-c4d5-4f42-b60d-01642ad5692e",
      "uniqueKey": "1905ec75-ecc2-4789-910b-1776aba2ae90",
      "daoName": "Synthetix",
      "title": "Synthetix",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/7ce906c9-c4d5-4f42-b60d-01642ad5692e.webp",
      "totalNumMembers": 83023,
      "totalNumProposals": 958,
      "totalNumVotes": 16268,
      "activeMembers": 2959,
      "totalValueUSD": 40194940,
      "change24hPercentage": 0,
      "change1WeekPercentage": -13.473749,
      "mainTreasuryAddress": "0x46abfe1c972fca43766d6ad70e1c1df72f4bb4d1",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 11202.572,
      "tokens": [
        {
          "organization_id": "7ce906c9-c4d5-4f42-b60d-01642ad5692e",
          "token_address": "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
          "token_symbol": "sUSD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUSD.webp",
          "token_value": 7.991525667126116e+23,
          "token_price": 0.9587026860799318,
          "created_at": "2025-11-24T02:24:50.475371",
          "usd_value": 766149.7122950526
        },
        {
          "organization_id": "7ce906c9-c4d5-4f42-b60d-01642ad5692e",
          "token_address": "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
          "token_symbol": "SNX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SNX.webp",
          "token_value": 4.037833886683427e+23,
          "token_price": 0.603,
          "created_at": "2025-11-24T02:24:50.475371",
          "usd_value": 243481.38336701063
        },
        {
          "organization_id": "7ce906c9-c4d5-4f42-b60d-01642ad5692e",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 7023378805123364000,
          "token_price": 2863.734,
          "created_at": "2025-11-24T02:24:50.475371",
          "usd_value": 20114.405354014823
        },
        {
          "organization_id": "7ce906c9-c4d5-4f42-b60d-01642ad5692e",
          "token_address": "0xe405de8f52ba7559f9df3c368500b6e6ae6cee49",
          "token_symbol": "sETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SETH.webp",
          "token_value": 4000000581202578000,
          "token_price": 2729.881434105466,
          "created_at": "2025-11-24T02:24:50.475371",
          "usd_value": 10919.527323035989
        },
        {
          "organization_id": "7ce906c9-c4d5-4f42-b60d-01642ad5692e",
          "token_address": "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
          "token_symbol": "AAVE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AAVE.webp",
          "token_value": 52603485510844850000,
          "token_price": 171.2028621160276,
          "created_at": "2025-11-24T02:24:50.475371",
          "usd_value": 9005.867276735626
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 40194940.76
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "3ec84f7d-e707-42cb-b30f-6192bb9c5e67",
      "uniqueKey": "1b737d05-4ee2-4ee6-b00b-c8727d324411",
      "daoName": "Orbs",
      "title": "Orbs",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/3ec84f7d-e707-42cb-b30f-6192bb9c5e67.webp",
      "totalNumMembers": 8407,
      "totalNumProposals": 8,
      "totalNumVotes": 147,
      "activeMembers": 67,
      "totalValueUSD": 39176740,
      "change24hPercentage": 0,
      "change1WeekPercentage": -5.7214093,
      "mainTreasuryAddress": "0xcaf1810f6bb2cd50f9a3c22a77e3c628cd282634",
      "mainTreasuryTitle": "Polygon",
      "mainTreasuryAum": 20176.67,
      "tokens": [
        {
          "organization_id": "3ec84f7d-e707-42cb-b30f-6192bb9c5e67",
          "token_address": "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
          "token_symbol": "ORBS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ORBS.webp",
          "token_value": 3.689993897637556e+27,
          "token_price": 0.01061,
          "created_at": "2025-11-24T02:25:10.215276",
          "usd_value": 39150835.253934465
        },
        {
          "organization_id": "3ec84f7d-e707-42cb-b30f-6192bb9c5e67",
          "token_address": "0x614389eaae0a6821dc49062d56bda3d9d45fa2ff",
          "token_symbol": "ORBS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ORBS.webp",
          "token_value": 1.9094343977429684e+24,
          "token_price": 0.010566830366375533,
          "created_at": "2025-11-24T02:25:10.215276",
          "usd_value": 20176.669376672377
        },
        {
          "organization_id": "3ec84f7d-e707-42cb-b30f-6192bb9c5e67",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 2000000000000000000,
          "token_price": 2863.32,
          "created_at": "2025-11-24T02:25:10.215276",
          "usd_value": 5726.64
        },
        {
          "organization_id": "3ec84f7d-e707-42cb-b30f-6192bb9c5e67",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 100000000000,
          "token_price": 2863.32,
          "created_at": "2025-11-24T02:25:10.215276",
          "usd_value": 0.000286332
        },
        {
          "organization_id": "3ec84f7d-e707-42cb-b30f-6192bb9c5e67",
          "token_address": "0x70784d8a360491562342b4f3d3d039aaacaf8f5d",
          "token_symbol": "SIM",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SIM.webp",
          "token_value": 23978193200000000000,
          "token_price": 0.000008014862042706256,
          "created_at": "2025-11-24T02:25:10.215276",
          "usd_value": 0.00019218191053135724
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/polygon.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 316882.48
        },
        "vesting": {
          "name": "vesting",
          "value": 38859856.08
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b1ed9192-7150-4136-891e-a35e89d8e84a",
      "uniqueKey": "9222220d-1202-4f36-bf5b-c2e7d79d29b8",
      "daoName": "Morpho",
      "title": "Morpho",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b1ed9192-7150-4136-891e-a35e89d8e84a.webp",
      "totalNumMembers": 6543,
      "totalNumProposals": 131,
      "totalNumVotes": 4710,
      "activeMembers": 580,
      "totalValueUSD": 38904252,
      "change24hPercentage": 0,
      "change1WeekPercentage": -27.482943,
      "mainTreasuryAddress": "0x5eb982bb1e620cc3927e5cf8a5d207e667643297",
      "mainTreasuryTitle": "Base",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "b1ed9192-7150-4136-891e-a35e89d8e84a",
          "token_address": "0x58d97b57bb95320f9a05dc918aef65434969c2b2",
          "token_symbol": "MORPHO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MORPHO.webp",
          "token_value": 6.417339825382597e+26,
          "token_price": 1.5086831321647036,
          "created_at": "2025-11-24T02:48:51.634941",
          "usd_value": 968173234.7923508
        },
        {
          "organization_id": "b1ed9192-7150-4136-891e-a35e89d8e84a",
          "token_address": "0xbaa5cc21fd487b8fcc2f632f3f4e8d37262a0842",
          "token_symbol": "MORPHO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MORPHO.webp",
          "token_value": 1.379230048306523e+25,
          "token_price": 1.5113,
          "created_at": "2025-11-24T02:48:51.634941",
          "usd_value": 20844303.72005648
        },
        {
          "organization_id": "b1ed9192-7150-4136-891e-a35e89d8e84a",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 3591214134559,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:48:51.634941",
          "usd_value": 3591932.5210632123
        },
        {
          "organization_id": "b1ed9192-7150-4136-891e-a35e89d8e84a",
          "token_address": "0x40bd670a58238e6e230c430bbb5ce6ec0d40df48",
          "token_symbol": "MORPHO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MORPHO.webp",
          "token_value": 2.760451e+23,
          "token_price": 1.5112446359595058,
          "created_at": "2025-11-24T02:48:51.634941",
          "usd_value": 417171.67665790534
        },
        {
          "organization_id": "b1ed9192-7150-4136-891e-a35e89d8e84a",
          "token_address": "matic",
          "token_symbol": "POL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/POL.webp",
          "token_value": 1.000001e+24,
          "token_price": 0.1342,
          "created_at": "2025-11-24T02:48:51.634941",
          "usd_value": 134200.1342
        }
      ],
      "chainLogo": null,
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 38904251.15
        },
        "project": {
          "name": "project",
          "value": 51398042.32
        },
        "protocol": {
          "name": "protocol",
          "value": 916804829.54
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b84755f3-f21f-4290-9d56-af77e9060690",
      "uniqueKey": "b96104c6-cf0b-4ebe-a788-549f752a42b9",
      "daoName": "UXDProtocol",
      "title": "UXDProtocol",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b84755f3-f21f-4290-9d56-af77e9060690.webp",
      "totalNumMembers": 32470,
      "totalNumProposals": 1162,
      "totalNumVotes": 3269,
      "activeMembers": 155,
      "totalValueUSD": 35990836,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "C4VqkkRPfPVtcCjVR1SZKRM95vGEUtH6mTBgf15x4ps7",
      "mainTreasuryTitle": "Solana",
      "mainTreasuryAum": 0.5642123,
      "tokens": [
        {
          "organization_id": "b84755f3-f21f-4290-9d56-af77e9060690",
          "token_address": "UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M",
          "token_symbol": "UXP",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UXP.webp",
          "token_value": 2878101326004557000,
          "token_price": 0.009966565,
          "created_at": "2024-08-05T02:03:48.871413",
          "usd_value": 28684783.942210604
        },
        {
          "organization_id": "b84755f3-f21f-4290-9d56-af77e9060690",
          "token_address": "7kbnvuGBxxj8AG9qp8Scn56muWGaRaFqxg1FsRp3PaFT",
          "token_symbol": "UXD",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UXD.webp",
          "token_value": 5800001500000,
          "token_price": 0.99847279,
          "created_at": "2024-08-05T02:03:48.871413",
          "usd_value": 5800048.4800121505
        },
        {
          "organization_id": "b84755f3-f21f-4290-9d56-af77e9060690",
          "token_address": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 1302560102578,
          "token_price": 0.9998917166666667,
          "created_at": "2024-08-05T02:03:48.871413",
          "usd_value": 1302570.6533148307
        },
        {
          "organization_id": "b84755f3-f21f-4290-9d56-af77e9060690",
          "token_address": "jtojtomepa8beP8AuQc6eXt5FriJwfFMwQx2v2f9mCL",
          "token_symbol": "",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/.webp",
          "token_value": 58247000000000,
          "token_price": 2.145691,
          "created_at": "2024-08-05T02:03:48.871413",
          "usd_value": 124980.06367699998
        },
        {
          "organization_id": "b84755f3-f21f-4290-9d56-af77e9060690",
          "token_address": "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN",
          "token_symbol": "",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/.webp",
          "token_value": 100201000000,
          "token_price": 0.7787577,
          "created_at": "2024-08-05T02:03:48.871413",
          "usd_value": 78032.3002977
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/solana.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "df5e8880-9d6f-412c-adab-d61fc242e0d3",
          "title": "Greater Good / Political",
          "description": "Work to achieve public goods and other goals beyond membership boundaries and immediate interests"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 35990836.23
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "796c23d6-0075-4237-ac76-e66168714383",
      "uniqueKey": "8e037404-56f9-40cb-833d-fed8e2b65642",
      "daoName": "Illuvium",
      "title": "Illuvium",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/796c23d6-0075-4237-ac76-e66168714383.webp",
      "totalNumMembers": 53821,
      "totalNumProposals": 57,
      "totalNumVotes": 6830,
      "activeMembers": 3186,
      "totalValueUSD": 33286272,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x58c37a622cdf8ace54d8b25c58223f61d0d738aa",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 33286272,
      "tokens": [
        {
          "organization_id": "796c23d6-0075-4237-ac76-e66168714383",
          "token_address": "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
          "token_symbol": "ILV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token-logos/16705968706100x767fe9edc9e0df98e07454847909b5e959d7ca0e",
          "token_value": 2.0185604852102421e+24,
          "token_price": 17.608181397256384,
          "created_at": "2024-10-28T02:27:31.961335",
          "usd_value": 33190204.796000913
        },
        {
          "organization_id": "796c23d6-0075-4237-ac76-e66168714383",
          "token_address": "0x5afe3855358e112b5647b952709e6165e1c1eeee",
          "token_symbol": "SAFE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "token_value": 2.4461705069297624e+22,
          "token_price": 1.2880598766211555,
          "created_at": "2024-10-28T02:27:31.961335",
          "usd_value": 31508.14081350259
        },
        {
          "organization_id": "796c23d6-0075-4237-ac76-e66168714383",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 9130943944204,
          "token_price": 0.0026558769655693165,
          "created_at": "2024-10-28T02:27:31.961335",
          "usd_value": 24250.66369531605
        },
        {
          "organization_id": "796c23d6-0075-4237-ac76-e66168714383",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 1251020551684,
          "token_price": 0.0020615741927249615,
          "created_at": "2024-10-28T02:27:31.961335",
          "usd_value": 2579.0716839202782
        },
        {
          "organization_id": "796c23d6-0075-4237-ac76-e66168714383",
          "token_address": "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
          "token_symbol": "SUSHI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUSHIPOWAH.webp",
          "token_value": 1.224083038226464e+23,
          "token_price": 0.0018621964748435065,
          "created_at": "2024-10-28T02:27:31.961335",
          "usd_value": 227.94831187010504
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
          "title": "Gaming",
          "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 33286272.13
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "53e01efd-2aec-43b0-a258-6f8704f19a02",
      "uniqueKey": "f04239ce-eb89-4f8d-a185-eb8c098274e1",
      "daoName": "SuperVerse",
      "title": "SuperVerse",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/53e01efd-2aec-43b0-a258-6f8704f19a02.webp",
      "totalNumMembers": 41748,
      "totalNumProposals": 3,
      "totalNumVotes": 176,
      "activeMembers": 63,
      "totalValueUSD": 32421970,
      "change24hPercentage": 0,
      "change1WeekPercentage": -18.459469,
      "mainTreasuryAddress": "0x23a1fd006d151e1d920d5de860e82c697e73fbcf",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 2368879.5,
      "tokens": [
        {
          "organization_id": "53e01efd-2aec-43b0-a258-6f8704f19a02",
          "token_address": "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
          "token_symbol": "SUPER",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUPER.webp",
          "token_value": 3.672107256559752e+26,
          "token_price": 0.20443987127329888,
          "created_at": "2025-11-24T02:20:48.870129",
          "usd_value": 75072513.48328224
        },
        {
          "organization_id": "53e01efd-2aec-43b0-a258-6f8704f19a02",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 243373837340165600000,
          "token_price": 2860.315,
          "created_at": "2025-11-24T02:20:48.870129",
          "usd_value": 696278.8235383967
        },
        {
          "organization_id": "53e01efd-2aec-43b0-a258-6f8704f19a02",
          "token_address": "bsc",
          "token_symbol": "BNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNB.webp",
          "token_value": 304416485698741860000,
          "token_price": 848.7,
          "created_at": "2025-11-24T02:20:48.870129",
          "usd_value": 258358.2714125222
        },
        {
          "organization_id": "53e01efd-2aec-43b0-a258-6f8704f19a02",
          "token_address": "0x77cb92156d838a3f7ae00e36b7e3c14263904444",
          "token_symbol": "BNBCHART",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNBCHART.webp",
          "token_value": 4.444e+21,
          "token_price": 0.0014720640849042587,
          "created_at": "2025-11-24T02:20:48.870129",
          "usd_value": 6.541852793314526
        },
        {
          "organization_id": "53e01efd-2aec-43b0-a258-6f8704f19a02",
          "token_address": "0x567fd5658f48c1c826a912ea1ba37696a6b32006",
          "token_symbol": "METAS",
          "token_decimals": 18,
          "token_icon": null,
          "token_value": 1500000000000000000,
          "token_price": 1.2799957864169975,
          "created_at": "2025-11-24T02:20:48.870129",
          "usd_value": 1.9199936796254962
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
          "title": "Gaming",
          "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 3635206.74
        },
        "private": {
          "name": "private",
          "value": 17330912.39
        },
        "protocol": {
          "name": "protocol",
          "value": 29440870.88
        },
        "vesting": {
          "name": "vesting",
          "value": 28786763.27
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "cd32c619-4a86-4374-8f0c-473abcdc75fb",
      "uniqueKey": "c27c7701-33ee-4f6a-9efe-40bce49f80ff",
      "daoName": "Venus Protocol",
      "title": "Venus Protocol",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1688974713270VenusProtocol",
      "totalNumMembers": 78028,
      "totalNumProposals": 189,
      "totalNumVotes": 1474,
      "activeMembers": 253,
      "totalValueUSD": 31410978,
      "change24hPercentage": 0,
      "change1WeekPercentage": -5.4895306,
      "mainTreasuryAddress": "0x555ba73db1b006f3f2c7db7126d6e4343adbce02",
      "mainTreasuryTitle": "Binance Smart Chain",
      "mainTreasuryAum": 3720.933,
      "tokens": [
        {
          "organization_id": "cd32c619-4a86-4374-8f0c-473abcdc75fb",
          "token_address": "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
          "token_symbol": "WBNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBNB.webp",
          "token_value": 1.3464501423903775e+22,
          "token_price": 849.1,
          "created_at": "2025-11-24T02:08:38.557571",
          "usd_value": 11432708.159036698
        },
        {
          "organization_id": "cd32c619-4a86-4374-8f0c-473abcdc75fb",
          "token_address": "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
          "token_symbol": "BTCB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BTCB.webp",
          "token_value": 59004735944826670000,
          "token_price": 87743.8,
          "created_at": "2025-11-24T02:08:38.557571",
          "usd_value": 5177299.749795683
        },
        {
          "organization_id": "cd32c619-4a86-4374-8f0c-473abcdc75fb",
          "token_address": "0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63",
          "token_symbol": "XVS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XVS.webp",
          "token_value": 2.5687208758166222e+23,
          "token_price": 4.06,
          "created_at": "2025-11-24T02:08:38.557571",
          "usd_value": 1042900.6755815485
        },
        {
          "organization_id": "cd32c619-4a86-4374-8f0c-473abcdc75fb",
          "token_address": "0x55d398326f99059ff775485246999027b3197955",
          "token_symbol": "USDT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 8.080935960822807e+23,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:08:38.557571",
          "usd_value": 807956.2201709468
        },
        {
          "organization_id": "cd32c619-4a86-4374-8f0c-473abcdc75fb",
          "token_address": "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 263500914914045950000,
          "token_price": 2847.95,
          "created_at": "2025-11-24T02:08:38.557571",
          "usd_value": 750437.4306294571
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/bsc.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 31410977.86
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "8ffbd6d6-3a16-48b5-94c1-97c05db41fcb",
      "uniqueKey": "253bee0d-9445-400e-b051-d4afa10e5b3a",
      "daoName": "HairDAO",
      "title": "HairDAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/8ffbd6d6-3a16-48b5-94c1-97c05db41fcb.webp",
      "totalNumMembers": 560,
      "totalNumProposals": 33,
      "totalNumVotes": 315,
      "activeMembers": 57,
      "totalValueUSD": 31386418,
      "change24hPercentage": 0,
      "change1WeekPercentage": -9.914074,
      "mainTreasuryAddress": "0xe98134dce5959eb8d13b7d6543b8e16a20ed973e",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 31386418,
      "tokens": [
        {
          "organization_id": "8ffbd6d6-3a16-48b5-94c1-97c05db41fcb",
          "token_address": "0x9ce115f0341ae5dabc8b477b74e83db2018a6f42",
          "token_symbol": "HAIR",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/HAIR.webp",
          "token_value": 8.384172003739984e+23,
          "token_price": 32.4477052989681,
          "created_at": "2025-11-24T02:43:02.835103",
          "usd_value": 27204714.235321388
        },
        {
          "organization_id": "8ffbd6d6-3a16-48b5-94c1-97c05db41fcb",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 170235393272404640000,
          "token_price": 2841.94,
          "created_at": "2025-11-24T02:43:02.835103",
          "usd_value": 483798.7735565777
        },
        {
          "organization_id": "8ffbd6d6-3a16-48b5-94c1-97c05db41fcb",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 16463013133,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:43:02.835103",
          "usd_value": 16467.953519055714
        },
        {
          "organization_id": "8ffbd6d6-3a16-48b5-94c1-97c05db41fcb",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 699892520173099500000,
          "token_price": 1,
          "created_at": "2025-11-24T02:43:02.835103",
          "usd_value": 699.8925201730996
        },
        {
          "organization_id": "8ffbd6d6-3a16-48b5-94c1-97c05db41fcb",
          "token_address": "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
          "token_symbol": "MTV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MTV.webp",
          "token_value": 1e+21,
          "token_price": 0.0003086,
          "created_at": "2025-11-24T02:43:02.835103",
          "usd_value": 0.30860000000000004
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "e5ce3a6b-5db5-4c6d-bb08-37827620328b",
          "title": "Decentralized Science",
          "description": "Conduct cooperative scientific research utilizing blockchain tools and development"
        },
        {
          "id": "b0ec5a90-63b7-4e1f-8a87-5e48cedfd105",
          "title": "Investments",
          "description": "Invest in crypto assets and projects via Web3, from incubation and VC to full acquisitions"
        },
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 31386417.86
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "53418429-b2ee-4c5a-b0f0-5b8ff20829ec",
      "uniqueKey": "d3cefd22-e787-4d18-88b8-65397adece27",
      "daoName": "JPEG'd",
      "title": "JPEG'd",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/53418429-b2ee-4c5a-b0f0-5b8ff20829ec.webp",
      "totalNumMembers": 3561,
      "totalNumProposals": 155,
      "totalNumVotes": 3560,
      "activeMembers": 972,
      "totalValueUSD": 29785272,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x3b7157e5e732863170597790b4c005436572570f",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 1656.681,
      "tokens": [
        {
          "organization_id": "53418429-b2ee-4c5a-b0f0-5b8ff20829ec",
          "token_address": "0xce722f60f35c37ab295adc4e6ba45bcc7ca89dd6",
          "token_symbol": "JPGD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/JPGD.webp",
          "token_value": 2.8071844309503796e+28,
          "token_price": 0.0007067084254734492,
          "created_at": "2025-02-24T02:26:25.292785",
          "usd_value": 19838608.892105233
        },
        {
          "organization_id": "53418429-b2ee-4c5a-b0f0-5b8ff20829ec",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 2.9455000773689763e+21,
          "token_price": 2786.01,
          "created_at": "2025-02-24T02:26:25.292785",
          "usd_value": 8206192.670550742
        },
        {
          "organization_id": "53418429-b2ee-4c5a-b0f0-5b8ff20829ec",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 1726800820252,
          "token_price": 0.6696359056361569,
          "created_at": "2025-02-24T02:26:25.292785",
          "usd_value": 1032996.2795702243
        },
        {
          "organization_id": "53418429-b2ee-4c5a-b0f0-5b8ff20829ec",
          "token_address": "0x821a278dfff762c76410264303f25bf42e195c0c",
          "token_symbol": "pETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PETH.webp",
          "token_value": 80000000000000000000,
          "token_price": 2779.417476966335,
          "created_at": "2025-02-24T02:26:25.292785",
          "usd_value": 222353.3981573068
        },
        {
          "organization_id": "53418429-b2ee-4c5a-b0f0-5b8ff20829ec",
          "token_address": "0x3415cf1a6459b62a34656e53e4048233775ac0ac",
          "token_symbol": "iJPEG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/IJPEG.webp",
          "token_value": 47202226387208990000,
          "token_price": 1864.4291,
          "created_at": "2025-02-24T02:26:25.292785",
          "usd_value": 88005.20446110031
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 29785271.77
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "6272fda9-f5e0-45c0-a270-ad49bc831043",
      "uniqueKey": "5a1b156e-bf8c-44e2-b12a-dc279ef6a7b7",
      "daoName": "Solend",
      "title": "Solend",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/6272fda9-f5e0-45c0-a270-ad49bc831043.webp",
      "totalNumMembers": 50614,
      "totalNumProposals": 12,
      "totalNumVotes": 444,
      "activeMembers": 275,
      "totalValueUSD": 28266952,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "9RuqAN42PTUi9ya59k9suGATrkqzvb9gk2QABJtQzGP5",
      "mainTreasuryTitle": "Solana",
      "mainTreasuryAum": 63189.746,
      "tokens": [
        {
          "organization_id": "6272fda9-f5e0-45c0-a270-ad49bc831043",
          "token_address": "374ee6cb-9987-4e8c-8e73-825653249734",
          "token_symbol": "SLND",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SLND.webp",
          "token_value": 43029953488868,
          "token_price": 0.396985065,
          "created_at": "2023-05-10T09:01:56.492775",
          "usd_value": 17082248.88272524
        },
        {
          "organization_id": "6272fda9-f5e0-45c0-a270-ad49bc831043",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 11158239013553,
          "token_price": 1.000467969116142,
          "created_at": "2023-05-10T09:01:56.492775",
          "usd_value": 11167898.998469116
        },
        {
          "organization_id": "6272fda9-f5e0-45c0-a270-ad49bc831043",
          "token_address": "49d64a3a-c004-485c-bd39-8f394ffd3e1c",
          "token_symbol": "SOL",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SOL.webp",
          "token_value": 253032022378,
          "token_price": 20.533259918600002,
          "created_at": "2023-05-10T09:01:56.492775",
          "usd_value": 5195.5722832164865
        },
        {
          "organization_id": "6272fda9-f5e0-45c0-a270-ad49bc831043",
          "token_address": "11111111111111111111111111111111",
          "token_symbol": "SOL",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SOL.webp",
          "token_value": 188015617338,
          "token_price": 20.5710693474,
          "created_at": "2023-05-10T09:01:56.492775",
          "usd_value": 3867.68230265422
        },
        {
          "organization_id": "6272fda9-f5e0-45c0-a270-ad49bc831043",
          "token_address": "c227e5bd-ae49-46da-a3fc-b4c818e0e746",
          "token_symbol": "UXD",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UXD.webp",
          "token_value": 3497374072,
          "token_price": 1.0008919235,
          "created_at": "2023-05-10T09:01:56.492775",
          "usd_value": 3500.4934621231077
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/solana.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 28266952.86
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "a1679a54-6e9a-4b03-b3da-fdcc7aeb28cd",
      "uniqueKey": "7ff2a8bd-7532-4219-b42c-c6788be7cc06",
      "daoName": "Yearn Finance",
      "title": "Yearn Finance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/a1679a54-6e9a-4b03-b3da-fdcc7aeb28cd.webp",
      "totalNumMembers": 52285,
      "totalNumProposals": 128,
      "totalNumVotes": 14547,
      "activeMembers": 6532,
      "totalValueUSD": 28221772,
      "change24hPercentage": 0,
      "change1WeekPercentage": -6.6537685,
      "mainTreasuryAddress": "0x93a62da5a14c80f265dabc077fcee437b1a0efde",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 15971219,
      "tokens": [
        {
          "organization_id": "a1679a54-6e9a-4b03-b3da-fdcc7aeb28cd",
          "token_address": "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
          "token_symbol": "YFI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VEYFI.webp",
          "token_value": 2.661851653847326e+21,
          "token_price": 7409.947295521803,
          "created_at": "2025-11-24T02:24:57.325244",
          "usd_value": 10872635.903402714
        },
        {
          "organization_id": "a1679a54-6e9a-4b03-b3da-fdcc7aeb28cd",
          "token_address": "0xdc035d45d973e3ec169d2276ddab16f1e407384f",
          "token_symbol": "USDS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDS.webp",
          "token_value": 9.666752e+22,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:24:57.325244",
          "usd_value": 96657.853248
        },
        {
          "organization_id": "a1679a54-6e9a-4b03-b3da-fdcc7aeb28cd",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 55317549,
          "token_price": 88015.08,
          "created_at": "2025-11-24T02:24:57.325244",
          "usd_value": 48687.785006389204
        },
        {
          "organization_id": "a1679a54-6e9a-4b03-b3da-fdcc7aeb28cd",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 5685046867276272000,
          "token_price": 2863.55,
          "created_at": "2025-11-24T02:24:57.325244",
          "usd_value": 16277.645025212581
        },
        {
          "organization_id": "a1679a54-6e9a-4b03-b3da-fdcc7aeb28cd",
          "token_address": "0x04c154b66cb340f3ae24111cc767e0184ed00cc6",
          "token_symbol": "pxETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PXETH.webp",
          "token_value": 3575160814204489000,
          "token_price": 2863.23,
          "created_at": "2025-11-24T02:24:57.325244",
          "usd_value": 10236.50769805472
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 28221772.32
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "89cd885e-e653-445f-b59b-a539111b756a",
      "uniqueKey": "998ad658-fcc4-4910-8e38-63e49190d39b",
      "daoName": "Origin",
      "title": "Origin",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/89cd885e-e653-445f-b59b-a539111b756a.webp",
      "totalNumMembers": 46355,
      "totalNumProposals": 376,
      "totalNumVotes": 2075,
      "activeMembers": 482,
      "totalValueUSD": 27952170,
      "change24hPercentage": 0,
      "change1WeekPercentage": -8.623685,
      "mainTreasuryAddress": "0xe011fa2a6df98c69383457d87a056ed0103aa352",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0.0304537,
      "tokens": [
        {
          "organization_id": "89cd885e-e653-445f-b59b-a539111b756a",
          "token_address": "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
          "token_symbol": "OGN",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/OGN.webp",
          "token_value": 1.3795507117866554e+26,
          "token_price": 0.03524,
          "created_at": "2025-11-24T02:03:47.186649",
          "usd_value": 4861536.708336174
        },
        {
          "organization_id": "89cd885e-e653-445f-b59b-a539111b756a",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 3624865330,
          "token_price": 87439.52,
          "created_at": "2025-11-24T02:03:47.186649",
          "usd_value": 3169564.845198416
        },
        {
          "organization_id": "89cd885e-e653-445f-b59b-a539111b756a",
          "token_address": "0xdbfefd2e8460a6ee4955a68582f85708baea60a3",
          "token_symbol": "superOETHb",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUPEROETHB.webp",
          "token_value": 90618855357307420000,
          "token_price": 2827.29889476436,
          "created_at": "2025-11-24T02:03:47.186649",
          "usd_value": 256206.58959652667
        },
        {
          "organization_id": "89cd885e-e653-445f-b59b-a539111b756a",
          "token_address": "0x2a8e1e676ec238d8a992307b495b45b3feaa5e86",
          "token_symbol": "OUSD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/OUSD.webp",
          "token_value": 1.87326350313468e+22,
          "token_price": 0.999171000286328,
          "created_at": "2025-11-24T02:03:47.186649",
          "usd_value": 18717.10568226949
        },
        {
          "organization_id": "89cd885e-e653-445f-b59b-a539111b756a",
          "token_address": "0x856c4efb76c1d1ae02e20ceb03a2a6a08b0b8dc3",
          "token_symbol": "OETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/OETH.webp",
          "token_value": 2028431875634418000,
          "token_price": 2830.843636081141,
          "created_at": "2025-11-24T02:03:47.186649",
          "usd_value": 5742.173466363824
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 27952170.76
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "9d99975b-650d-4c8e-bf11-75d8874bb035",
      "uniqueKey": "d74eea55-f969-415a-bf32-c6befb3ad8e4",
      "daoName": "0x Protocol",
      "title": "0x Protocol",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/9d99975b-650d-4c8e-bf11-75d8874bb035.webp",
      "totalNumMembers": 190393,
      "totalNumProposals": 34,
      "totalNumVotes": 2157,
      "activeMembers": 621,
      "totalValueUSD": 27667826,
      "change24hPercentage": 0,
      "change1WeekPercentage": -12.517913,
      "mainTreasuryAddress": "0xb6a1f58c5df9f13312639cddda0d128bf28cdd87",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "9d99975b-650d-4c8e-bf11-75d8874bb035",
          "token_address": "0xe41d2489571d322189246dafa5ebde1f4699f498",
          "token_symbol": "ZRX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ZRX.webp",
          "token_value": 1.5221432093723702e+26,
          "token_price": 0.157401,
          "created_at": "2025-11-24T02:24:26.294239",
          "usd_value": 23958686.329842046
        },
        {
          "organization_id": "9d99975b-650d-4c8e-bf11-75d8874bb035",
          "token_address": "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
          "token_symbol": "MATIC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MATIC.webp",
          "token_value": 2.703327817189105e+24,
          "token_price": 0.1356899473169504,
          "created_at": "2025-11-24T02:24:26.294239",
          "usd_value": 366814.4090948362
        },
        {
          "organization_id": "9d99975b-650d-4c8e-bf11-75d8874bb035",
          "token_address": "0xc00e94cb662c3520282e6f5717214004a7f26888",
          "token_symbol": "COMP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CUNI.webp",
          "token_value": 1.242764790476294e+21,
          "token_price": 29.09,
          "created_at": "2025-11-24T02:24:26.294239",
          "usd_value": 36152.027754955394
        },
        {
          "organization_id": "9d99975b-650d-4c8e-bf11-75d8874bb035",
          "token_address": "0x4200000000000000000000000000000000000042",
          "token_symbol": "OP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/optimism-token.png",
          "token_value": 1.190267702142779e+21,
          "token_price": 0.31,
          "created_at": "2025-11-24T02:24:26.294239",
          "usd_value": 368.9829876642615
        },
        {
          "organization_id": "9d99975b-650d-4c8e-bf11-75d8874bb035",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 98594594594594600,
          "token_price": 2863.43,
          "created_at": "2025-11-24T02:24:26.294239",
          "usd_value": 282.31872
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 27667825.8
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "4a7784af-e555-4901-b915-63022d22f04d",
      "uniqueKey": "55e82778-07bf-4eae-85c2-d2f40168bb2b",
      "daoName": "SushiSwap",
      "title": "SushiSwap",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/4a7784af-e555-4901-b915-63022d22f04d.webp",
      "totalNumMembers": 123687,
      "totalNumProposals": 307,
      "totalNumVotes": 50790,
      "activeMembers": 12031,
      "totalValueUSD": 26566710,
      "change24hPercentage": 0,
      "change1WeekPercentage": -5.3270607,
      "mainTreasuryAddress": "0x978982772b8e4055b921bf9295c0d74eb36bc54e",
      "mainTreasuryTitle": "Arbitrum",
      "mainTreasuryAum": 1262392.2,
      "tokens": [
        {
          "organization_id": "4a7784af-e555-4901-b915-63022d22f04d",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 9647832431944,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:22:54.865662",
          "usd_value": 9649762.384420883
        },
        {
          "organization_id": "4a7784af-e555-4901-b915-63022d22f04d",
          "token_address": "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
          "token_symbol": "SUSHI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUSHIPOWAH.webp",
          "token_value": 1.3959985008462214e+25,
          "token_price": 0.4113,
          "created_at": "2025-11-24T02:22:54.865662",
          "usd_value": 5741741.833980509
        },
        {
          "organization_id": "4a7784af-e555-4901-b915-63022d22f04d",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 1.2109499985304918e+21,
          "token_price": 2860.25,
          "created_at": "2025-11-24T02:22:54.865662",
          "usd_value": 3463619.7332968395
        },
        {
          "organization_id": "4a7784af-e555-4901-b915-63022d22f04d",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 3683737622,
          "token_price": 87979.31,
          "created_at": "2025-11-24T02:22:54.865662",
          "usd_value": 3240926.9420460085
        },
        {
          "organization_id": "4a7784af-e555-4901-b915-63022d22f04d",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 662793495744498200000,
          "token_price": 2860.25,
          "created_at": "2025-11-24T02:22:54.865662",
          "usd_value": 1895755.0962032012
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/arbitrum.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 26566710.37
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "52bf381b-79a8-4498-8504-41961beda494",
      "uniqueKey": "1a2423b6-665a-495c-9bd1-a1b3f5fef90b",
      "daoName": "Compound Finance",
      "title": "Compound Finance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/52bf381b-79a8-4498-8504-41961beda494.webp",
      "totalNumMembers": 219374,
      "totalNumProposals": 431,
      "totalNumVotes": 19839,
      "activeMembers": 5206,
      "totalValueUSD": 23758160,
      "change24hPercentage": 0,
      "change1WeekPercentage": 8.763112,
      "mainTreasuryAddress": "0xf1d8c2eed95d5fc2eade4e6bb15a5969453e89a9",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0.0147148315,
      "tokens": [
        {
          "organization_id": "52bf381b-79a8-4498-8504-41961beda494",
          "token_address": "0xc00e94cb662c3520282e6f5717214004a7f26888",
          "token_symbol": "COMP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CUNI.webp",
          "token_value": 3.584777189108136e+23,
          "token_price": 29.12,
          "created_at": "2025-11-24T02:26:45.159705",
          "usd_value": 10438871.174682895
        },
        {
          "organization_id": "52bf381b-79a8-4498-8504-41961beda494",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 3.001532310317669e+21,
          "token_price": 2859.45,
          "created_at": "2025-11-24T02:26:45.159705",
          "usd_value": 8582598.287912343
        },
        {
          "organization_id": "52bf381b-79a8-4498-8504-41961beda494",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 712230020,
          "token_price": 87904.59,
          "created_at": "2025-11-24T02:26:45.159705",
          "usd_value": 626082.878937918
        },
        {
          "organization_id": "52bf381b-79a8-4498-8504-41961beda494",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 227561895709,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:26:45.159705",
          "usd_value": 227607.4171924385
        },
        {
          "organization_id": "52bf381b-79a8-4498-8504-41961beda494",
          "token_address": "0x9e1028f5f1d5ede59748ffcee5532509976840e0",
          "token_symbol": "COMP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/COMP.webp",
          "token_value": 3.586074245e+21,
          "token_price": 29.12,
          "created_at": "2025-11-24T02:26:45.159705",
          "usd_value": 104426.4820144
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 23758160.46
        },
        "protocol": {
          "name": "protocol",
          "value": 872178.09
        },
        "vesting": {
          "name": "vesting",
          "value": 0.31
        }
      },
      "isPremium": true,
      "isDefaultPremium": true
    },
    {
      "organizationId": "a697b304-286c-40af-aa76-8efdc5086797",
      "uniqueKey": "e581cf2c-f17d-4986-9aef-29c6cb4d2c82",
      "daoName": "Aevo (fka Ribbon Finance)",
      "title": "Aevo (fka Ribbon Finance)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/a697b304-286c-40af-aa76-8efdc5086797.webp",
      "totalNumMembers": 40973,
      "totalNumProposals": 73,
      "totalNumVotes": 7109,
      "activeMembers": 1793,
      "totalValueUSD": 23397774,
      "change24hPercentage": 0,
      "change1WeekPercentage": -6.620401,
      "mainTreasuryAddress": "0x6adeb4fddb63f08e03d6f5b9f653be8b65341b35",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 7184.166,
      "tokens": [
        {
          "organization_id": "a697b304-286c-40af-aa76-8efdc5086797",
          "token_address": "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
          "token_symbol": "RBN",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RBN.webp",
          "token_value": 9.312228142040369e+26,
          "token_price": 0.11494642101789322,
          "created_at": "2025-11-24T02:05:47.142359",
          "usd_value": 107040729.66296458
        },
        {
          "organization_id": "a697b304-286c-40af-aa76-8efdc5086797",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 19591851839187,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:05:47.142359",
          "usd_value": 19597731.158534557
        },
        {
          "organization_id": "a697b304-286c-40af-aa76-8efdc5086797",
          "token_address": "0xb528edbef013aff855ac3c50b381f253af13b997",
          "token_symbol": "AEVO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VERBN.webp",
          "token_value": 3.666802365028367e+26,
          "token_price": 0.04782987195569069,
          "created_at": "2025-11-24T02:05:47.142359",
          "usd_value": 17538268.760613058
        },
        {
          "organization_id": "a697b304-286c-40af-aa76-8efdc5086797",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 829905855104647700000,
          "token_price": 2837.58,
          "created_at": "2025-11-24T02:05:47.142359",
          "usd_value": 2354634.040308085
        },
        {
          "organization_id": "a697b304-286c-40af-aa76-8efdc5086797",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 727949748098,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:05:47.142359",
          "usd_value": 727825.9966408233
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 23397773.35
        },
        "private": {
          "name": "private",
          "value": 135065302.78
        },
        "protocol": {
          "name": "protocol",
          "value": 434547.28
        },
        "vesting": {
          "name": "vesting",
          "value": 0
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b8586b8c-dec2-44e6-b78e-3a210a1780c4",
      "uniqueKey": "dcd335a3-8e33-4469-91aa-778794f7b01f",
      "daoName": "Yield Guild Games (YGG)",
      "title": "Yield Guild Games (YGG)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b8586b8c-dec2-44e6-b78e-3a210a1780c4.webp",
      "totalNumMembers": 356,
      "totalNumProposals": 100,
      "totalNumVotes": 212,
      "activeMembers": 125,
      "totalValueUSD": 22978604,
      "change24hPercentage": 0,
      "change1WeekPercentage": -11.116503,
      "mainTreasuryAddress": "0xe30ed74c6633a1b0d34a71c50889f9f0fdb7d68a",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 1301712.8,
      "tokens": [
        {
          "organization_id": "b8586b8c-dec2-44e6-b78e-3a210a1780c4",
          "token_address": "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
          "token_symbol": "YGG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/YGG.webp",
          "token_value": 2.317060837102779e+26,
          "token_price": 0.0895,
          "created_at": "2025-11-24T02:11:21.175759",
          "usd_value": 20737694.492069874
        },
        {
          "organization_id": "b8586b8c-dec2-44e6-b78e-3a210a1780c4",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 11682545327205286000,
          "token_price": 2853.5,
          "created_at": "2025-11-24T02:11:21.175759",
          "usd_value": 33336.14309118028
        },
        {
          "organization_id": "b8586b8c-dec2-44e6-b78e-3a210a1780c4",
          "token_address": "0xa9053dc939d74222f7aa0b3a2be407abbfd56c6a",
          "token_symbol": "YGG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/YGG.webp",
          "token_value": 1.0935493213574187e+23,
          "token_price": 0.08871551561687029,
          "created_at": "2025-11-24T02:11:21.175759",
          "usd_value": 9701.479189670197
        },
        {
          "organization_id": "b8586b8c-dec2-44e6-b78e-3a210a1780c4",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 3084967408938270000,
          "token_price": 2853.5,
          "created_at": "2025-11-24T02:11:21.175759",
          "usd_value": 8802.954501405353
        },
        {
          "organization_id": "b8586b8c-dec2-44e6-b78e-3a210a1780c4",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 6706000000,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:11:21.175759",
          "usd_value": 6708.012403721116
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        },
        {
          "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
          "title": "Gaming",
          "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets"
        },
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 22978604.77
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "f646ab2e-61ca-4de9-b0fa-441ac3d4465c",
      "uniqueKey": "b9a1be7c-793e-4d3d-bd3b-d8f47092bfc8",
      "daoName": "Rhino.fi (formerly: deversi.fi)",
      "title": "Rhino.fi (formerly: deversi.fi)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/f646ab2e-61ca-4de9-b0fa-441ac3d4465c.webp",
      "totalNumMembers": 1109,
      "totalNumProposals": 76,
      "totalNumVotes": 4154,
      "activeMembers": 1069,
      "totalValueUSD": 22313148,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x65d57b1e6570f5c636b8dd64c186ac304a4c0ce9",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 20098882,
      "tokens": [
        {
          "organization_id": "f646ab2e-61ca-4de9-b0fa-441ac3d4465c",
          "token_address": "0xdddddd4301a082e62e84e43f474f044423921918",
          "token_symbol": "DVF",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XDVF.webp",
          "token_value": 4.410323589526836e+25,
          "token_price": 0.4766533400862605,
          "created_at": "2024-08-05T12:24:44.017314",
          "usd_value": 21021954.69809192
        },
        {
          "organization_id": "f646ab2e-61ca-4de9-b0fa-441ac3d4465c",
          "token_address": "0x912ce59144191c1204e64559fe8253a0e49e6548",
          "token_symbol": "ARB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ARB.webp",
          "token_value": 7.1375e+22,
          "token_price": 0.4422,
          "created_at": "2024-08-05T12:24:44.017314",
          "usd_value": 31562.024999999998
        },
        {
          "organization_id": "f646ab2e-61ca-4de9-b0fa-441ac3d4465c",
          "token_address": "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
          "token_symbol": "SUSHI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUSHIPOWAH.webp",
          "token_value": 5.845321105540082e+21,
          "token_price": 0.23407472402390048,
          "created_at": "2024-08-05T12:24:44.017314",
          "usd_value": 1368.2419246103757
        },
        {
          "organization_id": "f646ab2e-61ca-4de9-b0fa-441ac3d4465c",
          "token_address": "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 158501414,
          "token_price": 1,
          "created_at": "2024-08-05T12:24:44.017314",
          "usd_value": 158.501414
        },
        {
          "organization_id": "f646ab2e-61ca-4de9-b0fa-441ac3d4465c",
          "token_address": "matic",
          "token_symbol": "MATIC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MATIC.webp",
          "token_value": 50000000000000000000,
          "token_price": 0.3576,
          "created_at": "2024-08-05T12:24:44.017314",
          "usd_value": 17.88
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 2214265.27
        },
        "vesting": {
          "name": "vesting",
          "value": 20098882.67
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "731aaac8-845c-4f9b-8a10-e50be2286169",
      "uniqueKey": "1eb8d807-f8d3-4212-9f10-8f961e1768af",
      "daoName": "dYdX",
      "title": "dYdX",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/731aaac8-845c-4f9b-8a10-e50be2286169.webp",
      "totalNumMembers": 56925,
      "totalNumProposals": 71,
      "totalNumVotes": 12720,
      "activeMembers": 4299,
      "totalValueUSD": 22140754,
      "change24hPercentage": 0,
      "change1WeekPercentage": -18.256334,
      "mainTreasuryAddress": "0x64c7d40c07efabec2aafdc243bf59eaf2195c6dc",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "731aaac8-845c-4f9b-8a10-e50be2286169",
          "token_address": "0x92d6c1e31e14520e676a687f0a93788b716beff5",
          "token_symbol": "DYDX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DYDX.webp",
          "token_value": 9.997225121601296e+25,
          "token_price": 0.236,
          "created_at": "2025-11-24T02:02:54.094785",
          "usd_value": 23593451.286979057
        },
        {
          "organization_id": "731aaac8-845c-4f9b-8a10-e50be2286169",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 50124301709,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:02:54.094785",
          "usd_value": 50134.32857471494
        },
        {
          "organization_id": "731aaac8-845c-4f9b-8a10-e50be2286169",
          "token_address": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "token_symbol": "SYND",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "token_value": 2e+23,
          "token_price": 0.107947,
          "created_at": "2025-11-24T02:02:54.094785",
          "usd_value": 21589.399999999998
        },
        {
          "organization_id": "731aaac8-845c-4f9b-8a10-e50be2286169",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 419489741088657800,
          "token_price": 2831.806666666667,
          "created_at": "2025-11-24T02:02:54.094785",
          "usd_value": 1187.7905940474923
        },
        {
          "organization_id": "731aaac8-845c-4f9b-8a10-e50be2286169",
          "token_address": "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
          "token_symbol": "MTV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MTV.webp",
          "token_value": 2e+21,
          "token_price": 0.0003095,
          "created_at": "2025-11-24T02:02:54.094785",
          "usd_value": 0.619
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 51479.27
        },
        "project": {
          "name": "project",
          "value": 3.81
        },
        "protocol": {
          "name": "protocol",
          "value": 1525606.58
        },
        "vesting": {
          "name": "vesting",
          "value": 22089274.21
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "4c31770a-e3ca-4cc8-9292-508d632ff66a",
      "uniqueKey": "388edd1c-28aa-4c09-8cb8-6c717a4d0260",
      "daoName": "Radicle",
      "title": "Radicle",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/4c31770a-e3ca-4cc8-9292-508d632ff66a.webp",
      "totalNumMembers": 7315,
      "totalNumProposals": 78,
      "totalNumVotes": 878,
      "activeMembers": 511,
      "totalValueUSD": 21930180,
      "change24hPercentage": 0,
      "change1WeekPercentage": -9.540458,
      "mainTreasuryAddress": "0x2fccd22c591b0019d8157461b5da803aa67cc59d",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 21.02804,
      "tokens": [
        {
          "organization_id": "4c31770a-e3ca-4cc8-9292-508d632ff66a",
          "token_address": "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
          "token_symbol": "RAD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RAD.webp",
          "token_value": 4.842260110447402e+25,
          "token_price": 0.3334528797878376,
          "created_at": "2025-11-24T02:27:38.41557",
          "usd_value": 16146655.785104586
        },
        {
          "organization_id": "4c31770a-e3ca-4cc8-9292-508d632ff66a",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 3313133018735,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:27:38.41557",
          "usd_value": 3313795.777890578
        },
        {
          "organization_id": "4c31770a-e3ca-4cc8-9292-508d632ff66a",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 60000000000000000000,
          "token_price": 2854.47,
          "created_at": "2025-11-24T02:27:38.41557",
          "usd_value": 171268.19999999998
        },
        {
          "organization_id": "4c31770a-e3ca-4cc8-9292-508d632ff66a",
          "token_address": "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
          "token_symbol": "GTC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GTC.webp",
          "token_value": 5e+23,
          "token_price": 0.16,
          "created_at": "2025-11-24T02:27:38.41557",
          "usd_value": 80000
        },
        {
          "organization_id": "4c31770a-e3ca-4cc8-9292-508d632ff66a",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 7366705216980489,
          "token_price": 2854.47,
          "created_at": "2025-11-24T02:27:38.41557",
          "usd_value": 21.028039040714297
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 21930180.83
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "5283ad38-9e60-4743-97f3-8bbeffd60636",
      "uniqueKey": "e58ccfc7-3c02-4e0d-bef0-c22b61b49c97",
      "daoName": "Scroll",
      "title": "Scroll",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/5283ad38-9e60-4743-97f3-8bbeffd60636.webp",
      "totalNumMembers": 185371,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 21334600,
      "change24hPercentage": 0,
      "change1WeekPercentage": -34.662872,
      "mainTreasuryAddress": "0x79d83d1518e2eaa64cdc0631df01b06e2762cc14",
      "mainTreasuryTitle": "Scroll",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "5283ad38-9e60-4743-97f3-8bbeffd60636",
          "token_address": "0xd29687c813d741e2f938f4ac377128810e217b1b",
          "token_symbol": "SCR",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SCR.webp",
          "token_value": 3.0733187083823914e+26,
          "token_price": 0.097,
          "created_at": "2025-11-24T02:22:41.358761",
          "usd_value": 29811191.4713092
        },
        {
          "organization_id": "5283ad38-9e60-4743-97f3-8bbeffd60636",
          "token_address": "scrl",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 900000000000000,
          "token_price": 2856.83,
          "created_at": "2025-11-24T02:22:41.358761",
          "usd_value": 2.571147
        }
      ],
      "chainLogo": null,
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 21334599.14
        },
        "project": {
          "name": "project",
          "value": 6752793.65
        },
        "protocol": {
          "name": "protocol",
          "value": 1723801.25
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "0750f4d3-4755-40d9-b82c-e421439cfd7f",
      "uniqueKey": "a4db7107-0ae9-46be-857e-ec4fb088a36a",
      "daoName": "Tokemak",
      "title": "Tokemak",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/0750f4d3-4755-40d9-b82c-e421439cfd7f.webp",
      "totalNumMembers": 6427,
      "totalNumProposals": 1,
      "totalNumVotes": 181,
      "activeMembers": 181,
      "totalValueUSD": 20864172,
      "change24hPercentage": 0,
      "change1WeekPercentage": -10.533908,
      "mainTreasuryAddress": "0x8b4334d4812c530574bd4f2763fcd22de94a969b",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 20857362,
      "tokens": [
        {
          "organization_id": "0750f4d3-4755-40d9-b82c-e421439cfd7f",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 3173822356839,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:17:16.430226",
          "usd_value": 3174457.2482886575
        },
        {
          "organization_id": "0750f4d3-4755-40d9-b82c-e421439cfd7f",
          "token_address": "0x2e9d63788249371f1dfc918a52f8d799f4a38c94",
          "token_symbol": "TOKE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TOKE.webp",
          "token_value": 1.6213858568922048e+25,
          "token_price": 0.14362759223688115,
          "created_at": "2025-11-24T02:17:16.430226",
          "usd_value": 2328757.4671235974
        },
        {
          "organization_id": "0750f4d3-4755-40d9-b82c-e421439cfd7f",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 38012549550418430000,
          "token_price": 2862.075,
          "created_at": "2025-11-24T02:17:16.430226",
          "usd_value": 108707.52556491703
        },
        {
          "organization_id": "0750f4d3-4755-40d9-b82c-e421439cfd7f",
          "token_address": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "token_symbol": "SYND",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "token_value": 2e+23,
          "token_price": 0.108858,
          "created_at": "2025-11-24T02:17:16.430226",
          "usd_value": 21771.599999999995
        },
        {
          "organization_id": "0750f4d3-4755-40d9-b82c-e421439cfd7f",
          "token_address": "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
          "token_symbol": "CVX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CVX.webp",
          "token_value": 3.1253525008719744e+21,
          "token_price": 1.7152718299539864,
          "created_at": "2025-11-24T02:17:16.430226",
          "usd_value": 5360.829103421939
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 20864172.65
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "d508f46d-35a6-459d-86d2-c28a1be9b165",
      "uniqueKey": "1fa00568-ca81-48a2-9936-d95b72fd44bc",
      "daoName": "Space ID",
      "title": "Space ID",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d508f46d-35a6-459d-86d2-c28a1be9b165.webp",
      "totalNumMembers": 4541,
      "totalNumProposals": 23,
      "totalNumVotes": 31462,
      "activeMembers": 12109,
      "totalValueUSD": 16908460,
      "change24hPercentage": 0,
      "change1WeekPercentage": -5.7971416,
      "mainTreasuryAddress": "0x062a7c8975d6d8a4ad14e05e87affb9ecb9ddca6",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 16908460,
      "tokens": [
        {
          "organization_id": "d508f46d-35a6-459d-86d2-c28a1be9b165",
          "token_address": "0x2dff88a56767223a5529ea5960da7a3f5f766406",
          "token_symbol": "ID",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ID.webp",
          "token_value": 6.302688916833438e+26,
          "token_price": 0.07870864685403063,
          "created_at": "2025-11-24T02:46:07.105087",
          "usd_value": 49590881.25779252
        },
        {
          "organization_id": "d508f46d-35a6-459d-86d2-c28a1be9b165",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 36213344780201470,
          "token_price": 2839.82,
          "created_at": "2025-11-24T02:46:07.105087",
          "usd_value": 102.83938077371175
        },
        {
          "organization_id": "d508f46d-35a6-459d-86d2-c28a1be9b165",
          "token_address": "bsc",
          "token_symbol": "BNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNB.webp",
          "token_value": 54237686000000000,
          "token_price": 847.2,
          "created_at": "2025-11-24T02:46:07.105087",
          "usd_value": 45.9501675792
        },
        {
          "organization_id": "d508f46d-35a6-459d-86d2-c28a1be9b165",
          "token_address": "0xe9a5c635c51002fa5f377f956a8ce58573d63d91",
          "token_symbol": "T99",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/T99.webp",
          "token_value": 2e+22,
          "token_price": 0.00005831330488599211,
          "created_at": "2025-11-24T02:46:07.105087",
          "usd_value": 1.1662660977198422
        },
        {
          "organization_id": "d508f46d-35a6-459d-86d2-c28a1be9b165",
          "token_address": "0xba331eff139710dc3c4f397cd0b9da0691c34cf4",
          "token_symbol": "TYB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TYB.webp",
          "token_value": 1000100000000000000,
          "token_price": 0.20739354230269674,
          "created_at": "2025-11-24T02:46:07.105087",
          "usd_value": 0.20741428165692702
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 16908459.84
        },
        "project": {
          "name": "project",
          "value": 32682571.59
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "2cb4f1b0-309f-4c60-99a5-4c132e17bcbe",
      "uniqueKey": "2d5e1d68-98ce-4805-b887-1d5158d7c1c9",
      "daoName": "Across DAO",
      "title": "Across DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/2cb4f1b0-309f-4c60-99a5-4c132e17bcbe.webp",
      "totalNumMembers": 6881,
      "totalNumProposals": 92,
      "totalNumVotes": 7159,
      "activeMembers": 1082,
      "totalValueUSD": 16284161,
      "change24hPercentage": 0,
      "change1WeekPercentage": -4.502246,
      "mainTreasuryAddress": "0xb524735356985d2f267fa010d681f061dff03715",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 16284161,
      "tokens": [
        {
          "organization_id": "2cb4f1b0-309f-4c60-99a5-4c132e17bcbe",
          "token_address": "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
          "token_symbol": "ACX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ACX.webp",
          "token_value": 2.3090021277160885e+26,
          "token_price": 0.0611,
          "created_at": "2025-11-24T02:47:20.965027",
          "usd_value": 14108003.0003453
        },
        {
          "organization_id": "2cb4f1b0-309f-4c60-99a5-4c132e17bcbe",
          "token_address": "0x04fa0d235c4abf4bcf4787af4cf447de572ef828",
          "token_symbol": "UMA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UMA.webp",
          "token_value": 6.065045401425278e+21,
          "token_price": 0.823,
          "created_at": "2025-11-24T02:47:20.965027",
          "usd_value": 4991.532365373004
        },
        {
          "organization_id": "2cb4f1b0-309f-4c60-99a5-4c132e17bcbe",
          "token_address": "arb",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 250752698452639600,
          "token_price": 2837.82,
          "created_at": "2025-11-24T02:47:20.965027",
          "usd_value": 711.5910227228698
        },
        {
          "organization_id": "2cb4f1b0-309f-4c60-99a5-4c132e17bcbe",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 25000000000000000,
          "token_price": 2837.82,
          "created_at": "2025-11-24T02:47:20.965027",
          "usd_value": 70.94550000000001
        },
        {
          "organization_id": "2cb4f1b0-309f-4c60-99a5-4c132e17bcbe",
          "token_address": "0xac485391eb2d7d88253a7f1ef18c37f4242d1a24",
          "token_symbol": "LSK",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LSK.webp",
          "token_value": 1000000000000000000,
          "token_price": 0.182,
          "created_at": "2025-11-24T02:47:20.965027",
          "usd_value": 0.182
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 16284161.4
        },
        "protocol": {
          "name": "protocol",
          "value": 360034.69
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "50eab83c-1bcd-4c02-8958-1727e2738ea3",
      "uniqueKey": "602b6454-d02a-4400-8f20-d0f7713d2f38",
      "daoName": "PleasrDAO",
      "title": "PleasrDAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/50eab83c-1bcd-4c02-8958-1727e2738ea3.webp",
      "totalNumMembers": 153,
      "totalNumProposals": 62,
      "totalNumVotes": 1115,
      "activeMembers": 101,
      "totalValueUSD": 15472338,
      "change24hPercentage": 0,
      "change1WeekPercentage": -6.480394,
      "mainTreasuryAddress": "0xf5c27c6fe782cbb5c85989ea3e75754748153459",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 5136246,
      "tokens": [
        {
          "organization_id": "50eab83c-1bcd-4c02-8958-1727e2738ea3",
          "token_address": "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
          "token_symbol": "cbETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CBETH.webp",
          "token_value": 925499617610364500000,
          "token_price": 3155.72,
          "created_at": "2025-11-24T02:30:37.568545",
          "usd_value": 2920617.6532853795
        },
        {
          "organization_id": "50eab83c-1bcd-4c02-8958-1727e2738ea3",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 693300764121646900000,
          "token_price": 2857.21,
          "created_at": "2025-11-24T02:30:37.568545",
          "usd_value": 1980905.8762560107
        },
        {
          "organization_id": "50eab83c-1bcd-4c02-8958-1727e2738ea3",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 1903302246292,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:30:37.568545",
          "usd_value": 1903873.4083144942
        },
        {
          "organization_id": "50eab83c-1bcd-4c02-8958-1727e2738ea3",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 13847192438908539000,
          "token_price": 2857.21,
          "created_at": "2025-11-24T02:30:37.568545",
          "usd_value": 39564.33670837387
        },
        {
          "organization_id": "50eab83c-1bcd-4c02-8958-1727e2738ea3",
          "token_address": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "token_symbol": "SYND",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "token_value": 2e+23,
          "token_price": 0.108862,
          "created_at": "2025-11-24T02:30:37.568545",
          "usd_value": 21772.399999999998
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "9137eb61-ce09-4391-aa22-f23fce0cc662",
          "title": "Art & Culture",
          "description": "Promote Web3 creators, their creations, communities & markets; lead ecosystem ideation, discourse and framing"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 15472337.73
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "c15beed6-a0e3-4a05-8377-7f4fca7e76e5",
      "uniqueKey": "df386438-a275-4340-82d9-3b6bfc437444",
      "daoName": "BrainDAO (IQ)",
      "title": "BrainDAO (IQ)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/c15beed6-a0e3-4a05-8377-7f4fca7e76e5.webp",
      "totalNumMembers": 3556,
      "totalNumProposals": 36,
      "totalNumVotes": 352,
      "activeMembers": 93,
      "totalValueUSD": 14691269,
      "change24hPercentage": 0,
      "change1WeekPercentage": -6.6981273,
      "mainTreasuryAddress": "0x56398b89d53e8731bca8c1b06886cfb14bd6b654",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 14691269,
      "tokens": [
        {
          "organization_id": "c15beed6-a0e3-4a05-8377-7f4fca7e76e5",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 2714263552,
          "token_price": 87813.52,
          "created_at": "2025-11-24T02:13:58.375404",
          "usd_value": 2383490.3670882303
        },
        {
          "organization_id": "c15beed6-a0e3-4a05-8377-7f4fca7e76e5",
          "token_address": "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
          "token_symbol": "IQ",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/IQ.webp",
          "token_value": 9.063091618100205e+26,
          "token_price": 0.0018050702426450967,
          "created_at": "2025-11-24T02:13:58.375404",
          "usd_value": 1635951.698619888
        },
        {
          "organization_id": "c15beed6-a0e3-4a05-8377-7f4fca7e76e5",
          "token_address": "0x853d955acef822db058eb8505911ed77f175b99e",
          "token_symbol": "Legacy Frax Dollar",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LEGACY FRAX DOLLAR.webp",
          "token_value": 2.82079059247344e+23,
          "token_price": 0.9949512935058911,
          "created_at": "2025-11-24T02:13:58.375404",
          "usd_value": 280654.92486906983
        },
        {
          "organization_id": "c15beed6-a0e3-4a05-8377-7f4fca7e76e5",
          "token_address": "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
          "token_symbol": "FRAX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LOBI.webp",
          "token_value": 1.708741922441124e+22,
          "token_price": 0.8575019549754183,
          "created_at": "2025-11-24T02:13:58.375404",
          "usd_value": 14652.495390417185
        },
        {
          "organization_id": "c15beed6-a0e3-4a05-8377-7f4fca7e76e5",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 532245932924791360,
          "token_price": 2853,
          "created_at": "2025-11-24T02:13:58.375404",
          "usd_value": 1518.4976466344299
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 14691268.9
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b354c204-1a3a-456a-9dd0-0e1c75096f20",
      "uniqueKey": "e08ca8b4-6bc5-483c-a9aa-adfab402e94c",
      "daoName": "Convex",
      "title": "Convex",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b354c204-1a3a-456a-9dd0-0e1c75096f20.webp",
      "totalNumMembers": 24822,
      "totalNumProposals": 1953,
      "totalNumVotes": 117386,
      "activeMembers": 5512,
      "totalValueUSD": 14521025,
      "change24hPercentage": 0,
      "change1WeekPercentage": -9.410017,
      "mainTreasuryAddress": "0x1389388d01708118b497f59521f6943be2541bb7",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 14459438,
      "tokens": [
        {
          "organization_id": "b354c204-1a3a-456a-9dd0-0e1c75096f20",
          "token_address": "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
          "token_symbol": "CVX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CVX.webp",
          "token_value": 7.327444169832567e+24,
          "token_price": 1.703495410797215,
          "created_at": "2025-11-24T02:39:21.984955",
          "usd_value": 12482267.516182585
        },
        {
          "organization_id": "b354c204-1a3a-456a-9dd0-0e1c75096f20",
          "token_address": "0x365accfca291e7d3914637abf1f7635db165bb09",
          "token_symbol": "FXN",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/FXN.webp",
          "token_value": 5.204138531935899e+21,
          "token_price": 32.335066530125154,
          "created_at": "2025-11-24T02:39:21.984955",
          "usd_value": 168276.16566213514
        },
        {
          "organization_id": "b354c204-1a3a-456a-9dd0-0e1c75096f20",
          "token_address": "0xd533a949740bb3306d119cc777fa900ba034cd52",
          "token_symbol": "CRV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CRV.webp",
          "token_value": 7.95111614298362e+22,
          "token_price": 0.3914,
          "created_at": "2025-11-24T02:39:21.984955",
          "usd_value": 31120.66858363789
        },
        {
          "organization_id": "b354c204-1a3a-456a-9dd0-0e1c75096f20",
          "token_address": "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
          "token_symbol": "crvUSD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CRVUSD.webp",
          "token_value": 2.0988954850333674e+22,
          "token_price": 1.000367916681432,
          "created_at": "2025-11-24T02:39:21.984955",
          "usd_value": 20996.677036948935
        },
        {
          "organization_id": "b354c204-1a3a-456a-9dd0-0e1c75096f20",
          "token_address": "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
          "token_symbol": "FRAX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LOBI.webp",
          "token_value": 1.6810508365679936e+22,
          "token_price": 0.8598139907935182,
          "created_at": "2025-11-24T02:39:21.984955",
          "usd_value": 14453.910285163089
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 14521025.28
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "802dad3e-2e3e-49d3-8fb5-4973c2e1751c",
      "uniqueKey": "49425473-9e78-475d-b427-04b5a1611958",
      "daoName": "Curve",
      "title": "Curve",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/802dad3e-2e3e-49d3-8fb5-4973c2e1751c.webp",
      "totalNumMembers": 88004,
      "totalNumProposals": 221,
      "totalNumVotes": 2103,
      "activeMembers": 813,
      "totalValueUSD": 14520693,
      "change24hPercentage": 0,
      "change1WeekPercentage": -6.9838133,
      "mainTreasuryAddress": "0xe3997288987e6297ad550a69b31439504f513267",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 9673241,
      "tokens": [
        {
          "organization_id": "802dad3e-2e3e-49d3-8fb5-4973c2e1751c",
          "token_address": "0xd533a949740bb3306d119cc777fa900ba034cd52",
          "token_symbol": "CRV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CRV.webp",
          "token_value": 3.651770427370262e+25,
          "token_price": 0.3941,
          "created_at": "2025-11-24T02:31:32.075202",
          "usd_value": 14391627.254266202
        },
        {
          "organization_id": "802dad3e-2e3e-49d3-8fb5-4973c2e1751c",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 2707901771,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:31:32.075202",
          "usd_value": 2708.7143853155944
        },
        {
          "organization_id": "802dad3e-2e3e-49d3-8fb5-4973c2e1751c",
          "token_address": "0xf939e0a03fb07f59a73314e73794be0e57ac1b4e",
          "token_symbol": "crvUSD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CRVUSD.webp",
          "token_value": 237897290178304640000,
          "token_price": 1.0002680768196701,
          "created_at": "2025-11-24T02:31:32.075202",
          "usd_value": 237.96106492726378
        },
        {
          "organization_id": "802dad3e-2e3e-49d3-8fb5-4973c2e1751c",
          "token_address": "0x07d15798a67253d76cea61f0ea6f57aedc59dffb",
          "token_symbol": "BASED",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BASED.webp",
          "token_value": 3.444e+21,
          "token_price": 0.000012216505820770756,
          "created_at": "2025-11-24T02:31:32.075202",
          "usd_value": 0.042073646046734484
        },
        {
          "organization_id": "802dad3e-2e3e-49d3-8fb5-4973c2e1751c",
          "token_address": "0x6021d2c27b6fbd6e7608d1f39b41398caee2f824",
          "token_symbol": "CP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CP.webp",
          "token_value": 1000000000000000000,
          "token_price": 0.01473405094982915,
          "created_at": "2025-11-24T02:31:32.075202",
          "usd_value": 0.01473405094982915
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 14520692.85
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "e3e5927c-b8bc-4c7b-a223-262b730d8f41",
      "uniqueKey": "84f0b757-79ac-414b-91de-2b0cd67abdf0",
      "daoName": "Tokenlon 合约",
      "title": "Tokenlon 合约",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/e3e5927c-b8bc-4c7b-a223-262b730d8f41.webp",
      "totalNumMembers": 40683,
      "totalNumProposals": 47,
      "totalNumVotes": 3153,
      "activeMembers": 1457,
      "totalValueUSD": 13579052,
      "change24hPercentage": 0,
      "change1WeekPercentage": -1.8584648,
      "mainTreasuryAddress": "0x000000000049a1772a9ed1533f0d6b7f54a4814e",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "e3e5927c-b8bc-4c7b-a223-262b730d8f41",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 7877244523177,
          "token_price": 0.99982,
          "created_at": "2025-11-24T02:14:13.685398",
          "usd_value": 7875826.619162828
        },
        {
          "organization_id": "e3e5927c-b8bc-4c7b-a223-262b730d8f41",
          "token_address": "0x0000000000095413afc295d19edeb1ad7b71c952",
          "token_symbol": "LON",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LON.webp",
          "token_value": 1.075240231598426e+25,
          "token_price": 0.44668188419587795,
          "created_at": "2025-11-24T02:14:13.685398",
          "usd_value": 4802903.326135971
        },
        {
          "organization_id": "e3e5927c-b8bc-4c7b-a223-262b730d8f41",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 178010293046,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:14:13.685398",
          "usd_value": 178045.9022264453
        },
        {
          "organization_id": "e3e5927c-b8bc-4c7b-a223-262b730d8f41",
          "token_address": "0x55678cd083fcdc2947a0df635c93c838c89454a3",
          "token_symbol": "LON",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LON.webp",
          "token_value": 4.054153672858738e+23,
          "token_price": 0.4197440975028544,
          "created_at": "2025-11-24T02:14:13.685398",
          "usd_value": 170170.70745519735
        },
        {
          "organization_id": "e3e5927c-b8bc-4c7b-a223-262b730d8f41",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 136626481,
          "token_price": 87846.92,
          "created_at": "2025-11-24T02:14:13.685398",
          "usd_value": 120022.1554628852
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 13579052.31
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "23fbec52-b0bf-4ec5-991d-846985f9b7e8",
      "uniqueKey": "d00098be-0a79-4fb4-b4bd-3f8b6af0261a",
      "daoName": "India Crypto Relief Fund",
      "title": "India Crypto Relief Fund",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1687865613524CryptoRelief",
      "totalNumMembers": null,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 13351074,
      "change24hPercentage": 0.18364768,
      "change1WeekPercentage": -3.848182,
      "mainTreasuryAddress": "0x5c9e5571b17d91e6accd4f0c29bbe199af1f7b09",
      "mainTreasuryTitle": "Binance Smart Chain",
      "mainTreasuryAum": 2652930.8,
      "tokens": [
        {
          "organization_id": "23fbec52-b0bf-4ec5-991d-846985f9b7e8",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 6052015992667,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:12:14.60547",
          "usd_value": 6053832.142309692
        },
        {
          "organization_id": "23fbec52-b0bf-4ec5-991d-846985f9b7e8",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 976792782579772800000,
          "token_price": 2853.2233333333334,
          "created_at": "2025-11-24T02:12:14.60547",
          "usd_value": 2786409.8575143227
        },
        {
          "organization_id": "23fbec52-b0bf-4ec5-991d-846985f9b7e8",
          "token_address": "bsc",
          "token_symbol": "BNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNB.webp",
          "token_value": 2.853641140067472e+21,
          "token_price": 849.3,
          "created_at": "2025-11-24T02:12:14.60547",
          "usd_value": 2423597.420259304
        },
        {
          "organization_id": "23fbec52-b0bf-4ec5-991d-846985f9b7e8",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 1647833949688,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:12:14.60547",
          "usd_value": 1647553.817916553
        },
        {
          "organization_id": "23fbec52-b0bf-4ec5-991d-846985f9b7e8",
          "token_address": "0x2db0d5cb907014c67dc201886624716fb5c71123",
          "token_symbol": "AINU",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AINU.webp",
          "token_value": 2.4995679914509164e+26,
          "token_price": 5.674091355657799e-13,
          "created_at": "2025-11-24T02:12:14.60547",
          "usd_value": 141827.77133170574
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/bsc.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "e5ce3a6b-5db5-4c6d-bb08-37827620328b",
          "title": "Decentralized Science",
          "description": "Conduct cooperative scientific research utilizing blockchain tools and development"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 13351073.59
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "7536003d-e1aa-4cb4-8a45-e6f113ed7b2f",
      "uniqueKey": "bd647a11-4000-4074-a2d8-7c749cd17917",
      "daoName": "Ampera ($AMP)",
      "title": "Ampera ($AMP)",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/7536003d-e1aa-4cb4-8a45-e6f113ed7b2f.webp",
      "totalNumMembers": 98859,
      "totalNumProposals": 5,
      "totalNumVotes": 1121,
      "activeMembers": 714,
      "totalValueUSD": 13243948,
      "change24hPercentage": 0,
      "change1WeekPercentage": -6.8796506,
      "mainTreasuryAddress": "0x0c3a4a4416562ddccfda34e4fe681569fe60c7bd",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 13243948,
      "tokens": [
        {
          "organization_id": "7536003d-e1aa-4cb4-8a45-e6f113ed7b2f",
          "token_address": "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
          "token_symbol": "AMP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AMP.webp",
          "token_value": 5.938990201746742e+27,
          "token_price": 0.00223,
          "created_at": "2025-11-24T02:01:44.527741",
          "usd_value": 13243948.149895236
        },
        {
          "organization_id": "7536003d-e1aa-4cb4-8a45-e6f113ed7b2f",
          "token_address": "0x06450dee7fd2fb8e39061434babcfc05599a6fb8",
          "token_symbol": "XEN",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XEN.webp",
          "token_value": 3.4362e+23,
          "token_price": 1.201e-8,
          "created_at": "2025-11-24T02:01:44.527741",
          "usd_value": 0.004126876200000001
        },
        {
          "organization_id": "7536003d-e1aa-4cb4-8a45-e6f113ed7b2f",
          "token_address": "0x4a57e687b9126435a9b19e4a802113e266adebde",
          "token_symbol": "FXC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/FXC.webp",
          "token_value": 4.8e+25,
          "token_price": 0,
          "created_at": "2025-11-24T02:01:44.527741",
          "usd_value": 0
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 13243948.15
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "059e8d65-4a18-40c1-9f72-bec363cb5023",
      "uniqueKey": "48c9942b-a5aa-4168-8873-603ad83a8e0d",
      "daoName": "Pangolin",
      "title": "Pangolin",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/059e8d65-4a18-40c1-9f72-bec363cb5023.webp",
      "totalNumMembers": 38268,
      "totalNumProposals": 45,
      "totalNumVotes": 2003,
      "activeMembers": 818,
      "totalValueUSD": 13044236,
      "change24hPercentage": 0,
      "change1WeekPercentage": -28.542976,
      "mainTreasuryAddress": "0x8d2e504087f081a41727a10e193f0d656bbf51f2",
      "mainTreasuryTitle": "Avalanche",
      "mainTreasuryAum": 0.012395154,
      "tokens": [
        {
          "organization_id": "059e8d65-4a18-40c1-9f72-bec363cb5023",
          "token_address": "0x60781c2586d68229fde47564546784ab3faca982",
          "token_symbol": "PNG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PNG.webp",
          "token_value": 3.1362602828345055e+26,
          "token_price": 0.04159,
          "created_at": "2025-11-24T02:30:47.585397",
          "usd_value": 13043706.516308708
        },
        {
          "organization_id": "059e8d65-4a18-40c1-9f72-bec363cb5023",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 500000000,
          "token_price": 0.99982,
          "created_at": "2025-11-24T02:30:47.585397",
          "usd_value": 499.91
        },
        {
          "organization_id": "059e8d65-4a18-40c1-9f72-bec363cb5023",
          "token_address": "avax",
          "token_symbol": "AVAX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AVAX.webp",
          "token_value": 2175277085000000000,
          "token_price": 13.43,
          "created_at": "2025-11-24T02:30:47.585397",
          "usd_value": 29.213971251549996
        },
        {
          "organization_id": "059e8d65-4a18-40c1-9f72-bec363cb5023",
          "token_address": "0xc7198437980c041c805a1edcba50c1ce5db95118",
          "token_symbol": "USDT.e",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.E.webp",
          "token_value": 207427,
          "token_price": 0.99982,
          "created_at": "2025-11-24T02:30:47.585397",
          "usd_value": 0.20738966314000004
        },
        {
          "organization_id": "059e8d65-4a18-40c1-9f72-bec363cb5023",
          "token_address": "0x07d15798a67253d76cea61f0ea6f57aedc59dffb",
          "token_symbol": "BASED",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BASED.webp",
          "token_value": 1.6332e+22,
          "token_price": 0.000012201540952814709,
          "created_at": "2025-11-24T02:30:47.585397",
          "usd_value": 0.19927556684136982
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/avalanche.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 245910.27
        },
        "vesting": {
          "name": "vesting",
          "value": 12798325.78
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "1a2dfd63-2cc5-4a39-ab3d-ca2fdd0788c3",
      "uniqueKey": "f7076820-f880-4abc-bee0-cde00297fbc5",
      "daoName": "MEOW DAO",
      "title": "MEOW DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/1a2dfd63-2cc5-4a39-ab3d-ca2fdd0788c3.webp",
      "totalNumMembers": 10151,
      "totalNumProposals": 23,
      "totalNumVotes": 1375,
      "activeMembers": 1284,
      "totalValueUSD": 13006769,
      "change24hPercentage": 0,
      "change1WeekPercentage": -16.224337,
      "mainTreasuryAddress": "0xef147697d948d609f712397db270234cf155a925",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 13006769,
      "tokens": [
        {
          "organization_id": "1a2dfd63-2cc5-4a39-ab3d-ca2fdd0788c3",
          "token_address": "0x0ec78ed49c2d27b315d462d43b5bab94d2c79bf8",
          "token_symbol": "ZERO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MEOW.webp",
          "token_value": 6.060887224399797e+27,
          "token_price": 0.0021461169289204635,
          "created_at": "2025-11-24T02:48:42.556445",
          "usd_value": 13007372.676562164
        },
        {
          "organization_id": "1a2dfd63-2cc5-4a39-ab3d-ca2fdd0788c3",
          "token_address": "0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4",
          "token_symbol": "TOSHI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TOSHI.webp",
          "token_value": 1.540821503395065e+25,
          "token_price": 0.0003968,
          "created_at": "2025-11-24T02:48:42.556445",
          "usd_value": 6113.979725471618
        },
        {
          "organization_id": "1a2dfd63-2cc5-4a39-ab3d-ca2fdd0788c3",
          "token_address": "base",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1513726937314909000,
          "token_price": 2833.01,
          "created_at": "2025-11-24T02:48:42.556445",
          "usd_value": 4288.40355068251
        },
        {
          "organization_id": "1a2dfd63-2cc5-4a39-ab3d-ca2fdd0788c3",
          "token_address": "0x4200000000000000000000000000000000000006",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 1454224510000000000,
          "token_price": 2833.01,
          "created_at": "2025-11-24T02:48:42.556445",
          "usd_value": 4119.8325790751005
        },
        {
          "organization_id": "1a2dfd63-2cc5-4a39-ab3d-ca2fdd0788c3",
          "token_address": "0xb8d98a102b0079b69ffbc760c8d857a31653e56e",
          "token_symbol": "toby",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TOBY.webp",
          "token_value": 5.91550071e+26,
          "token_price": 1.2104846598712881e-8,
          "created_at": "2025-11-24T02:48:42.556445",
          "usd_value": 7.160622864912713
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 13006769.27
        },
        "project": {
          "name": "project",
          "value": 15300.36
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "09f20643-887e-4295-bdf5-7ac31f90c61f",
      "uniqueKey": "65bde23c-0dc8-4c07-b68a-535ac3dcd36e",
      "daoName": "AxonDAO",
      "title": "AxonDAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/09f20643-887e-4295-bdf5-7ac31f90c61f.webp",
      "totalNumMembers": 23365,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 12674073,
      "change24hPercentage": 0,
      "change1WeekPercentage": -21.391764,
      "mainTreasuryAddress": "0x2322f9c0c2f09677cb0892699a5936ed1a937b56",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 6348.603,
      "tokens": [
        {
          "organization_id": "09f20643-887e-4295-bdf5-7ac31f90c61f",
          "token_address": "0xdd66781d0e9a08d4fbb5ec7bac80b691be27f21d",
          "token_symbol": "AXGT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AXGT.webp",
          "token_value": 5.2944546723109154e+26,
          "token_price": 0.023550289489891615,
          "created_at": "2025-11-24T02:47:30.831399",
          "usd_value": 12468594.022403132
        },
        {
          "organization_id": "09f20643-887e-4295-bdf5-7ac31f90c61f",
          "token_address": "0x9b700b043e9587dde9a0c29a9483e2f8fa450d54",
          "token_symbol": "AXGT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AXGT.webp",
          "token_value": 6.2208e+23,
          "token_price": 0.023717463529636437,
          "created_at": "2025-11-24T02:47:30.831399",
          "usd_value": 14754.159712516235
        },
        {
          "organization_id": "09f20643-887e-4295-bdf5-7ac31f90c61f",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 44708893536318670,
          "token_price": 2835.39,
          "created_at": "2025-11-24T02:47:30.831399",
          "usd_value": 126.76714964394259
        },
        {
          "organization_id": "09f20643-887e-4295-bdf5-7ac31f90c61f",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 15916781465769396,
          "token_price": 2835.39,
          "created_at": "2025-11-24T02:47:30.831399",
          "usd_value": 45.13028300022789
        },
        {
          "organization_id": "09f20643-887e-4295-bdf5-7ac31f90c61f",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 4570000,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:47:30.831399",
          "usd_value": 4.571371411423427
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 12674073.23
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "9c2bf476-e1b6-46f6-977a-81e1b3f5f55b",
      "uniqueKey": "39ef6e12-b9de-454f-9bb2-6b5ec6780f84",
      "daoName": "ChainGPT AI",
      "title": "ChainGPT AI",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/9c2bf476-e1b6-46f6-977a-81e1b3f5f55b.webp",
      "totalNumMembers": 63178,
      "totalNumProposals": 56,
      "totalNumVotes": 1987,
      "activeMembers": 869,
      "totalValueUSD": 12594175,
      "change24hPercentage": 0,
      "change1WeekPercentage": -8.53892,
      "mainTreasuryAddress": "0x1d84a19d1072982f63c6530c4b92135e7d140861",
      "mainTreasuryTitle": "Binance Smart Chain",
      "mainTreasuryAum": 0.0010727734,
      "tokens": [
        {
          "organization_id": "9c2bf476-e1b6-46f6-977a-81e1b3f5f55b",
          "token_address": "0x9840652dc04fb9db2c43853633f0f62be6f00f98",
          "token_symbol": "CGPT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CGPT.webp",
          "token_value": 2.6018261902183932e+26,
          "token_price": 0.038674121198530274,
          "created_at": "2025-11-24T02:10:58.642564",
          "usd_value": 10062334.141801644
        },
        {
          "organization_id": "9c2bf476-e1b6-46f6-977a-81e1b3f5f55b",
          "token_address": "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
          "token_symbol": "USDC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 8.221693961798629e+23,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:10:58.642564",
          "usd_value": 822416.1210161676
        },
        {
          "organization_id": "9c2bf476-e1b6-46f6-977a-81e1b3f5f55b",
          "token_address": "0x55d398326f99059ff775485246999027b3197955",
          "token_symbol": "USDT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 2.791115207121418e+23,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:10:58.642564",
          "usd_value": 279064.0717536207
        },
        {
          "organization_id": "9c2bf476-e1b6-46f6-977a-81e1b3f5f55b",
          "token_address": "bsc",
          "token_symbol": "BNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNB.webp",
          "token_value": 8587098497196550000,
          "token_price": 848.88,
          "created_at": "2025-11-24T02:10:58.642564",
          "usd_value": 7290.284076371273
        },
        {
          "organization_id": "9c2bf476-e1b6-46f6-977a-81e1b3f5f55b",
          "token_address": "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
          "token_symbol": "Cake",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CAKE.webp",
          "token_value": 3.0017027699112694e+21,
          "token_price": 2.2768177122477256,
          "created_at": "2025-11-24T02:10:58.642564",
          "usd_value": 6834.330033437038
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/bsc.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 8374002.34
        },
        "vesting": {
          "name": "vesting",
          "value": 4220172.89
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "ae059561-070d-4046-9736-aa805bc32fb0",
      "uniqueKey": "d8e1dbe6-b6f4-4fae-ab78-1f93967ba91c",
      "daoName": "Hector Network",
      "title": "Hector Network",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/ae059561-070d-4046-9736-aa805bc32fb0.webp",
      "totalNumMembers": 10919,
      "totalNumProposals": 75,
      "totalNumVotes": 23616,
      "activeMembers": 6685,
      "totalValueUSD": 12093832,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x3cdf52cc28d21c5b7b91d7065fd6dfe6d426fcc5",
      "mainTreasuryTitle": "Binance Smart Chain",
      "mainTreasuryAum": 2.7797053,
      "tokens": [
        {
          "organization_id": "ae059561-070d-4046-9736-aa805bc32fb0",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 9121604818123,
          "token_price": 1,
          "created_at": "2024-01-14T02:25:50.987709",
          "usd_value": 9121604.818123
        },
        {
          "organization_id": "ae059561-070d-4046-9736-aa805bc32fb0",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 2944092590615,
          "token_price": 0.999775,
          "created_at": "2024-01-14T02:25:50.987709",
          "usd_value": 2943430.1697821114
        },
        {
          "organization_id": "ae059561-070d-4046-9736-aa805bc32fb0",
          "token_address": "0x5c4fdfc5233f935f20d2adba572f770c2e377ab0",
          "token_symbol": "HEC",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/HEC.webp",
          "token_value": 154662055717276,
          "token_price": 0.18562543962576003,
          "created_at": "2024-01-14T02:25:50.987709",
          "usd_value": 28709.21208594315
        },
        {
          "organization_id": "ae059561-070d-4046-9736-aa805bc32fb0",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 30000000000000000,
          "token_price": 2557.58,
          "created_at": "2024-01-14T02:25:50.987709",
          "usd_value": 76.72739999999999
        },
        {
          "organization_id": "ae059561-070d-4046-9736-aa805bc32fb0",
          "token_address": "0x321162cd933e2be498cd2267a90534a804051b11",
          "token_symbol": "BTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BTC.webp",
          "token_value": 235691,
          "token_price": 2041.4103895316978,
          "created_at": "2024-01-14T02:25:50.987709",
          "usd_value": 4.811420561191153
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/bsc.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 12065122.43
        },
        "vesting": {
          "name": "vesting",
          "value": 28709.21
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "fe4cd05c-f6cb-461a-add9-bcdb1365fc0e",
      "uniqueKey": "29a2d3e7-dcff-4f3f-8621-9a3345d2f444",
      "daoName": "Badger DAO",
      "title": "Badger DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/fe4cd05c-f6cb-461a-add9-bcdb1365fc0e.webp",
      "totalNumMembers": 30766,
      "totalNumProposals": 164,
      "totalNumVotes": 72300,
      "activeMembers": 11260,
      "totalValueUSD": 12041208,
      "change24hPercentage": 0,
      "change1WeekPercentage": -8.471484,
      "mainTreasuryAddress": "0x86cbd0ce0c087b482782c181da8d191de18c8275",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 7804.7505,
      "tokens": [
        {
          "organization_id": "fe4cd05c-f6cb-461a-add9-bcdb1365fc0e",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 1731562020,
          "token_price": 87778.01,
          "created_at": "2025-11-24T02:28:26.845257",
          "usd_value": 1519930.683071802
        },
        {
          "organization_id": "fe4cd05c-f6cb-461a-add9-bcdb1365fc0e",
          "token_address": "0x3472a5a71965499acd81997a54bba8d852c6e53d",
          "token_symbol": "BADGER",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BADGER.webp",
          "token_value": 9.117599034680198e+23,
          "token_price": 0.5790728366912202,
          "created_at": "2025-11-24T02:28:26.845257",
          "usd_value": 527975.3936825393
        },
        {
          "organization_id": "fe4cd05c-f6cb-461a-add9-bcdb1365fc0e",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 149163540715,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:28:26.845257",
          "usd_value": 149208.30320596177
        },
        {
          "organization_id": "fe4cd05c-f6cb-461a-add9-bcdb1365fc0e",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 12575372392063754000,
          "token_price": 2854.995,
          "created_at": "2025-11-24T02:28:26.845257",
          "usd_value": 35901.84620989599
        },
        {
          "organization_id": "fe4cd05c-f6cb-461a-add9-bcdb1365fc0e",
          "token_address": "0x912ce59144191c1204e64559fe8253a0e49e6548",
          "token_symbol": "ARB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ARB.webp",
          "token_value": 1.11875e+23,
          "token_price": 0.2059,
          "created_at": "2025-11-24T02:28:26.845257",
          "usd_value": 23035.0625
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 12041207.62
        },
        "vesting": {
          "name": "vesting",
          "value": 0
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "4a8d7f3c-844a-4039-949d-7b748d3242e0",
      "uniqueKey": "f627c39b-83e1-46e9-ae39-ef4dca0779a4",
      "daoName": "Polygon",
      "title": "Polygon",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/4a8d7f3c-844a-4039-949d-7b748d3242e0.webp",
      "totalNumMembers": 640205,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 11882190,
      "change24hPercentage": 0,
      "change1WeekPercentage": 14.297284,
      "mainTreasuryAddress": "0x803b74766d8f79195d4daecf6f2aac31dba78f25",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 1288.1422,
      "tokens": [
        {
          "organization_id": "4a8d7f3c-844a-4039-949d-7b748d3242e0",
          "token_address": "0x455e53cbb86018ac2b8092fdcd39d8444affc3f6",
          "token_symbol": "POL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/POL.webp",
          "token_value": 3.588924180191861e+27,
          "token_price": 0.1347184836193048,
          "created_at": "2025-11-24T02:07:23.259274",
          "usd_value": 483494423.38010424
        },
        {
          "organization_id": "4a8d7f3c-844a-4039-949d-7b748d3242e0",
          "token_address": "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
          "token_symbol": "MATIC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MATIC.webp",
          "token_value": 3.415460186081646e+25,
          "token_price": 0.13518226545292783,
          "created_at": "2025-11-24T02:07:23.259274",
          "usd_value": 4617096.455187953
        },
        {
          "organization_id": "4a8d7f3c-844a-4039-949d-7b748d3242e0",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 1122988549314,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:07:23.259274",
          "usd_value": 1123325.5469780932
        },
        {
          "organization_id": "4a8d7f3c-844a-4039-949d-7b748d3242e0",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 41839131320943440000,
          "token_price": 2851.168,
          "created_at": "2025-11-24T02:07:23.259274",
          "usd_value": 119312.37567913238
        },
        {
          "organization_id": "4a8d7f3c-844a-4039-949d-7b748d3242e0",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 108804670751,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:07:23.259274",
          "usd_value": 108786.17395697233
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 11882188.19
        },
        "private": {
          "name": "private",
          "value": 477544781.26
        },
        "project": {
          "name": "project",
          "value": 137865.06
        },
        "protocol": {
          "name": "protocol",
          "value": 3236.93
        },
        "vesting": {
          "name": "vesting",
          "value": 1.42
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "37aba1a5-2f93-4c15-9171-5df14ac4e237",
      "uniqueKey": "0d2fe3d7-565b-47ea-93a6-88cbd22b368b",
      "daoName": "Nouns DAO",
      "title": "Nouns DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/37aba1a5-2f93-4c15-9171-5df14ac4e237.webp",
      "totalNumMembers": 405,
      "totalNumProposals": 914,
      "totalNumVotes": 29211,
      "activeMembers": 3633,
      "totalValueUSD": 11715192,
      "change24hPercentage": 0,
      "change1WeekPercentage": -8.758301,
      "mainTreasuryAddress": "0x0bc3807ec262cb779b38d65b38158acc3bfede10",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 3418.3013,
      "tokens": [
        {
          "organization_id": "37aba1a5-2f93-4c15-9171-5df14ac4e237",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 492577498744362200000,
          "token_price": 2852.86,
          "created_at": "2025-11-24T02:13:42.835929",
          "usd_value": 1405254.6430678412
        },
        {
          "organization_id": "37aba1a5-2f93-4c15-9171-5df14ac4e237",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 704942237834,
          "token_price": 1.0002500650175048,
          "created_at": "2025-11-24T02:13:42.835929",
          "usd_value": 705153.7739641888
        },
        {
          "organization_id": "37aba1a5-2f93-4c15-9171-5df14ac4e237",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 55085858738723725000,
          "token_price": 2852.86,
          "created_at": "2025-11-24T02:13:42.835929",
          "usd_value": 157152.24296135537
        },
        {
          "organization_id": "37aba1a5-2f93-4c15-9171-5df14ac4e237",
          "token_address": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "token_symbol": "SYND",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "token_value": 2e+23,
          "token_price": 0.109362,
          "created_at": "2025-11-24T02:13:42.835929",
          "usd_value": 21872.399999999998
        },
        {
          "organization_id": "37aba1a5-2f93-4c15-9171-5df14ac4e237",
          "token_address": "0x4200000000000000000000000000000000000042",
          "token_symbol": "OP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/optimism-token.png",
          "token_value": 1.190277702142779e+21,
          "token_price": 0.3078,
          "created_at": "2025-11-24T02:13:42.835929",
          "usd_value": 366.36747671954737
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        },
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 11715192.23
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "14314c86-2e63-4f3f-9fc4-1b63353a05e0",
      "uniqueKey": "f288d098-f81a-4ee2-87a1-ce02afc2324a",
      "daoName": "Galxe",
      "title": "Galxe",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/14314c86-2e63-4f3f-9fc4-1b63353a05e0.webp",
      "totalNumMembers": 17772,
      "totalNumProposals": 34,
      "totalNumVotes": 113167,
      "activeMembers": 14050,
      "totalValueUSD": 10665812,
      "change24hPercentage": 0,
      "change1WeekPercentage": -3.3692667,
      "mainTreasuryAddress": "0x177e8892d2cf2d03a39d5889e31f337fc19e6b3c",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 36.199253,
      "tokens": [
        {
          "organization_id": "14314c86-2e63-4f3f-9fc4-1b63353a05e0",
          "token_address": "0x5faa989af96af85384b8a938c2ede4a7378d9875",
          "token_symbol": "GAL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GAL.webp",
          "token_value": 3.5560000855908895e+25,
          "token_price": 0.29992969864493774,
          "created_at": "2025-11-24T02:19:12.577887",
          "usd_value": 10665500.340526484
        },
        {
          "organization_id": "14314c86-2e63-4f3f-9fc4-1b63353a05e0",
          "token_address": "0x5afe3855358e112b5647b952709e6165e1c1eeee",
          "token_symbol": "SAFE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "token_value": 473033234215261400000,
          "token_price": 0.1522,
          "created_at": "2025-11-24T02:19:12.577887",
          "usd_value": 71.99565824756277
        },
        {
          "organization_id": "14314c86-2e63-4f3f-9fc4-1b63353a05e0",
          "token_address": "0xba386a4ca26b85fd057ab1ef86e3dc7bdeb5ce70",
          "token_symbol": "JESUS",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/JESUS.webp",
          "token_value": 1000000000000000000,
          "token_price": 2.1846778781081687e-8,
          "created_at": "2025-11-24T02:19:12.577887",
          "usd_value": 2.1846778781081687e-8
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 311.79
        },
        "vesting": {
          "name": "vesting",
          "value": 10665500.34
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b117a15b-866b-443e-83ec-a0f3e09f0586",
      "uniqueKey": "212cbe30-4ea6-4080-801a-a25511b01b42",
      "daoName": "Metaplex",
      "title": "Metaplex",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b117a15b-866b-443e-83ec-a0f3e09f0586.webp",
      "totalNumMembers": 9,
      "totalNumProposals": 85,
      "totalNumVotes": 228,
      "activeMembers": 7,
      "totalValueUSD": 10373994,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "7FLf6Gk2h3dDeGxDrmohv4jByL8tUKQBMYuWWzveJ7yk",
      "mainTreasuryTitle": "Solana",
      "mainTreasuryAum": 0.03604094,
      "tokens": [
        {
          "organization_id": "b117a15b-866b-443e-83ec-a0f3e09f0586",
          "token_address": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 10333084358680,
          "token_price": 1.0039591,
          "created_at": "2022-12-01T00:09:10.633324",
          "usd_value": 10373994.072964452
        },
        {
          "organization_id": "b117a15b-866b-443e-83ec-a0f3e09f0586",
          "token_address": "11111111111111111111111111111111",
          "token_symbol": "SOL",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SOL.webp",
          "token_value": 18247360,
          "token_price": 14.2099233,
          "created_at": "2022-12-01T00:09:10.633324",
          "usd_value": 0.25932624115296
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/solana.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 10373994.33
        }
      },
      "isPremium": false,
      "isDefaultPremium": false
    },
    {
      "organizationId": "d835036b-392f-4153-8736-b976a21573f4",
      "uniqueKey": "44b92ec3-7d2e-4894-ae53-ff5d7995d9df",
      "daoName": "ParagonsDAO",
      "title": "ParagonsDAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d835036b-392f-4153-8736-b976a21573f4.webp",
      "totalNumMembers": 1526,
      "totalNumProposals": 87,
      "totalNumVotes": 1341,
      "activeMembers": 412,
      "totalValueUSD": 9742606,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x12267aefd8bb461817df348ce16c933e76c1aa0d",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 149.11366,
      "tokens": [
        {
          "organization_id": "d835036b-392f-4153-8736-b976a21573f4",
          "token_address": "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
          "token_symbol": "stETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/STETH.webp",
          "token_value": 2.051406476361783e+21,
          "token_price": 2638.288550186041,
          "created_at": "2024-07-24T02:16:58.460683",
          "usd_value": 5438956.287984438
        },
        {
          "organization_id": "d835036b-392f-4153-8736-b976a21573f4",
          "token_address": "0x375abb85c329753b1ba849a601438ae77eec9893",
          "token_symbol": "PDT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PDAOCONTRCOUN.webp",
          "token_value": 4.0231099007435e+25,
          "token_price": 0.10798727439711024,
          "created_at": "2024-07-24T02:16:58.460683",
          "usd_value": 5285789.198303235
        },
        {
          "organization_id": "d835036b-392f-4153-8736-b976a21573f4",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 2994555128489,
          "token_price": 1.000525,
          "created_at": "2024-07-24T02:16:58.460683",
          "usd_value": 2996332.6609799443
        },
        {
          "organization_id": "d835036b-392f-4153-8736-b976a21573f4",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 586375990599032240000,
          "token_price": 2478.924,
          "created_at": "2024-07-24T02:16:58.460683",
          "usd_value": 1855635.5004142057
        },
        {
          "organization_id": "d835036b-392f-4153-8736-b976a21573f4",
          "token_address": "0xb23d80f5fefcddaa212212f028021b41ded428cf",
          "token_symbol": "PRIME",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PRIME.webp",
          "token_value": 6.544030191430404e+23,
          "token_price": 2.5680993065900717,
          "created_at": "2023-08-14T00:17:29.616717",
          "usd_value": 1680571.9396916914
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        },
        {
          "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
          "title": "Gaming",
          "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 9742605.94
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "06bc203b-b4ba-47f6-871b-eeba6a68945f",
      "uniqueKey": "4b5dfbc6-abe8-4f61-9598-b2528804b4cd",
      "daoName": "Global Coin Research",
      "title": "Global Coin Research",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/06bc203b-b4ba-47f6-871b-eeba6a68945f.webp",
      "totalNumMembers": 714,
      "totalNumProposals": 9,
      "totalNumVotes": 171,
      "activeMembers": 95,
      "totalValueUSD": 9692348,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0xc4ddc2f471a476da1b906727072669f95d37c622",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 9692348,
      "tokens": [
        {
          "organization_id": "06bc203b-b4ba-47f6-871b-eeba6a68945f",
          "token_address": "0x6307b25a665efc992ec1c1bc403c38f3ddd7c661",
          "token_symbol": "GCR",
          "token_decimals": 4,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GCR.webp",
          "token_value": 46704077061,
          "token_price": 1.9990358978045293,
          "created_at": "2023-05-25T00:17:36.402541",
          "usd_value": 9336312.661876805
        },
        {
          "organization_id": "06bc203b-b4ba-47f6-871b-eeba6a68945f",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 217372483770,
          "token_price": 1.0001,
          "created_at": "2023-05-25T00:17:36.402541",
          "usd_value": 217394.221018377
        },
        {
          "organization_id": "06bc203b-b4ba-47f6-871b-eeba6a68945f",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 20717438858382447000,
          "token_price": 1800.69,
          "created_at": "2023-05-25T00:17:36.402541",
          "usd_value": 37305.68497790069
        },
        {
          "organization_id": "06bc203b-b4ba-47f6-871b-eeba6a68945f",
          "token_address": "0x39aa39c021dfbae8fac545936693ac917d5e7563",
          "token_symbol": "cUSDC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CUSDC.webp",
          "token_value": 154956808232545,
          "token_price": 0.022864140355237084,
          "created_at": "2023-05-25T00:17:36.402541",
          "usd_value": 35429.54212428466
        },
        {
          "organization_id": "06bc203b-b4ba-47f6-871b-eeba6a68945f",
          "token_address": "0xbcca60bb61934080951369a648fb03df4f96263c",
          "token_symbol": "aUSDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AUSDC.webp",
          "token_value": 32234246066,
          "token_price": 0.9996,
          "created_at": "2023-05-25T00:17:36.402541",
          "usd_value": 32221.3523675736
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "1c53c9d8-5a64-4e4d-9845-cf3a03976a47",
          "title": "Media & Communications",
          "description": "Build and run platforms and channels for exchange of information & ideas, PR and marketing on Web3"
        },
        {
          "id": "b0ec5a90-63b7-4e1f-8a87-5e48cedfd105",
          "title": "Investments",
          "description": "Invest in crypto assets and projects via Web3, from incubation and VC to full acquisitions"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 9692347.92
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "e9bb5304-b363-44a2-9666-17590478d069",
      "uniqueKey": "bc4db59a-5889-4969-b146-e0953f113cd1",
      "daoName": "1inch",
      "title": "1inch",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/e9bb5304-b363-44a2-9666-17590478d069.webp",
      "totalNumMembers": 109177,
      "totalNumProposals": 99,
      "totalNumVotes": 13316,
      "activeMembers": 1537,
      "totalValueUSD": 9669302,
      "change24hPercentage": 0,
      "change1WeekPercentage": -1.8495008,
      "mainTreasuryAddress": "0x7951c7ef839e26f63da87a42c9a87986507f1c07",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 9326364,
      "tokens": [
        {
          "organization_id": "e9bb5304-b363-44a2-9666-17590478d069",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 4214232462271,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:34:27.445126",
          "usd_value": 4215075.4773664735
        },
        {
          "organization_id": "e9bb5304-b363-44a2-9666-17590478d069",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 257530560548770250000,
          "token_price": 2843.56,
          "created_at": "2025-11-24T02:34:27.445126",
          "usd_value": 732303.6007540611
        },
        {
          "organization_id": "e9bb5304-b363-44a2-9666-17590478d069",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 243452046156389700000,
          "token_price": 2843.56,
          "created_at": "2025-11-24T02:34:27.445126",
          "usd_value": 692270.5003684636
        },
        {
          "organization_id": "e9bb5304-b363-44a2-9666-17590478d069",
          "token_address": "0x111111111117dc0aa78b770fa6a738034120c302",
          "token_symbol": "1INCH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/1INCH.webp",
          "token_value": 2.3184426932041535e+24,
          "token_price": 0.188,
          "created_at": "2025-11-24T02:34:27.445126",
          "usd_value": 435867.2263223808
        },
        {
          "organization_id": "e9bb5304-b363-44a2-9666-17590478d069",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 301984033013,
          "token_price": 0.99982,
          "created_at": "2025-11-24T02:34:27.445126",
          "usd_value": 301929.6758870577
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 9669302.5
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "2a598414-a973-4021-8056-dd5e02e8168b",
      "uniqueKey": "ac82cd8e-1207-433d-b9f4-90d32b4f619e",
      "daoName": "BENQI",
      "title": "BENQI",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/2a598414-a973-4021-8056-dd5e02e8168b.webp",
      "totalNumMembers": 36300,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 9384559,
      "change24hPercentage": 0,
      "change1WeekPercentage": -7.2115793,
      "mainTreasuryAddress": "0x142eb2ed775e6d497aa8d03a2151d016bbfe7fc2",
      "mainTreasuryTitle": "Avalanche",
      "mainTreasuryAum": 5296759,
      "tokens": [
        {
          "organization_id": "2a598414-a973-4021-8056-dd5e02e8168b",
          "token_address": "0x8729438eb15e2c8b576fcc6aecda6a148776c0f5",
          "token_symbol": "QI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/QI.webp",
          "token_value": 2.3505227967679182e+27,
          "token_price": 0.003785,
          "created_at": "2025-11-24T02:25:41.865328",
          "usd_value": 8896728.785766572
        },
        {
          "organization_id": "2a598414-a973-4021-8056-dd5e02e8168b",
          "token_address": "avax",
          "token_symbol": "AVAX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AVAX.webp",
          "token_value": 3.6189185e+22,
          "token_price": 13.48,
          "created_at": "2025-11-24T02:25:41.865328",
          "usd_value": 487830.21379999997
        },
        {
          "organization_id": "2a598414-a973-4021-8056-dd5e02e8168b",
          "token_address": "0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 31291,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:25:41.865328",
          "usd_value": 0.03129725945189038
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/avalanche.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 9384559.03
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "949bdfa3-17e6-4bae-b0ac-3bc4226b8a72",
      "uniqueKey": "94348c94-9470-4f3d-89ec-22ec931111a7",
      "daoName": "Ampleforth",
      "title": "Ampleforth",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/949bdfa3-17e6-4bae-b0ac-3bc4226b8a72.webp",
      "totalNumMembers": 26155,
      "totalNumProposals": 93,
      "totalNumVotes": 1578,
      "activeMembers": 447,
      "totalValueUSD": 9152472,
      "change24hPercentage": 0,
      "change1WeekPercentage": -3.6793063,
      "mainTreasuryAddress": "0x223592a191ecfc7fdc38a9256c3bd96e771539a9",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 9152472,
      "tokens": [
        {
          "organization_id": "949bdfa3-17e6-4bae-b0ac-3bc4226b8a72",
          "token_address": "0x77fba179c79de5b7653f68b5039af940ada60ce0",
          "token_symbol": "FORTH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AMPL.webp",
          "token_value": 1.8515836963440116e+24,
          "token_price": 1.7971,
          "created_at": "2025-11-24T02:36:21.345212",
          "usd_value": 3327481.0606998233
        },
        {
          "organization_id": "949bdfa3-17e6-4bae-b0ac-3bc4226b8a72",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 2538734864573,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:36:21.345212",
          "usd_value": 2539242.713115623
        },
        {
          "organization_id": "949bdfa3-17e6-4bae-b0ac-3bc4226b8a72",
          "token_address": "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
          "token_symbol": "AMPL",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AMPL.webp",
          "token_value": 729548865711357,
          "token_price": 1.2818133063714847,
          "created_at": "2025-11-24T02:36:21.345212",
          "usd_value": 935145.4437170408
        },
        {
          "organization_id": "949bdfa3-17e6-4bae-b0ac-3bc4226b8a72",
          "token_address": "0xedb171c18ce90b633db442f2a6f72874093b49ef",
          "token_symbol": "WAMPL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WAMPL.webp",
          "token_value": 1.3971913023893275e+22,
          "token_price": 1.4720437188946984,
          "created_at": "2025-11-24T02:36:21.345212",
          "usd_value": 20567.266807765125
        },
        {
          "organization_id": "949bdfa3-17e6-4bae-b0ac-3bc4226b8a72",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 4747793453460957000,
          "token_price": 2842.17,
          "created_at": "2025-11-24T02:36:21.345212",
          "usd_value": 13494.03611962313
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 9152472.42
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "ef4d5b4f-8ece-404c-9751-495caf736710",
      "uniqueKey": "290f688e-31be-4f42-8360-742765850c77",
      "daoName": "Prom",
      "title": "Prom",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1688367433439Prom",
      "totalNumMembers": 6979,
      "totalNumProposals": 34,
      "totalNumVotes": 829,
      "activeMembers": 77,
      "totalValueUSD": 9132560,
      "change24hPercentage": 0,
      "change1WeekPercentage": -1.7126752,
      "mainTreasuryAddress": "0x3dd223968c2acb1071dfb327cc0065a5fa4d4b15",
      "mainTreasuryTitle": "Binance Smart Chain",
      "mainTreasuryAum": 1560.408,
      "tokens": [
        {
          "organization_id": "ef4d5b4f-8ece-404c-9751-495caf736710",
          "token_address": "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
          "token_symbol": "PROM",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PROM.webp",
          "token_value": 1e+24,
          "token_price": 9.131,
          "created_at": "2025-11-24T02:07:03.475597",
          "usd_value": 9131000
        },
        {
          "organization_id": "ef4d5b4f-8ece-404c-9751-495caf736710",
          "token_address": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "token_symbol": "WBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "token_value": 1107262,
          "token_price": 87906.8,
          "created_at": "2025-11-24T02:07:03.475597",
          "usd_value": 973.3585918160001
        },
        {
          "organization_id": "ef4d5b4f-8ece-404c-9751-495caf736710",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 204047430000000000,
          "token_price": 2851.52,
          "created_at": "2025-11-24T02:07:03.475597",
          "usd_value": 581.8453275936
        },
        {
          "organization_id": "ef4d5b4f-8ece-404c-9751-495caf736710",
          "token_address": "0x4507cef57c46789ef8d1a19ea45f4216bae2b528",
          "token_symbol": "TOKEN",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TOKEN.webp",
          "token_value": 462809072500,
          "token_price": 0.004740279077546207,
          "created_at": "2025-11-24T02:07:03.475597",
          "usd_value": 2.193844163270316
        },
        {
          "organization_id": "ef4d5b4f-8ece-404c-9751-495caf736710",
          "token_address": "0xbba39fd2935d5769116ce38d46a71bde9cf03099",
          "token_symbol": "CHO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CHO.webp",
          "token_value": 8400000000000000000,
          "token_price": 0.020049090165011968,
          "created_at": "2025-11-24T02:07:03.475597",
          "usd_value": 0.16841235738610053
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/bsc.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "9d644dba-e5b4-4cd9-aacd-57b926067147",
          "title": "Gaming",
          "description": "Buidl games as a technological frontier; serve digital gamers, their communities & markets"
        },
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 1560.41
        },
        "vesting": {
          "name": "vesting",
          "value": 9131000
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "b2f20f6d-9b7a-4d95-aabc-349d15f7d661",
      "uniqueKey": "1dbece3d-a577-4f38-bafd-88ff3cc1809d",
      "daoName": "CypherTrust DAO",
      "title": "CypherTrust DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1688367425195CypherTrustDAO",
      "totalNumMembers": 34,
      "totalNumProposals": 193,
      "totalNumVotes": 995,
      "activeMembers": 35,
      "totalValueUSD": 8815932,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0xbaed5a2e8a9c3f2daa7332a90fea69f775ba9c80",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 21381.973,
      "tokens": [
        {
          "organization_id": "b2f20f6d-9b7a-4d95-aabc-349d15f7d661",
          "token_address": "0xb560e85fd5c5a1494f96ba02e81c4b888f3e4110",
          "token_symbol": "TRUST",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TRUST.webp",
          "token_value": 8.783061e+24,
          "token_price": 1.0013081458217594,
          "created_at": "2024-08-05T02:14:54.828841",
          "usd_value": 8794550.524549408
        },
        {
          "organization_id": "b2f20f6d-9b7a-4d95-aabc-349d15f7d661",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 2706555403907078000,
          "token_price": 2264.59,
          "created_at": "2024-08-05T02:14:54.828841",
          "usd_value": 6129.238302133931
        },
        {
          "organization_id": "b2f20f6d-9b7a-4d95-aabc-349d15f7d661",
          "token_address": "0x4591dbff62656e7859afe5e45f6f47d3669fbb28",
          "token_symbol": "mkUSD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MKUSD.webp",
          "token_value": 5.128910438013601e+21,
          "token_price": 0.9858703675973025,
          "created_at": "2024-08-05T02:14:54.828841",
          "usd_value": 5056.44081889811
        },
        {
          "organization_id": "b2f20f6d-9b7a-4d95-aabc-349d15f7d661",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 4104577030,
          "token_price": 0.99977,
          "created_at": "2024-08-05T02:14:54.828841",
          "usd_value": 4103.6329772831
        },
        {
          "organization_id": "b2f20f6d-9b7a-4d95-aabc-349d15f7d661",
          "token_address": "0x8668a15b7b023dc77b372a740fcb8939e15257cf",
          "token_symbol": "afCVX",
          "token_decimals": 18,
          "token_icon": null,
          "token_value": 1.7622311105651346e+21,
          "token_price": 2.25538416307364,
          "created_at": "2024-08-05T02:14:54.828841",
          "usd_value": 3974.5081384442774
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 8815932.5
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "59b3cb22-a5a2-4aaa-b7fb-360baa910666",
      "uniqueKey": "8fc81a50-1b60-4b43-b4df-8871b2b4ee25",
      "daoName": "SuperRare",
      "title": "SuperRare",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/59b3cb22-a5a2-4aaa-b7fb-360baa910666.webp",
      "totalNumMembers": 11357,
      "totalNumProposals": 30,
      "totalNumVotes": 1411,
      "activeMembers": 610,
      "totalValueUSD": 8489374,
      "change24hPercentage": 0,
      "change1WeekPercentage": -3.0071125,
      "mainTreasuryAddress": "0x860a80d33e85e97888f1f0c75c6e5bbd60b48da9",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 8489374,
      "tokens": [
        {
          "organization_id": "59b3cb22-a5a2-4aaa-b7fb-360baa910666",
          "token_address": "0xba5bde662c17e2adff1075610382b9b691296350",
          "token_symbol": "RARE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RARE.webp",
          "token_value": 1.7547649887741272e+26,
          "token_price": 0.0256,
          "created_at": "2025-11-24T02:28:57.225485",
          "usd_value": 4492198.371261766
        },
        {
          "organization_id": "59b3cb22-a5a2-4aaa-b7fb-360baa910666",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 254060871417480970000,
          "token_price": 2853.9,
          "created_at": "2025-11-24T02:28:57.225485",
          "usd_value": 725064.320938349
        },
        {
          "organization_id": "59b3cb22-a5a2-4aaa-b7fb-360baa910666",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 35190139150000000000,
          "token_price": 2853.9,
          "created_at": "2025-11-24T02:28:57.225485",
          "usd_value": 100429.138120185
        },
        {
          "organization_id": "59b3cb22-a5a2-4aaa-b7fb-360baa910666",
          "token_address": "0x9dfad1b7102d46b1b197b90095b5c4e9f5845bba",
          "token_symbol": "BOTTO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BOTTO.webp",
          "token_value": 1e+24,
          "token_price": 0.08476253036490083,
          "created_at": "2025-11-24T02:28:57.225485",
          "usd_value": 84762.53036490083
        },
        {
          "organization_id": "59b3cb22-a5a2-4aaa-b7fb-360baa910666",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 42255428482,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:28:57.225485",
          "usd_value": 42268.108914674405
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "9137eb61-ce09-4391-aa22-f23fce0cc662",
          "title": "Art & Culture",
          "description": "Promote Web3 creators, their creations, communities & markets; lead ecosystem ideation, discourse and framing"
        },
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 8489374.42
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "dcc378ed-d4e5-4aeb-9cdc-3a75379441d3",
      "uniqueKey": "30e71474-43e5-4306-baee-72fd445594a6",
      "daoName": "Threshold Network",
      "title": "Threshold Network",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/dcc378ed-d4e5-4aeb-9cdc-3a75379441d3.webp",
      "totalNumMembers": 7685,
      "totalNumProposals": 139,
      "totalNumVotes": 1582,
      "activeMembers": 224,
      "totalValueUSD": 8206246.5,
      "change24hPercentage": 0,
      "change1WeekPercentage": -3.9586308,
      "mainTreasuryAddress": "0x2ff7ab212cd6feae21bac5300465e149fb6b85a9",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 99756.734,
      "tokens": [
        {
          "organization_id": "dcc378ed-d4e5-4aeb-9cdc-3a75379441d3",
          "token_address": "0xcdf7028ceab81fa0c6971208e83fa7872994bee5",
          "token_symbol": "T",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/T.webp",
          "token_value": 4.644596141856861e+26,
          "token_price": 0.01151,
          "created_at": "2025-11-24T02:31:03.525202",
          "usd_value": 5345930.159277247
        },
        {
          "organization_id": "dcc378ed-d4e5-4aeb-9cdc-3a75379441d3",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 441273789170,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:31:03.525202",
          "usd_value": 441406.2110333099
        },
        {
          "organization_id": "dcc378ed-d4e5-4aeb-9cdc-3a75379441d3",
          "token_address": "0x18084fba666a33d37592fa2633fd49a74dd93a88",
          "token_symbol": "tBTC",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TBTC.webp",
          "token_value": 3976648777483924000,
          "token_price": 87683.33133651031,
          "created_at": "2025-11-24T02:31:03.525202",
          "usd_value": 348685.8123650516
        },
        {
          "organization_id": "dcc378ed-d4e5-4aeb-9cdc-3a75379441d3",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 67055167390773680000,
          "token_price": 2854.65,
          "created_at": "2025-11-24T02:31:03.525202",
          "usd_value": 191419.03359207208
        },
        {
          "organization_id": "dcc378ed-d4e5-4aeb-9cdc-3a75379441d3",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 30478314880681270000,
          "token_price": 2854.65,
          "created_at": "2025-11-24T02:31:03.525202",
          "usd_value": 87004.9215741368
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 8206246.61
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "8b5c67c6-3b9c-4185-9ca1-4aaee5681784",
      "uniqueKey": "e343c523-f2f9-49b2-be2a-6551b02d1657",
      "daoName": "Magpie",
      "title": "Magpie",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/8b5c67c6-3b9c-4185-9ca1-4aaee5681784.webp",
      "totalNumMembers": 13457,
      "totalNumProposals": 150,
      "totalNumVotes": 5611,
      "activeMembers": 1017,
      "totalValueUSD": 8160625,
      "change24hPercentage": 0,
      "change1WeekPercentage": -6.87067,
      "mainTreasuryAddress": "0xf433c2a2d6facecdd9edd7b8ce9ceaab96f41866",
      "mainTreasuryTitle": "Binance Smart Chain",
      "mainTreasuryAum": 9298.788,
      "tokens": [
        {
          "organization_id": "8b5c67c6-3b9c-4185-9ca1-4aaee5681784",
          "token_address": "0xd06716e1ff2e492cc5034c2e81805562dd3b45fa",
          "token_symbol": "MGP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MGP.webp",
          "token_value": 5.5807208491926904e+26,
          "token_price": 0.015445049505117056,
          "created_at": "2025-11-24T02:47:14.355141",
          "usd_value": 8619450.979002
        },
        {
          "organization_id": "8b5c67c6-3b9c-4185-9ca1-4aaee5681784",
          "token_address": "0xa61f74247455a40b01b0559ff6274441fafa22a3",
          "token_symbol": "MGP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MGP.webp",
          "token_value": 7.688838349970149e+25,
          "token_price": 0.01565468463635651,
          "created_at": "2025-11-24T02:47:14.355141",
          "usd_value": 1203663.3958870643
        },
        {
          "organization_id": "8b5c67c6-3b9c-4185-9ca1-4aaee5681784",
          "token_address": "0x2ac2b254bc18cd4999f64773a966e4f4869c34ee",
          "token_symbol": "PNP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PNP.webp",
          "token_value": 7.3780326607655965e+22,
          "token_price": 2.152282792071705,
          "created_at": "2025-11-24T02:47:14.355141",
          "usd_value": 158796.12735108807
        },
        {
          "organization_id": "8b5c67c6-3b9c-4185-9ca1-4aaee5681784",
          "token_address": "0x5012c90f14d190607662ca8344120812aaa2639d",
          "token_symbol": "PNP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PNP.webp",
          "token_value": 2.8958517052325526e+22,
          "token_price": 2.1016593500097653,
          "created_at": "2025-11-24T02:47:14.355141",
          "usd_value": 60860.93812543717
        },
        {
          "organization_id": "8b5c67c6-3b9c-4185-9ca1-4aaee5681784",
          "token_address": "bsc",
          "token_symbol": "BNB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BNB.webp",
          "token_value": 65999788681799025000,
          "token_price": 847.4857142857143,
          "created_at": "2025-11-24T02:47:14.355141",
          "usd_value": 55928.62159538262
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/bsc.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 8160625.13
        },
        "private": {
          "name": "private",
          "value": 3277701.06
        },
        "project": {
          "name": "project",
          "value": 6254630.83
        },
        "protocol": {
          "name": "protocol",
          "value": 111616.06
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "5a5dc2e8-480d-443b-b258-a438874aa4f8",
      "uniqueKey": "d845f10d-8657-43bc-a4eb-c7425a3b5a4f",
      "daoName": "Euler Finance",
      "title": "Euler Finance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/5a5dc2e8-480d-443b-b258-a438874aa4f8.webp",
      "totalNumMembers": 2633,
      "totalNumProposals": 65,
      "totalNumVotes": 8395,
      "activeMembers": 809,
      "totalValueUSD": 7652158.5,
      "change24hPercentage": 0,
      "change1WeekPercentage": -10.747294,
      "mainTreasuryAddress": "0xd4ee8939a537d943a4e46e7ae04069c9451d724f",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "5a5dc2e8-480d-443b-b258-a438874aa4f8",
          "token_address": "0xd9fcd98c322942075a5c3860693e9f4f03aae07b",
          "token_symbol": "EUL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/EUL.webp",
          "token_value": 1.885707868098628e+24,
          "token_price": 3.909,
          "created_at": "2025-11-24T02:36:42.921712",
          "usd_value": 7371232.056397537
        },
        {
          "organization_id": "5a5dc2e8-480d-443b-b258-a438874aa4f8",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 59512209065584290,
          "token_price": 2841.67,
          "created_at": "2025-11-24T02:36:42.921712",
          "usd_value": 169.11405913539892
        },
        {
          "organization_id": "5a5dc2e8-480d-443b-b258-a438874aa4f8",
          "token_address": "0x437cc33344a0b27a429f795ff6b469c72698b291",
          "token_symbol": "wM",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WM.webp",
          "token_value": 74375036,
          "token_price": 1.0003905770781132,
          "created_at": "2025-11-24T02:36:42.921712",
          "usd_value": 74.40408518424543
        },
        {
          "organization_id": "5a5dc2e8-480d-443b-b258-a438874aa4f8",
          "token_address": "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
          "token_symbol": "MTV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MTV.webp",
          "token_value": 1e+21,
          "token_price": 0.0003102,
          "created_at": "2025-11-24T02:36:42.921712",
          "usd_value": 0.31020000000000003
        },
        {
          "organization_id": "5a5dc2e8-480d-443b-b258-a438874aa4f8",
          "token_address": "0x07d15798a67253d76cea61f0ea6f57aedc59dffb",
          "token_symbol": "BASED",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BASED.webp",
          "token_value": 6.888e+21,
          "token_price": 0.000012154722294495076,
          "created_at": "2025-11-24T02:36:42.921712",
          "usd_value": 0.08372172716448208
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 7652158.5
        },
        "project": {
          "name": "project",
          "value": 169.16
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "e10d5152-4098-419b-a9ec-e9a26c0a975e",
      "uniqueKey": "8e25c716-4d55-4ef4-96e1-5024dcbf86e2",
      "daoName": "Spool",
      "title": "Spool",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/e10d5152-4098-419b-a9ec-e9a26c0a975e.webp",
      "totalNumMembers": 1515,
      "totalNumProposals": 99,
      "totalNumVotes": 1070,
      "activeMembers": 168,
      "totalValueUSD": 7613107,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x53431942db50416d7a563d13d58378a084ddf153",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "e10d5152-4098-419b-a9ec-e9a26c0a975e",
          "token_address": "0x40803cea2b2a32bda1be61d3604af6a814e70976",
          "token_symbol": "SPOOL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PRESPL.webp",
          "token_value": 4.498640236881573e+25,
          "token_price": 0.1443872822356515,
          "created_at": "2024-10-14T02:00:18.647981",
          "usd_value": 6495464.375592778
        },
        {
          "organization_id": "e10d5152-4098-419b-a9ec-e9a26c0a975e",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 7.489069571600456e+23,
          "token_price": 0.5015106896955117,
          "created_at": "2024-10-14T02:00:18.647981",
          "usd_value": 267641.7114726753
        },
        {
          "organization_id": "e10d5152-4098-419b-a9ec-e9a26c0a975e",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 1051779987835,
          "token_price": 0.37710692254938716,
          "created_at": "2024-10-14T02:00:18.647981",
          "usd_value": 140818.49481337468
        },
        {
          "organization_id": "e10d5152-4098-419b-a9ec-e9a26c0a975e",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 20715460241,
          "token_price": 0.99959,
          "created_at": "2024-10-14T02:00:18.647981",
          "usd_value": 20706.966902301192
        },
        {
          "organization_id": "e10d5152-4098-419b-a9ec-e9a26c0a975e",
          "token_address": "0x6021d2c27b6fbd6e7608d1f39b41398caee2f824",
          "token_symbol": "CP",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CP.webp",
          "token_value": 1000000000000000000,
          "token_price": 0.018387555632727426,
          "created_at": "2024-10-14T02:00:18.647981",
          "usd_value": 0.018387555632727426
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 7613107.11
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "d3eb8010-ef2c-4e6c-956e-2cdbdd05cbf5",
      "uniqueKey": "02dd7a12-77e3-45a2-8c0f-0ac224e6f44b",
      "daoName": "DIMO",
      "title": "DIMO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d3eb8010-ef2c-4e6c-956e-2cdbdd05cbf5.webp",
      "totalNumMembers": 53381,
      "totalNumProposals": 35,
      "totalNumVotes": 546,
      "activeMembers": 82,
      "totalValueUSD": 7599190,
      "change24hPercentage": 0,
      "change1WeekPercentage": -12.323815,
      "mainTreasuryAddress": "0xc97bf974d6d4bab6e0f7641b7b37ec5b70922ce5",
      "mainTreasuryTitle": "Polygon",
      "mainTreasuryAum": 6668539.5,
      "tokens": [
        {
          "organization_id": "d3eb8010-ef2c-4e6c-956e-2cdbdd05cbf5",
          "token_address": "0xe261d618a959afffd53168cd07d12e37b26761db",
          "token_symbol": "DIMO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DIMO.webp",
          "token_value": 3.585984563383594e+26,
          "token_price": 0.01964,
          "created_at": "2025-11-24T02:18:43.683685",
          "usd_value": 7042873.68248538
        },
        {
          "organization_id": "d3eb8010-ef2c-4e6c-956e-2cdbdd05cbf5",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 2.8368e+23,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:18:43.683685",
          "usd_value": 283651.632
        },
        {
          "organization_id": "d3eb8010-ef2c-4e6c-956e-2cdbdd05cbf5",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 106451793495,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:18:43.683685",
          "usd_value": 106433.69669010586
        },
        {
          "organization_id": "d3eb8010-ef2c-4e6c-956e-2cdbdd05cbf5",
          "token_address": "0x5fab9761d60419c9eeebe3915a8fa1ed7e8d2e1b",
          "token_symbol": "DIMO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DIMO.webp",
          "token_value": 4.1663537150772384e+24,
          "token_price": 0.01964,
          "created_at": "2025-11-24T02:18:43.683685",
          "usd_value": 81827.18696411696
        },
        {
          "organization_id": "d3eb8010-ef2c-4e6c-956e-2cdbdd05cbf5",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 52843360795,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:18:43.683685",
          "usd_value": 52853.93158131626
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/polygon.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "84f710d8-5ad0-4996-9f8a-a345d58b1b15",
          "title": "Physical Assets",
          "description": "Create, produce, manage or trade assets and any other things that are not online"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 7599189.84
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "01091ef6-e165-4104-8228-ceb07e5c55e2",
      "uniqueKey": "205a9aa9-7451-495c-a050-5270f56debeb",
      "daoName": "Radiant Capital",
      "title": "Radiant Capital",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/01091ef6-e165-4104-8228-ceb07e5c55e2.webp",
      "totalNumMembers": 29919,
      "totalNumProposals": 56,
      "totalNumVotes": 83803,
      "activeMembers": 17444,
      "totalValueUSD": 7569113,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x3c4401ef35a02330d8508b3bcb837f6c9f183393",
      "mainTreasuryTitle": "Arbitrum",
      "mainTreasuryAum": 826.6702,
      "tokens": [
        {
          "organization_id": "01091ef6-e165-4104-8228-ceb07e5c55e2",
          "token_address": "0x0c4681e6c0235179ec3d4f4fc4df3d14fdd96017",
          "token_symbol": "RDNT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RDNT.webp",
          "token_value": 3.1044581318782778e+25,
          "token_price": 0.4109361758296807,
          "created_at": "2023-05-05T00:08:19.490858",
          "usd_value": 13291119.776610639
        },
        {
          "organization_id": "01091ef6-e165-4104-8228-ceb07e5c55e2",
          "token_address": "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 2690934024,
          "token_price": 1.00271,
          "created_at": "2023-03-20T00:08:06.267256",
          "usd_value": 2698.22645520504
        },
        {
          "organization_id": "01091ef6-e165-4104-8228-ceb07e5c55e2",
          "token_address": "arb",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 837861708667613800,
          "token_price": 1776.42,
          "created_at": "2023-03-20T00:08:06.267256",
          "usd_value": 1488.3942965113226
        },
        {
          "organization_id": "01091ef6-e165-4104-8228-ceb07e5c55e2",
          "token_address": "0x3082cc23568ea640225c2467653db90e9250aaa0",
          "token_symbol": "RDNT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RDNT.webp",
          "token_value": 5220000000000000000,
          "token_price": 0.3944240093963323,
          "created_at": "2023-05-05T00:08:19.490858",
          "usd_value": 2.0588933290488547
        },
        {
          "organization_id": "01091ef6-e165-4104-8228-ceb07e5c55e2",
          "token_address": "0x4cd44e6fcfa68bf797c65889c74b26b8c2e5d4d3",
          "token_symbol": "rWBTC",
          "token_decimals": 8,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RWBTC.webp",
          "token_value": 1,
          "token_price": 29080.5,
          "created_at": "2023-05-05T00:08:19.490858",
          "usd_value": 0.000290805
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/arbitrum.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 7569112.88
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "f664a1f5-d543-4c70-b134-029dd0e6aacc",
      "uniqueKey": "ff22e8c2-79fb-451d-bc5e-2a2fba20404f",
      "daoName": "RealToken Ecosystem Governance",
      "title": "RealToken Ecosystem Governance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/f664a1f5-d543-4c70-b134-029dd0e6aacc.webp",
      "totalNumMembers": null,
      "totalNumProposals": null,
      "totalNumVotes": null,
      "activeMembers": 0,
      "totalValueUSD": 7511858,
      "change24hPercentage": 0,
      "change1WeekPercentage": -0.26994133,
      "mainTreasuryAddress": "0x0212b941cb5c80c9fcda00035d126ac067169e72",
      "mainTreasuryTitle": "Gnosis Chain (formerly xDai)",
      "mainTreasuryAum": 32356.299,
      "tokens": [
        {
          "organization_id": "f664a1f5-d543-4c70-b134-029dd0e6aacc",
          "token_address": "0x0aa1e96d2a46ec6beb2923de1e61addf5f5f1dce",
          "token_symbol": "REG",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/REG.webp",
          "token_value": 5.023957020099183e+25,
          "token_price": 0.14664941101782827,
          "created_at": "2025-11-24T02:16:33.98533",
          "usd_value": 7367603.379764289
        },
        {
          "organization_id": "f664a1f5-d543-4c70-b134-029dd0e6aacc",
          "token_address": "0x960e61f5c4107d71bd8936b010416738c250f91c",
          "token_symbol": "REALTOKEN-S-16851-16881-GREENFIELD-RD-DETROIT-MI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/REALTOKEN-S-16851-16881-GREENFIELD-RD-DETROIT-MI.webp",
          "token_value": 1.2587409901770718e+22,
          "token_price": 50.85,
          "created_at": "2025-11-24T02:16:33.98533",
          "usd_value": 640069.793505041
        },
        {
          "organization_id": "f664a1f5-d543-4c70-b134-029dd0e6aacc",
          "token_address": "0x3839ab8550a64940964e0ecb02ed301005a96ffc",
          "token_symbol": "REALTOKEN-S-18980-FENTON-ST-DETROIT-MI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/REALTOKEN-S-18980-FENTON-ST-DETROIT-MI.webp",
          "token_value": 1.128778635505715e+22,
          "token_price": 50.25,
          "created_at": "2025-11-24T02:16:33.98533",
          "usd_value": 567211.2643416219
        },
        {
          "organization_id": "f664a1f5-d543-4c70-b134-029dd0e6aacc",
          "token_address": "0xb7c1c306bff953df8997cc8d91949b7aff36772b",
          "token_symbol": "REALTOKEN-S-1-HOLDINGS-HOLCOMB-ST-DETROIT-MI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/REALTOKEN-S-1-HOLDINGS-HOLCOMB-ST-DETROIT-MI.webp",
          "token_value": 9.516624627748775e+21,
          "token_price": 57.87,
          "created_at": "2025-11-24T02:16:33.98533",
          "usd_value": 550727.0672078216
        },
        {
          "organization_id": "f664a1f5-d543-4c70-b134-029dd0e6aacc",
          "token_address": "0xf7412e264fa85ae5e79ac3a4b64ce4669e32b98f",
          "token_symbol": "REALTOKEN-S-19000-FENTON-ST-DETROIT-MI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/REALTOKEN-S-19000-FENTON-ST-DETROIT-MI.webp",
          "token_value": 1.0549358828042983e+22,
          "token_price": 50.06,
          "created_at": "2025-11-24T02:16:33.98533",
          "usd_value": 528100.9029318318
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/gnosis.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "84f710d8-5ad0-4996-9f8a-a345d58b1b15",
          "title": "Physical Assets",
          "description": "Create, produce, manage or trade assets and any other things that are not online"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 7511857.95
        },
        "private": {
          "name": "private",
          "value": 38007951.15
        },
        "protocol": {
          "name": "protocol",
          "value": 0
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "a93c0f9f-268a-4366-b72a-0c8f234f1653",
      "uniqueKey": "fa299826-824f-407d-9a53-f3b69ebe3e99",
      "daoName": "API3",
      "title": "API3",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/a93c0f9f-268a-4366-b72a-0c8f234f1653.webp",
      "totalNumMembers": 23940,
      "totalNumProposals": 76,
      "totalNumVotes": 210,
      "activeMembers": 10,
      "totalValueUSD": 7329743,
      "change24hPercentage": 0,
      "change1WeekPercentage": -10.567098,
      "mainTreasuryAddress": "0xe7af7c5982e073ac6525a34821fe1b3e8e432099",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "a93c0f9f-268a-4366-b72a-0c8f234f1653",
          "token_address": "0x0b38210ea11411557c13457d4da7dc6ea731b88a",
          "token_symbol": "API3",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/API3.webp",
          "token_value": 7.096177936322647e+24,
          "token_price": 0.531,
          "created_at": "2025-11-24T02:04:49.900073",
          "usd_value": 3768070.484187327
        },
        {
          "organization_id": "a93c0f9f-268a-4366-b72a-0c8f234f1653",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1.2018149545821615e+21,
          "token_price": 2834.52,
          "created_at": "2025-11-24T02:04:49.900073",
          "usd_value": 3406568.525062228
        },
        {
          "organization_id": "a93c0f9f-268a-4366-b72a-0c8f234f1653",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 125827803125,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:04:49.900073",
          "usd_value": 125865.56279383815
        },
        {
          "organization_id": "a93c0f9f-268a-4366-b72a-0c8f234f1653",
          "token_address": "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
          "token_symbol": "PNK",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PNK.webp",
          "token_value": 1.547987e+24,
          "token_price": 0.015117865984125229,
          "created_at": "2025-11-24T02:04:49.900073",
          "usd_value": 23402.26001116806
        },
        {
          "organization_id": "a93c0f9f-268a-4366-b72a-0c8f234f1653",
          "token_address": "0x67f4c72a50f8df6487720261e188f2abe83f57d7",
          "token_symbol": "wPOKT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WPOKT.webp",
          "token_value": 249999990000,
          "token_price": 0.014255341151596861,
          "created_at": "2025-11-24T02:04:49.900073",
          "usd_value": 3563.8351453458035
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 7329743.09
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "0c06f49b-0655-4858-9e18-b5cfa1447059",
      "uniqueKey": "c129fed1-9704-42e1-bba8-abdfc2bdffc1",
      "daoName": "GMX",
      "title": "GMX",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/0c06f49b-0655-4858-9e18-b5cfa1447059.webp",
      "totalNumMembers": 275132,
      "totalNumProposals": 67,
      "totalNumVotes": 296129,
      "activeMembers": 87301,
      "totalValueUSD": 7062341,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x6d42daf7c26aa3780178b80faa893b9b6d4ccb85",
      "mainTreasuryTitle": "Arbitrum",
      "mainTreasuryAum": 886.5154,
      "tokens": [
        {
          "organization_id": "0c06f49b-0655-4858-9e18-b5cfa1447059",
          "token_address": "0x4bae380b5d762d543d426331b8437926443ae9ec",
          "token_symbol": "XVIX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XVIX.webp",
          "token_value": 1.953124480632e+22,
          "token_price": 14.801792908798172,
          "created_at": "2025-04-07T02:37:20.688623",
          "usd_value": 289097.44087418856
        },
        {
          "organization_id": "0c06f49b-0655-4858-9e18-b5cfa1447059",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 560911269715995500,
          "token_price": 1580.41,
          "created_at": "2025-04-07T02:37:20.688623",
          "usd_value": 886.4697797718565
        },
        {
          "organization_id": "0c06f49b-0655-4858-9e18-b5cfa1447059",
          "token_address": "0x99e92123eb77bc8f999316f622e5222498438784",
          "token_symbol": "GMT",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GMT.webp",
          "token_value": 146744955010000000000,
          "token_price": 0.3894365542507692,
          "created_at": "2025-04-07T02:37:20.688623",
          "usd_value": 57.14784963277854
        },
        {
          "organization_id": "0c06f49b-0655-4858-9e18-b5cfa1447059",
          "token_address": "0x07d15798a67253d76cea61f0ea6f57aedc59dffb",
          "token_symbol": "BASED",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BASED.webp",
          "token_value": 3.444e+21,
          "token_price": 0.00000821963752187506,
          "created_at": "2025-04-07T02:37:20.688623",
          "usd_value": 0.028308431625337707
        },
        {
          "organization_id": "0c06f49b-0655-4858-9e18-b5cfa1447059",
          "token_address": "0x5b52bfb8062ce664d74bbcd4cd6dc7df53fd7233",
          "token_symbol": "ZENIQ",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ZENIQ.webp",
          "token_value": 3198153320000000000,
          "token_price": 0.005400563170310035,
          "created_at": "2025-04-07T02:37:20.688623",
          "usd_value": 0.017271829032996764
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/arbitrum.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 7062340.81
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "5ddfcb77-c402-4685-9374-9daea63f2823",
      "uniqueKey": "722a6169-c3d0-4cff-a27e-f31fdb291e7e",
      "daoName": "Thales Markets",
      "title": "Thales Markets",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/5ddfcb77-c402-4685-9374-9daea63f2823.webp",
      "totalNumMembers": 7,
      "totalNumProposals": 245,
      "totalNumVotes": 3135,
      "activeMembers": 960,
      "totalValueUSD": 6972473.5,
      "change24hPercentage": 0,
      "change1WeekPercentage": -7.0007706,
      "mainTreasuryAddress": "0x4aad282dac74d79e41fd12833b1fad7a18c778ed",
      "mainTreasuryTitle": "Polygon",
      "mainTreasuryAum": 0.0016302986,
      "tokens": [
        {
          "organization_id": "5ddfcb77-c402-4685-9374-9daea63f2823",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 1039069437245,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:16:23.083905",
          "usd_value": 1039277.2927035406
        },
        {
          "organization_id": "5ddfcb77-c402-4685-9374-9daea63f2823",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 256638219125636170000,
          "token_price": 2860.02,
          "created_at": "2025-11-24T02:16:23.083905",
          "usd_value": 734146.6425775258
        },
        {
          "organization_id": "5ddfcb77-c402-4685-9374-9daea63f2823",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 575441125096,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:16:23.083905",
          "usd_value": 575343.3001047337
        },
        {
          "organization_id": "5ddfcb77-c402-4685-9374-9daea63f2823",
          "token_address": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 216911004128,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:16:23.083905",
          "usd_value": 216954.39500700138
        },
        {
          "organization_id": "5ddfcb77-c402-4685-9374-9daea63f2823",
          "token_address": "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 141774084373,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:16:23.083905",
          "usd_value": 141749.9827786566
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/polygon.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6972473.64
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "f8fe9f76-46dd-4dcd-bbb6-db5e737c50b8",
      "uniqueKey": "06e7da61-3550-4d17-a08b-d6b2ddbae27a",
      "daoName": "Silo Finance",
      "title": "Silo Finance",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/bz0cfjtN_400x400.png",
      "totalNumMembers": 2904,
      "totalNumProposals": 109,
      "totalNumVotes": 1230,
      "activeMembers": 479,
      "totalValueUSD": 6957128,
      "change24hPercentage": 0,
      "change1WeekPercentage": -22.073492,
      "mainTreasuryAddress": "0xdac29737b5fb121f11ee7f17db0212f82b4ab009",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 2500500.5,
      "tokens": [
        {
          "organization_id": "f8fe9f76-46dd-4dcd-bbb6-db5e737c50b8",
          "token_address": "0xf0b2dd79324a66d2108c961d680f7616e1486bb0",
          "token_symbol": "SILO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SILO.webp",
          "token_value": 3.684757215483163e+26,
          "token_price": 0.010109577479952897,
          "created_at": "2025-11-24T02:02:42.674326",
          "usd_value": 3725133.8564742533
        },
        {
          "organization_id": "f8fe9f76-46dd-4dcd-bbb6-db5e737c50b8",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 2810467204942,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:02:42.674326",
          "usd_value": 2811029.4108241647
        },
        {
          "organization_id": "f8fe9f76-46dd-4dcd-bbb6-db5e737c50b8",
          "token_address": "0x09f569af991c730cae05a392bae6490558ef2214",
          "token_symbol": "SILO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SILO.webp",
          "token_value": 3.10118660093427e+24,
          "token_price": 0.010109577479952897,
          "created_at": "2025-11-24T02:02:42.674326",
          "usd_value": 31351.68622193677
        },
        {
          "organization_id": "f8fe9f76-46dd-4dcd-bbb6-db5e737c50b8",
          "token_address": "0xdd4c6fd31ccf66e250790643947675153c221a91",
          "token_symbol": "xSILO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XSILO.webp",
          "token_value": 1.29163e+24,
          "token_price": 0.01286194952625362,
          "created_at": "2025-11-24T02:02:42.674326",
          "usd_value": 16612.87986659496
        },
        {
          "organization_id": "f8fe9f76-46dd-4dcd-bbb6-db5e737c50b8",
          "token_address": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 9573734830,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:02:42.674326",
          "usd_value": 9575.649959991997
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "9137eb61-ce09-4391-aa22-f23fce0cc662",
          "title": "Art & Culture",
          "description": "Promote Web3 creators, their creations, communities & markets; lead ecosystem ideation, discourse and framing"
        },
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        },
        {
          "id": "df5e8880-9d6f-412c-adab-d61fc242e0d3",
          "title": "Greater Good / Political",
          "description": "Work to achieve public goods and other goals beyond membership boundaries and immediate interests"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6957128.13
        },
        "vesting": {
          "name": "vesting",
          "value": 0
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "f03d0cf4-2f80-4ab0-9be8-cc091fde325e",
      "uniqueKey": "db070c6e-203b-4ac5-a0eb-59f739b58c92",
      "daoName": "Alchemix",
      "title": "Alchemix",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/f03d0cf4-2f80-4ab0-9be8-cc091fde325e.webp",
      "totalNumMembers": 13570,
      "totalNumProposals": 151,
      "totalNumVotes": 13958,
      "activeMembers": 2298,
      "totalValueUSD": 6870719,
      "change24hPercentage": 0,
      "change1WeekPercentage": -17.138721,
      "mainTreasuryAddress": "0x8392f6669292fa56123f71949b52d883ae57e225",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 1179575.1,
      "tokens": [
        {
          "organization_id": "f03d0cf4-2f80-4ab0-9be8-cc091fde325e",
          "token_address": "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
          "token_symbol": "ALCX",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ALCX.webp",
          "token_value": 3.2853762463729655e+23,
          "token_price": 9.822865897021083,
          "created_at": "2025-11-24T02:27:11.815597",
          "usd_value": 3227181.028938014
        },
        {
          "organization_id": "f03d0cf4-2f80-4ab0-9be8-cc091fde325e",
          "token_address": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "token_symbol": "WETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "token_value": 115291560870097780000,
          "token_price": 2857.655,
          "created_at": "2025-11-24T02:27:11.815597",
          "usd_value": 329480.4762046172
        },
        {
          "organization_id": "f03d0cf4-2f80-4ab0-9be8-cc091fde325e",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 23406202857593350000,
          "token_price": 2857.655,
          "created_at": "2025-11-24T02:27:11.815597",
          "usd_value": 66891.8849563303
        },
        {
          "organization_id": "f03d0cf4-2f80-4ab0-9be8-cc091fde325e",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 3.1218047634421687e+22,
          "token_price": 0.9999,
          "created_at": "2025-11-24T02:27:11.815597",
          "usd_value": 31214.925829658245
        },
        {
          "organization_id": "f03d0cf4-2f80-4ab0-9be8-cc091fde325e",
          "token_address": "0xbc6da0fe9ad5f3b0d58160288917aa56653660e9",
          "token_symbol": "alUSD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ALUSD.webp",
          "token_value": 1.2366666666666667e+22,
          "token_price": 0.9892065437141278,
          "created_at": "2025-11-24T02:27:11.815597",
          "usd_value": 12233.187590598047
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6870718.79
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "26f16041-06c8-4637-8639-25d735dfb1f1",
      "uniqueKey": "00cf09ac-bb92-4af4-901d-2d411b427aff",
      "daoName": "Sarcophagus DAO",
      "title": "Sarcophagus DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/26f16041-06c8-4637-8639-25d735dfb1f1.webp",
      "totalNumMembers": 1132,
      "totalNumProposals": 115,
      "totalNumVotes": 540,
      "activeMembers": 54,
      "totalValueUSD": 6794109.5,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0xe74fc9dfc587241dad8a82ab50208355685d2b4c",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 0,
      "tokens": [
        {
          "organization_id": "26f16041-06c8-4637-8639-25d735dfb1f1",
          "token_address": "0x7697b462a7c4ff5f8b55bdbc2f4076c2af9cf51a",
          "token_symbol": "SARCO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SARCO.webp",
          "token_value": 5.392680694429841e+25,
          "token_price": 0.09350089644421895,
          "created_at": "2024-02-24T02:23:53.014642",
          "usd_value": 5042204.791666234
        },
        {
          "organization_id": "26f16041-06c8-4637-8639-25d735dfb1f1",
          "token_address": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "token_symbol": "DAI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "token_value": 1.344747442179589e+24,
          "token_price": 0.99985,
          "created_at": "2024-02-24T02:23:53.014642",
          "usd_value": 1344545.7300632622
        },
        {
          "organization_id": "26f16041-06c8-4637-8639-25d735dfb1f1",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 139007628935365000000,
          "token_price": 2920.31,
          "created_at": "2024-02-24T02:23:53.014642",
          "usd_value": 405945.36885623576
        },
        {
          "organization_id": "26f16041-06c8-4637-8639-25d735dfb1f1",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 1408780000,
          "token_price": 1,
          "created_at": "2024-02-24T02:23:53.014642",
          "usd_value": 1408.78
        },
        {
          "organization_id": "26f16041-06c8-4637-8639-25d735dfb1f1",
          "token_address": "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
          "token_symbol": "BlueSparrow",
          "token_decimals": 9,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BLUESPARROW.webp",
          "token_value": 50002928380,
          "token_price": 0.06154408425196497,
          "created_at": "2024-02-24T02:23:53.014642",
          "usd_value": 3.07738443706369
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6794109.62
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "f59505b9-d52f-4698-beee-95ff23248f70",
      "uniqueKey": "8d0a45f1-0c1e-496a-94c6-216fa6602872",
      "daoName": "Sperax DAO",
      "title": "Sperax DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/f59505b9-d52f-4698-beee-95ff23248f70.webp",
      "totalNumMembers": 247057,
      "totalNumProposals": 73,
      "totalNumVotes": 209263,
      "activeMembers": 21528,
      "totalValueUSD": 6750092.5,
      "change24hPercentage": 0,
      "change1WeekPercentage": -12.22354,
      "mainTreasuryAddress": "0xba6ca0b9e7333f5e667816b85704c024ab250c9d",
      "mainTreasuryTitle": "Arbitrum",
      "mainTreasuryAum": 6750000,
      "tokens": [
        {
          "organization_id": "f59505b9-d52f-4698-beee-95ff23248f70",
          "token_address": "0x5575552988a3a80504bbaeb1311674fcfd40ad4b",
          "token_symbol": "SPA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SPA.webp",
          "token_value": 1.6920517880596098e+27,
          "token_price": 0.0054,
          "created_at": "2025-11-24T02:45:47.565022",
          "usd_value": 9137079.655521892
        },
        {
          "organization_id": "f59505b9-d52f-4698-beee-95ff23248f70",
          "token_address": "0xd74f5255d557944cf7dd0e45ff521520002d5748",
          "token_symbol": "USDs",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDS.webp",
          "token_value": 3.6972854212823394e+23,
          "token_price": 0.9987199095784299,
          "created_at": "2025-11-24T02:45:47.565022",
          "usd_value": 369255.2561628745
        },
        {
          "organization_id": "f59505b9-d52f-4698-beee-95ff23248f70",
          "token_address": "0xb4a3b0faf0ab53df58001804dda5bfc6a3d59008",
          "token_symbol": "SPA",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SPA.webp",
          "token_value": 9.174101749126679e+24,
          "token_price": 0.0054,
          "created_at": "2025-11-24T02:45:47.565022",
          "usd_value": 49540.14944528406
        },
        {
          "organization_id": "f59505b9-d52f-4698-beee-95ff23248f70",
          "token_address": "0x3d9907f9a368ad0a51be60f7da3b97cf940982d8",
          "token_symbol": "GRAIL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GRAIL.webp",
          "token_value": 6295709890456989000,
          "token_price": 190.6439259644702,
          "created_at": "2025-11-24T02:45:47.565022",
          "usd_value": 1200.238850250065
        },
        {
          "organization_id": "f59505b9-d52f-4698-beee-95ff23248f70",
          "token_address": "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
          "token_symbol": "USD₮0",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USD₮0.webp",
          "token_value": 655970749,
          "token_price": 0.99973,
          "created_at": "2025-11-24T02:45:47.565022",
          "usd_value": 655.7936368977699
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/arbitrum.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        },
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6750092.69
        },
        "project": {
          "name": "project",
          "value": 539806.27
        },
        "protocol": {
          "name": "protocol",
          "value": 2432853.54
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "41832c47-f998-4592-b7b9-7624a8a9a4dd",
      "uniqueKey": "ed74e94f-c39b-48aa-a15f-a7118f2bedd4",
      "daoName": "Kleros",
      "title": "Kleros",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/41832c47-f998-4592-b7b9-7624a8a9a4dd.webp",
      "totalNumMembers": 9068,
      "totalNumProposals": 41,
      "totalNumVotes": 1103,
      "activeMembers": 388,
      "totalValueUSD": 6632289.5,
      "change24hPercentage": 0,
      "change1WeekPercentage": -10.845732,
      "mainTreasuryAddress": "0x879041adce0debb392c6334c1462b06e908057cd",
      "mainTreasuryTitle": "Mantle",
      "mainTreasuryAum": 14037.766,
      "tokens": [
        {
          "organization_id": "41832c47-f998-4592-b7b9-7624a8a9a4dd",
          "token_address": "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
          "token_symbol": "PNK",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PNK.webp",
          "token_value": 6.1178082924630886e+25,
          "token_price": 0.015249963842238945,
          "created_at": "2025-11-24T02:24:13.316679",
          "usd_value": 932963.5525381169
        },
        {
          "organization_id": "41832c47-f998-4592-b7b9-7624a8a9a4dd",
          "token_address": "0x37b60f4e9a31a64ccc0024dce7d0fd07eaa0f7b3",
          "token_symbol": "PNK",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PNK.webp",
          "token_value": 3.0177340650492356e+25,
          "token_price": 0.015029209252168448,
          "created_at": "2025-11-24T02:24:13.316679",
          "usd_value": 453541.5673102187
        },
        {
          "organization_id": "41832c47-f998-4592-b7b9-7624a8a9a4dd",
          "token_address": "0x9c58bacc331c9aa871afd802db6379a98e80cedb",
          "token_symbol": "GNO",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GNO.webp",
          "token_value": 1.1569149414430313e+21,
          "token_price": 131.43418186021395,
          "created_at": "2025-11-24T02:24:13.316679",
          "usd_value": 152058.16881042215
        },
        {
          "organization_id": "41832c47-f998-4592-b7b9-7624a8a9a4dd",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 24349458203012186000,
          "token_price": 2862.411666666667,
          "created_at": "2025-11-24T02:24:13.316679",
          "usd_value": 69686.16867113915
        },
        {
          "organization_id": "41832c47-f998-4592-b7b9-7624a8a9a4dd",
          "token_address": "0x912ce59144191c1204e64559fe8253a0e49e6548",
          "token_symbol": "ARB",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ARB.webp",
          "token_value": 1.0034970558311534e+23,
          "token_price": 0.2067,
          "created_at": "2025-11-24T02:24:13.316679",
          "usd_value": 20742.28414402994
        }
      ],
      "chainLogo": null,
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "738d3b6e-03f1-4f34-b5f4-18d9821e83e7",
          "title": "Work & Funding",
          "description": "Run a Web3 work marketplace platform, significant grant programmes, BUIDL guilds, other mass job venues"
        },
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6632289.51
        },
        "private": {
          "name": "private",
          "value": 453606.63
        },
        "project": {
          "name": "project",
          "value": 2929914.33
        },
        "protocol": {
          "name": "protocol",
          "value": 1861896.91
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "d3c0bb7a-af5b-41d6-ae48-f630ad7f7194",
      "uniqueKey": "b9e029e3-8e7a-44ee-90b2-b6ad195a23ad",
      "daoName": "ApeCoin DAO",
      "title": "ApeCoin DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d3c0bb7a-af5b-41d6-ae48-f630ad7f7194.webp",
      "totalNumMembers": 171289,
      "totalNumProposals": 354,
      "totalNumVotes": 143820,
      "activeMembers": 13652,
      "totalValueUSD": 6576234.5,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x03ca52e482912308c287d09ec941b996c18668f5",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 4224183,
      "tokens": [
        {
          "organization_id": "d3c0bb7a-af5b-41d6-ae48-f630ad7f7194",
          "token_address": "0x4d224452801aced8b2f0aebe155379bb5d594381",
          "token_symbol": "APE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VOTE.webp",
          "token_value": 1.789666821765316e+25,
          "token_price": 0.36727256518840556,
          "created_at": "2024-08-26T02:23:57.848097",
          "usd_value": 6572955.244623286
        },
        {
          "organization_id": "d3c0bb7a-af5b-41d6-ae48-f630ad7f7194",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 1200000000000000000,
          "token_price": 2730,
          "created_at": "2024-08-26T02:23:57.848097",
          "usd_value": 3276
        },
        {
          "organization_id": "d3c0bb7a-af5b-41d6-ae48-f630ad7f7194",
          "token_address": "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 611743409873631,
          "token_price": 2730,
          "created_at": "2024-08-26T02:23:57.848097",
          "usd_value": 1.6700595089550128
        },
        {
          "organization_id": "d3c0bb7a-af5b-41d6-ae48-f630ad7f7194",
          "token_address": "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
          "token_symbol": "MTV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MTV.webp",
          "token_value": 2e+21,
          "token_price": 0.0007133,
          "created_at": "2024-08-26T02:23:57.848097",
          "usd_value": 1.4266
        },
        {
          "organization_id": "d3c0bb7a-af5b-41d6-ae48-f630ad7f7194",
          "token_address": "0x07d15798a67253d76cea61f0ea6f57aedc59dffb",
          "token_symbol": "BASED",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BASED.webp",
          "token_value": 1.8444e+22,
          "token_price": 0.00000431334921142991,
          "created_at": "2024-08-26T02:23:57.848097",
          "usd_value": 0.07955541285561325
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "9137eb61-ce09-4391-aa22-f23fce0cc662",
          "title": "Art & Culture",
          "description": "Promote Web3 creators, their creations, communities & markets; lead ecosystem ideation, discourse and framing"
        },
        {
          "id": "b0ec5a90-63b7-4e1f-8a87-5e48cedfd105",
          "title": "Investments",
          "description": "Invest in crypto assets and projects via Web3, from incubation and VC to full acquisitions"
        },
        {
          "id": "1011857f-9223-480d-a67b-5b74890f1111",
          "title": "NFTs",
          "description": "Serve NFT technology, communities and markets, NFTs as a DeFi & governance instrument"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6576234.44
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "c9db5a89-025e-4cfd-9a7f-552d86add137",
      "uniqueKey": "fdba2e7c-e359-465b-bcd9-04aabb80db17",
      "daoName": "DXdao",
      "title": "DXdao",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/c9db5a89-025e-4cfd-9a7f-552d86add137.webp",
      "totalNumMembers": 1207,
      "totalNumProposals": 918,
      "totalNumVotes": 2566,
      "activeMembers": 239,
      "totalValueUSD": 6460267,
      "change24hPercentage": null,
      "change1WeekPercentage": null,
      "mainTreasuryAddress": "0x4942fbdc53b295563d59af51e6ddedceba5e332f",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 6364184,
      "tokens": [
        {
          "organization_id": "c9db5a89-025e-4cfd-9a7f-552d86add137",
          "token_address": "0xa1d65e8fb6e87b60feccbc582f7f97804b725521",
          "token_symbol": "DXD",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DXD.webp",
          "token_value": 2.031801228889071e+22,
          "token_price": 313.22679642132965,
          "created_at": "2024-05-23T02:00:59.416484",
          "usd_value": 6364145.898898444
        },
        {
          "organization_id": "c9db5a89-025e-4cfd-9a7f-552d86add137",
          "token_address": "0x177127622c4a00f3d409b75571e12cb3c8973d3c",
          "token_symbol": "COW",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VCOW.webp",
          "token_value": 2e+23,
          "token_price": 0.2809487033344424,
          "created_at": "2024-05-23T02:00:59.416484",
          "usd_value": 56189.74066688847
        },
        {
          "organization_id": "c9db5a89-025e-4cfd-9a7f-552d86add137",
          "token_address": "arb",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 7162522689125405000,
          "token_price": 3759.7,
          "created_at": "2024-05-23T02:00:59.416484",
          "usd_value": 26928.936554304782
        },
        {
          "organization_id": "c9db5a89-025e-4cfd-9a7f-552d86add137",
          "token_address": "0xde903e2712288a1da82942dddf2c20529565ac30",
          "token_symbol": "SWPR",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SWPR.webp",
          "token_value": 1e+24,
          "token_price": 0.007935969776698982,
          "created_at": "2024-05-23T02:00:59.416484",
          "usd_value": 7935.969776698982
        },
        {
          "organization_id": "c9db5a89-025e-4cfd-9a7f-552d86add137",
          "token_address": "xdai",
          "token_symbol": "xDai",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XDAI.webp",
          "token_value": 5e+21,
          "token_price": 0.99985,
          "created_at": "2024-05-23T02:00:59.416484",
          "usd_value": 4999.25
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "3b36a92c-1b3a-4ab4-9bcf-b54e00240529",
          "title": "DAO Tool",
          "description": "Supply needed DAO services such as governance infrastructure, accounting, payments, identity, token-minting"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6460266.82
        },
        "vesting": {
          "name": "vesting",
          "value": 0
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "cb6e31d5-976f-4fdd-bac6-c4edcd1b0a59",
      "uniqueKey": "8d234360-f8ae-41b9-a62c-35dc249b55c6",
      "daoName": "Goldfinch DAO",
      "title": "Goldfinch DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/dao/logo/1689773986249GoldfinchDAO",
      "totalNumMembers": 14946,
      "totalNumProposals": 92,
      "totalNumVotes": 3509,
      "activeMembers": 489,
      "totalValueUSD": 6231835,
      "change24hPercentage": 0,
      "change1WeekPercentage": -9.596936,
      "mainTreasuryAddress": "0x6bdb7d781936da8df50187b221045db9ce79e4dc",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 912.2474,
      "tokens": [
        {
          "organization_id": "cb6e31d5-976f-4fdd-bac6-c4edcd1b0a59",
          "token_address": "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
          "token_symbol": "GFI",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GFI.webp",
          "token_value": 1.9042801302351476e+25,
          "token_price": 0.2694,
          "created_at": "2025-11-24T02:08:48.404789",
          "usd_value": 5130130.670853487
        },
        {
          "organization_id": "cb6e31d5-976f-4fdd-bac6-c4edcd1b0a59",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 495865230101,
          "token_price": 1.000300090027008,
          "created_at": "2025-11-24T02:08:48.404789",
          "usd_value": 496014.03431129333
        },
        {
          "organization_id": "cb6e31d5-976f-4fdd-bac6-c4edcd1b0a59",
          "token_address": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "token_symbol": "SYND",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "token_value": 2e+23,
          "token_price": 0.108253,
          "created_at": "2025-11-24T02:08:48.404789",
          "usd_value": 21650.6
        },
        {
          "organization_id": "cb6e31d5-976f-4fdd-bac6-c4edcd1b0a59",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 257008108075508800,
          "token_price": 2848.57,
          "created_at": "2025-11-24T02:08:48.404789",
          "usd_value": 732.1055864206521
        },
        {
          "organization_id": "cb6e31d5-976f-4fdd-bac6-c4edcd1b0a59",
          "token_address": "0x5afe3855358e112b5647b952709e6165e1c1eeee",
          "token_symbol": "SAFE",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "token_value": 4.735779139554418e+21,
          "token_price": 0.1513,
          "created_at": "2025-11-24T02:08:48.404789",
          "usd_value": 716.5233838145833
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "84f710d8-5ad0-4996-9f8a-a345d58b1b15",
          "title": "Physical Assets",
          "description": "Create, produce, manage or trade assets and any other things that are not online"
        },
        {
          "id": "6b5e506e-22f1-4bdc-bbbb-5f286566ce96",
          "title": "DeFi",
          "description": "Run Web3 potocols, assets or tools for decentralized non-custodial trading"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6231835.16
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    },
    {
      "organizationId": "2f139393-59f2-4d5f-a18b-fb7d5322a1d8",
      "uniqueKey": "241d0a77-30af-449e-9b60-f0507c25411a",
      "daoName": "Gelato DAO",
      "title": "Gelato DAO",
      "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/2f139393-59f2-4d5f-a18b-fb7d5322a1d8.webp",
      "totalNumMembers": 3773,
      "totalNumProposals": 10,
      "totalNumVotes": 424,
      "activeMembers": 263,
      "totalValueUSD": 6217678.5,
      "change24hPercentage": 0,
      "change1WeekPercentage": -10.683517,
      "mainTreasuryAddress": "0x163407fda1a93941358c1bfda39a868599553b6d",
      "mainTreasuryTitle": "Ethereum",
      "mainTreasuryAum": 3116929.5,
      "tokens": [
        {
          "organization_id": "2f139393-59f2-4d5f-a18b-fb7d5322a1d8",
          "token_address": "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
          "token_symbol": "GEL",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GEL.webp",
          "token_value": 1.477906045097147e+26,
          "token_price": 0.022156551559013683,
          "created_at": "2025-11-24T02:25:34.445359",
          "usd_value": 3274517.931289295
        },
        {
          "organization_id": "2f139393-59f2-4d5f-a18b-fb7d5322a1d8",
          "token_address": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "token_symbol": "USDC",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "token_value": 502925594496,
          "token_price": 1.0002000400080016,
          "created_at": "2025-11-24T02:25:34.445359",
          "usd_value": 503026.1997359471
        },
        {
          "organization_id": "2f139393-59f2-4d5f-a18b-fb7d5322a1d8",
          "token_address": "0xdac17f958d2ee523a2206206994597c13d831ec7",
          "token_symbol": "USDT",
          "token_decimals": 6,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "token_value": 201399684222,
          "token_price": 0.99983,
          "created_at": "2025-11-24T02:25:34.445359",
          "usd_value": 201365.44627568228
        },
        {
          "organization_id": "2f139393-59f2-4d5f-a18b-fb7d5322a1d8",
          "token_address": "eth",
          "token_symbol": "ETH",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "token_value": 18035477760012000,
          "token_price": 2861.73,
          "created_at": "2025-11-24T02:25:34.445359",
          "usd_value": 51.612667770159135
        },
        {
          "organization_id": "2f139393-59f2-4d5f-a18b-fb7d5322a1d8",
          "token_address": "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
          "token_symbol": "MTV",
          "token_decimals": 18,
          "token_icon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MTV.webp",
          "token_value": 1e+21,
          "token_price": 0.0003098,
          "created_at": "2025-11-24T02:25:34.445359",
          "usd_value": 0.3098
        }
      ],
      "chainLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/assets/chain/eth.webp",
      "createdAt": "2025-11-25T03:30:01.159Z",
      "categories": [
        {
          "id": "cd1983ac-f339-4e66-9278-6e05a682b6d5",
          "title": "Infrastructure",
          "description": "Develop and run supporting technology for Web3, such as blockchains, APIs, wallets, primitives"
        }
      ],
      "aum": {
        "liquid": {
          "name": "liquid",
          "value": 6217678.46
        }
      },
      "isPremium": true,
      "isDefaultPremium": false
    }
  ],
  "createdAt": "2025-11-25T03:30:01.159Z"
};